// src/components/MapCenterModal.jsx
import React, { useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import {
    FaFilter,
    FaInfoCircle,
    FaList,
    FaThLarge,
    FaCompress,
    FaExpand,
    FaSearch,
    FaTruck,
    FaMobileAlt,
    FaIdCard,
    FaMapMarkerAlt,
    FaTachometerAlt,
    FaChevronRight,
    FaExclamationTriangle,
    FaVideo,
    FaEllipsisV,
    FaTag,
    FaLayerGroup,
    FaEyeSlash,
} from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { SiGraphql, SiRoamresearch } from "react-icons/si";
import { TbRouteOff } from "react-icons/tb";
import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Button,
    Input,
    Card,
    CardBody,
    Spinner,
} from "reactstrap";
import "./../../Pages/Css/mapCenterStyles.css";
import "boxicons/css/boxicons.min.css";
import Swal from "sweetalert2";
import FilterBodyOffcanvas from "../filtersTrafico/filterBodyOffcanvas";
import BaseModalXXL from "./baseModalXXL";
import BaseModalAuto2 from "./BaseModalAuto2";
import ReporteContrato from "../../Modulos/ReporteContrato";
import ModalMultimediaHub, { multimediaHubTabs } from "./menuContratos/modalMultimediaHub";
import InfoWindowContent from "../windowContent/InfoWindowContent";
import EnVivoPanel from "../enVivo/EnVivoPanel";
import LiveFloatingPanel from "../enVivo/LiveFloatingPanel";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { renderToStaticMarkup } from "react-dom/server";
import ModalReporteServicio from "./modalReporteServicio";
import ReporteServicio from "../../Modulos/Reporteservicio";
import ModalBaseLg from "./modal-base-lg";
import ModalComprobanteValitronics from "./menuContratos/modalComprobanteValitronics";
import axios from "../../utils/axiosConfig";
import BaseModalAuto from "./baseModalAuto";
import PrintComponent from "../printComponent/PrintComponent";
import RSeguimientoServicio from "./modalRSeguimientoServicio";
import FormReporteServicio from "../formsSolicitudes/formReporteServicio";
import { HtmlMarker } from "../../utils/HtmlMarker";
import { Rnd } from "react-rnd";
import FilteredBodyGeocercas from "../mapCenter/filteredBodyGeocercas";
import FilteredBodyGeorutas from "../mapCenter/filteredBodyGeorutas";
import FilteredBodyInviasCountries from "../mapCenter/FilteredBodyInviasCountries";
import GeocercasTrayectoOffcanvas from "../geocercas/GeocercasTrayectoOffcanvas";
import { formattedGlobalDate } from "../../utils/formattedDates";
import SwitchButton3 from "../../componentes/SwitchButton3";
import { TiCancel } from 'react-icons/ti';
import Joyride from 'react-joyride';
import { toast } from "react-hot-toast";
import { getGeocercaColors } from "../../utils/geocercaColors";
import { registerOpenStreetMap } from "../../utils/openStreetMapType";

const getCompanyFilterCandidates = (item) =>
    [
        item?.NombreEmpresa,
        item?.EmpresaConsulta1,
        item?.EmpresaConsulta2,
        item?.EmpresaConsulta3,
    ]
        .map((value) => String(value ?? "").trim())
        .filter((value) => value.length > 0 && value.toLowerCase() !== "null");

const isUnsecuredContrato = (contrato) =>
    String(contrato?.IconSeguro || "").toLowerCase().includes("unsecured");

const ICON_CATEGORIES = [
    {
        key: "lock",
        file: (c) => ((c.IconLocked || "").split("/").pop() || "candado.png"),
        isActive: () => true,
    },
    {
        key: "desvio",
        file: (c) => {
            const raw = (c.IconDesvio || "").split("/").pop()?.toLowerCase() || "";
            if (!raw || raw.includes("transparent")) return "desvio.gif";
            return raw;
        },
        isActive: (c) => {
            const raw = (c.IconDesvio || "").split("/").pop()?.toLowerCase() || "";
            return Boolean(raw) && !raw.includes("transparent");
        },
    },
    {
        key: "timeexchange",
        file: () => "timer-regular-24.png",
        isActive: (c) => {
            return getElapsedMinutesFromUtc(c.LoksysServerTime) >= 30;
        },
    },
    { key: "nogps", file: () => "NoGPS.png", isActive: (c) => c.bitGPS === true },
    {
        key: "seguro",
        file: (c) => {
            const ico = (c.IconSeguro || "").toLowerCase();
            if (ico.includes("secured")) return "secured.png";
            if (ico.includes("unsecured")) return "unsecured.png";
            return "secured.png";
        },
        isActive: (c) => {
            const ico = (c.IconSeguro || "").toLowerCase();
            return ico.includes("secured") || ico.includes("unsecured");
        },
    },
    { key: "back", file: () => "back.png", isActive: (c) => (c.IconBack || "").includes("back") },
    {
        key: "battery",
        file: (c) => ((c.icon_bat || "").split("/").pop() || "batt-med1.png"),
        isActive: (c) => !(c.icon_bat || "").toLowerCase().includes("transparent"),
    },
    { key: "stop", file: () => "stop.png", isActive: (c) => (c.IconMoving || "").includes("stop") },
    { key: "moving", file: () => "moving.png", isActive: (c) => (c.IconMoving || "").includes("moving") },
];

const INVIAS_WARNING_ICON_HTML = renderToStaticMarkup(
    <FaExclamationTriangle size={10} color="#ffffff" />
);
const INVIAS_CANCEL_ICON_HTML = renderToStaticMarkup(
    <TiCancel size={12} color="#ffffff" />
);
const ACTIVE_STREAMS_STORAGE_KEY = "active_streams_v1";
const MARKER_LABEL_FIELDS_STORAGE_KEY = "mapcenter-marker-label-fields";
const MARKER_LABEL_FIELD_OPTIONS = [
    { key: "company", label: "Empresa", field: "NombreEmpresa" },
    { key: "plate", label: "Placa", field: "PlacaTruck" },
    { key: "device", label: "Dispositivo", field: "FKLokDeviceID" },
    { key: "ref", label: "Ref", field: "Ref" },
    { key: "driver", label: "NombreConductor", field: "NombreConductor" },
    { key: "container", label: "Contenedor", field: "ContainerNum" },
    { key: "time", label: "Tiempo", field: "Tiempo" },
];

const readStoredMarkerLabelFields = () => {
    try {
        const storedFields = JSON.parse(localStorage.getItem(MARKER_LABEL_FIELDS_STORAGE_KEY));
        const allowedFields = new Set(MARKER_LABEL_FIELD_OPTIONS.map((option) => option.key));
        const validFields = Array.isArray(storedFields)
            ? [...new Set(storedFields.filter((field) => allowedFields.has(field)))].slice(0, 3)
            : [];
        return validFields.length > 0 ? validFields : ["plate"];
    } catch (error) {
        return ["plate"];
    }
};
const getGeoCategoryBadgeColors = (categoryColor) => {
    const rawColor = String(categoryColor || "").trim();
    const validHex = /^#[0-9a-f]{6}$/i.test(rawColor)
        ? rawColor.toUpperCase()
        : /^#[0-9a-f]{3}$/i.test(rawColor)
            ? `#${[...rawColor.slice(1)].map((character) => character.repeat(2)).join("")}`.toUpperCase()
            : null;

    if (!validHex) {
        return {
            background: "#E8EEF4",
            border: "#CBD8E3",
            color: "#31546F",
        };
    }

    const red = parseInt(validHex.slice(1, 3), 16);
    const green = parseInt(validHex.slice(3, 5), 16);
    const blue = parseInt(validHex.slice(5, 7), 16);
    const luminance = (0.299 * red) + (0.587 * green) + (0.114 * blue);

    return {
        background: validHex,
        border: validHex,
        color: luminance > 165 ? "#16324A" : "#FFFFFF",
    };
};

const normalizeGeocercaActive = (value) => {
    if (value == null || value === "") return true;
    if (typeof value === "boolean") return value;
    return !["0", "false", "inactive", "inactivo"].includes(String(value).trim().toLowerCase());
};

const normalizeGeocercaCode = (value) => {
    const normalizedValue = String(value ?? "").trim();
    return /^\d+$/.test(normalizedValue) ? String(Number.parseInt(normalizedValue, 10)) : "";
};

const parseGeocercaCenter = (geocerca) => {
    const rawVertices = geocerca?.Vertices ?? geocerca?.vertices;
    const points = String(rawVertices || "")
        .split("/")
        .map((point) => point.replace(/[()]/g, "").trim())
        .filter(Boolean)
        .map((point) => {
            const [lat, lng] = point.split(",").map(Number);
            return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
        })
        .filter(Boolean);

    if (!points.length) return null;

    const { latSum, lngSum } = points.reduce(
        (accumulator, point) => ({
            latSum: accumulator.latSum + point.lat,
            lngSum: accumulator.lngSum + point.lng,
        }),
        { latSum: 0, lngSum: 0 }
    );

    return {
        lat: latSum / points.length,
        lng: lngSum / points.length,
    };
};

const getGeocercaPointName = (point) =>
    point?.name ??
    point?.Nombre ??
    point?.nombre ??
    point?.Descripcion ??
    point?.description ??
    "";

const normalizeTrayectoPoint = (point) => {
    if (!point) return null;

    const id = String(point?.id ?? "").trim();
    const name = String(getGeocercaPointName(point) || "").trim();
    const lat = Number(point?.lat);
    const lng = Number(point?.lng);

    return {
        id,
        name,
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
    };
};

const areTrayectoPointsEqual = (left, right) => {
    const normalizedLeft = normalizeTrayectoPoint(left);
    const normalizedRight = normalizeTrayectoPoint(right);

    if (!normalizedLeft && !normalizedRight) return true;
    if (!normalizedLeft || !normalizedRight) return false;

    return (
        normalizedLeft.id === normalizedRight.id &&
        normalizedLeft.name === normalizedRight.name &&
        normalizedLeft.lat === normalizedRight.lat &&
        normalizedLeft.lng === normalizedRight.lng
    );
};

const extractTrayectoPointFromGeoruta = (georuta, type) => {
    const isStart = type === "start";
    const idCandidates = isStart
        ? [
            georuta?.GeoOrigen,
            georuta?.GeocercaInicioID,
            georuta?.GeocercaInicioId,
            georuta?.GeocercaInicio,
            georuta?.PuntoInicialID,
            georuta?.PuntoInicialId,
            georuta?.InicioGeocercaID,
            georuta?.InicioGeocercaId,
        ]
        : [
            georuta?.GeoDestino,
            georuta?.GeocercaFinalID,
            georuta?.GeocercaFinalId,
            georuta?.GeocercaFinal,
            georuta?.PuntoFinalID,
            georuta?.PuntoFinalId,
            georuta?.FinalGeocercaID,
            georuta?.FinalGeocercaId,
        ];
    const nameCandidates = isStart
        ? [
            georuta?.NombreGeocercaInicio,
            georuta?.GeocercaInicioNombre,
            georuta?.PuntoInicialNombre,
            georuta?.InicioGeocercaNombre,
        ]
        : [
            georuta?.NombreGeocercaFinal,
            georuta?.GeocercaFinalNombre,
            georuta?.PuntoFinalNombre,
            georuta?.FinalGeocercaNombre,
        ];
    const latCandidates = isStart
        ? [georuta?.LatitudInicial, georuta?.LatInicial, georuta?.PuntoInicialLat, georuta?.InicioLat]
        : [georuta?.LatitudFinal, georuta?.LatFinal, georuta?.PuntoFinalLat, georuta?.FinalLat];
    const lngCandidates = isStart
        ? [georuta?.LongitudInicial, georuta?.LngInicial, georuta?.LonInicial, georuta?.PuntoInicialLng, georuta?.InicioLng]
        : [georuta?.LongitudFinal, georuta?.LngFinal, georuta?.LonFinal, georuta?.PuntoFinalLng, georuta?.FinalLng];

    const id = idCandidates.find((value) => value != null && String(value).trim() !== "");
    const name = nameCandidates.find((value) => value != null && String(value).trim() !== "");
    const latRaw = latCandidates.find((value) => value != null && String(value).trim?.() !== "");
    const lngRaw = lngCandidates.find((value) => value != null && String(value).trim?.() !== "");
    const lat = Number(latRaw);
    const lng = Number(lngRaw);

    if (id == null && name == null && !Number.isFinite(lat) && !Number.isFinite(lng)) {
        return null;
    }

    return normalizeTrayectoPoint({
        id: id ?? "",
        name: name ?? "",
        lat,
        lng,
    });
};

const openTrayectoUpdateLoader = () => {
    Swal.fire({
        title: "Actualizando georuta",
        html: `
            <div style="display:grid; gap:12px; text-align:left;">
                <div id="trayecto-update-status" style="font-weight:700; color:#16324a;">
                    Preparando actualizacion...
                </div>
                <div style="display:grid; gap:6px;">
                    <div style="height:10px; border-radius:999px; overflow:hidden; background:rgba(15,76,129,0.12);">
                        <div id="trayecto-update-progress-bar" style="height:100%; width:0%; background:linear-gradient(90deg, #0f4c81 0%, #1d8bc9 100%); transition:width .25s ease;"></div>
                    </div>
                    <div id="trayecto-update-progress-label" style="font-size:13px; color:#5b7083; text-align:right;">
                        0%
                    </div>
                </div>
            </div>
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
};

const escapeTooltipHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const updateTrayectoUpdateLoader = (status, progress) => {
    const htmlContainer = Swal.getHtmlContainer();
    const statusNode = htmlContainer?.querySelector("#trayecto-update-status");
    const progressBarNode = htmlContainer?.querySelector("#trayecto-update-progress-bar");
    const progressLabelNode = htmlContainer?.querySelector("#trayecto-update-progress-label");
    const normalizedProgress = Math.max(0, Math.min(100, Number(progress) || 0));

    if (statusNode) {
        statusNode.textContent = status;
    }

    if (progressBarNode) {
        progressBarNode.style.width = `${normalizedProgress}%`;
    }

    if (progressLabelNode) {
        progressLabelNode.textContent = `${Math.round(normalizedProgress)}%`;
    }
};

const getUtcMs = (value) => {
    if (!value) return NaN;
    const raw = String(value).trim();
    if (!raw) return NaN;

    const plainMatch = raw.match(
        /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
    );
    if (plainMatch) {
        const [, y, mo, d, h, mi, s = "00"] = plainMatch;
        return Date.UTC(
            Number(y),
            Number(mo) - 1,
            Number(d),
            Number(h),
            Number(mi),
            Number(s)
        );
    }

    const parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? NaN : parsed;
};

const getElapsedMinutesFromUtc = (utcValue) => {
    const utcMs = getUtcMs(utcValue);
    if (!Number.isFinite(utcMs)) return Number.POSITIVE_INFINITY;
    return (Date.now() - utcMs) / (1000 * 60);
};

function IconGrid({ contrato, changedIcons }) {
    const changedFiles = new Set(
        (changedIcons || [])
            .map((key) => contrato?.[key])
            .filter(Boolean)
            .map((url) => String(url).split("/").pop())
    );

    return (
        <div className="icon-grid">
            {ICON_CATEGORIES.map((cat) => {
                const file = typeof cat.file === "function" ? cat.file(contrato) : cat.file;
                const isActive = cat.isActive(contrato);
                const isChanged = changedFiles.has(file);

                return (
                    <img
                        key={cat.key}
                        src={`/images/${file}`}
                        alt={cat.key}
                        title={cat.key}
                        className={["icon-item", isActive ? "active" : "", isChanged ? "icon-changed" : ""].join(" ").trim()}
                    />
                );
            })}
        </div>
    );
}



const TOUR_STEP_INDEX = {
    map: 0,
    search: 1,
    leftPanel: 2,
    advancedButton: 3,
    advancedPanel: 4,
    geocercasButton: 5,
    geocercasPanel: 6,
    georutasButton: 7,
    georutasPanel: 8,
    inviasButton: 9,
    inviasPanel: 10,
    fastFilters: 11,
    fastFiltersPanel: 12,
    devicesViewButton: 13,
    devicesList: 14,
};

const OFFCANVAS_FLOW = {
    advanced: { button: TOUR_STEP_INDEX.advancedButton, panel: TOUR_STEP_INDEX.advancedPanel },
    geocercas: { button: TOUR_STEP_INDEX.geocercasButton, panel: TOUR_STEP_INDEX.geocercasPanel },
    georutas: { button: TOUR_STEP_INDEX.georutasButton, panel: TOUR_STEP_INDEX.georutasPanel },
    invias: { button: TOUR_STEP_INDEX.inviasButton, panel: TOUR_STEP_INDEX.inviasPanel },
};

const MapCenterModal = React.forwardRef((props, ref) => {
    const appName = props?.appName || "MAP CENTER";
    const initialOpenPanel = props?.initialOpenPanel || null;
    const appMode = props?.appMode || "full";
    const isGeocercasOnly = appMode === "geocercas-only";
    const mapRef = useRef(null);
    const mapContainerRef = useRef(null);
    const mapCenterRootRef = useRef(null);
    const placeSearchInputRef = useRef(null);
    const placeAutocompleteRef = useRef(null);
    const placeSearchMarkerRef = useRef(null);
    const geoFetchRequestRef = useRef(0);
    const initialPanelSeededRef = useRef(false);

    const infoWindowRef = useRef(null);
    const geofenceInfoWindowRef = useRef(null);
    const geofenceActionsOverlayRef = useRef(null);
    const geofenceActionsOverlayElementRef = useRef(null);
    const geofenceActionsOverlayCleanupRef = useRef(null);
    const geocercaPolygonsRef = useRef([]);
    const geocercaPulseAnimationsRef = useRef([]);
    const geocercaDecoratorLinesRef = useRef([]);
    const geoDraftPolygonRef = useRef(null);
    const geoDraftPolylineRef = useRef(null);
    const geoDraftPreviewPolylineRef = useRef(null);
    const geoDraftPointMarkersRef = useRef([]);
    const geoDraftPathListenersRef = useRef([]);
    const geoTrackpadIsDrawingRef = useRef(false);
    const geoZoomTransitionRef = useRef(null);
    const showSelectedGeorutaOnMapRef = useRef(null);

    const infoWindowMarkerRef = useRef(null);
    const selectedInfoWindowOpenRef = useRef(false);
    const activeMarkerHoverRef = useRef(null);
    const hoverCloseTimerRef = useRef(null);
    const hoverTooltipPortalRef = useRef(null);
    const hoverInteractionRef = useRef({
        markerHovered: false,
        markerFocused: false,
        tooltipHovered: false,
        tooltipFocused: false,
    });

    const polylineRef = useRef([]);
    const circleRef = useRef(null);
    const zoomListenerRef = useRef(null);

    const markersRef = useRef([]);
    const markersByIdRef = useRef({});
    const singleOverlayRef = useRef(null);
    const inviasMarkersRef = useRef([]);
    const inviasInfoWindowRef = useRef(null);

    const socketRef = useRef(null);
    const activeQuickFilterRef = useRef(null);
    const prevContratoRef = useRef(null);

    const arrowLinesRef = useRef([]);
    const trayectoLinesRef = useRef([]);

    const projectionOverlayRef = useRef(null);
    const clusterOverlaysRef = useRef([]);
    const userZoomedRef = useRef(false);

    const prevGeoViewRef = useRef(null);
    const activeGeoDraftRecordRef = useRef(null);

    const [offcanvasOpen, setOffcanvasOpen] = useState(false);
    const [offcanvasOpenGeocercas, setOffcanvasOpenGeocercas] = useState(false);
    const [offcanvasOpenGeorutas, setOffcanvasOpenGeorutas] = useState(false);
    const [offcanvasOpenGeocercasTrayecto, setOffcanvasOpenGeocercasTrayecto] = useState(false);
    const [selectedGeoruta, setSelectedGeoruta] = useState(null);
    const [trayectoGeocercaSelectedIds, setTrayectoGeocercaSelectedIds] = useState([]);
    const [trayectoGeocercaOriginalIds, setTrayectoGeocercaOriginalIds] = useState([]);
    const [trayectoNearbyDetectedIds, setTrayectoNearbyDetectedIds] = useState([]);
    const [trayectoStartPoint, setTrayectoStartPoint] = useState(null);
    const [trayectoEndPoint, setTrayectoEndPoint] = useState(null);
    const [trayectoOriginalStartPoint, setTrayectoOriginalStartPoint] = useState(null);
    const [trayectoOriginalEndPoint, setTrayectoOriginalEndPoint] = useState(null);
    const [isUpdatingTrayecto, setIsUpdatingTrayecto] = useState(false);
    const [markerLabelsOffcanvasOpen, setMarkerLabelsOffcanvasOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [menuVisible, setMenuVisible] = useState(true);
    const [savedFilters, setSavedFilters] = useState(false);
    const [newValueFilterButton, setNewValueFilterButton] = useState("");
    const [deleteNewFilterButton, setDeleteNewFilterButton] = useState("");
    const [arrayFilter, setArrayFilter] = useState([]);

    const [contracts, setContracts] = useState([]);
    const [filteredContracts, setFilteredContracts] = useState([]);
    const [search, setSearch] = useState("");
    const [liveSearch, setLiveSearch] = useState("");
    const [placeSearch, setPlaceSearch] = useState("");

    const [notificationCircle, setNotificationCircle] = useState(false);

    const [openCount, setOpenCount] = useState(0);
    const [movingCount, setMovingCount] = useState(0);
    const [stopCount, setStopCount] = useState(0);
    const [stopAlertCount, setStopAlertCount] = useState(0);
    const [desvioCount, setDesvioCount] = useState(0);
    const [lowBatteryCount, setLowBatteryCount] = useState(0);
    const [noGpsCount, setNoGpsCount] = useState(0);
    const [noRutaCount, setNoRutaCount] = useState(0);
    const [timeExchangeCount, setTimeExchangeCount] = useState(0);
    const [refuerzoCount, setRefuerzoCount] = useState(0);
    const [unsecuredCount, setUnsecuredCount] = useState(0);
    const [isStreamingActive, setIsStreamingActive] = useState(false);

    const [changedIcons, setChangedIcons] = useState([]);

    const [isMovingActive, setIsMovingActive] = useState(false);
    const [isStopActive, setIsStopActive] = useState(false);
    const [isStopAlertActive, setIsStopAlertActive] = useState(false);
    const [isDesvioAlertActive, setIsDesvioAlertActive] = useState(false);
    const [isLowBatteryActive, setIsLowBatteryActive] = useState(false);
    const [isOpenActive, setIsOpenActive] = useState(false);
    const [isTimeExchangeActive, setIsTimeExchangeActive] = useState(false);
    const [isRefuerzoActive, setIsRefuerzoActive] = useState(false);
    const [isNoGpsActive, setIsNoGpsActive] = useState(false);
    const [isNoRutaActive, setIsNoRutaActive] = useState(false);
    const [isUnsecuredActive, setIsUnsecuredActive] = useState(false);

    const [fastFilter, setFastFilter] = useState(false);
    const [fastGeocerca, setFastGeocerca] = useState(false);
    const [fastGeoruta, setFastGeoruta] = useState(false);
    const [inviasActive, setInviasActive] = useState(false);
    const [inviasOffcanvasOpen, setInviasOffcanvasOpen] = useState(false);
    const [inviasCountries, setInviasCountries] = useState(["colombia"]);
    const [inviasCountriesDraft, setInviasCountriesDraft] = useState(["colombia"]);
    const [inviasLoading, setInviasLoading] = useState(false);
    const [inviasPendingApply, setInviasPendingApply] = useState(false);
    const [showHorizontalDevices, setShowHorizontalDevices] = useState(false);
    const [showTrafficGrid, setShowTrafficGrid] = useState(false);
    const [showPlateBadges, setShowPlateBadges] = useState(
        () => localStorage.getItem("sw-placa") !== "false"
    );
    const [markerLabelFields, setMarkerLabelFields] = useState(readStoredMarkerLabelFields);
    const [markerLabelFieldsDraft, setMarkerLabelFieldsDraft] = useState(readStoredMarkerLabelFields);
    const [bottomHeight, setBottomHeight] = useState(260);
    const [isResizingBottom, setIsResizingBottom] = useState(false);
    const [isMapFullscreen, setIsMapFullscreen] = useState(false);
    const [isCustomFullscreen, setIsCustomFullscreen] = useState(false);
    const bottomResizeRef = useRef({ startY: 0, startHeight: 0 });

    const [geoFilter, setGeoFilter] = useState({ showAll: false, selectedIds: [] });
    const [georutaFilter, setGeorutaFilter] = useState({ showAll: false, selectedIds: [] });
    const [geoCrudMode, setGeoCrudMode] = useState("browse");
    const [geoDraftMode, setGeoDraftMode] = useState("points");
    const [geoDraftName, setGeoDraftName] = useState("");
    const [geoDraftDescription, setGeoDraftDescription] = useState("");
    const [geoDraftCategory, setGeoDraftCategory] = useState("1");
    const [geoDraftActive, setGeoDraftActive] = useState(true);
    const [geoCategories, setGeoCategories] = useState([]);
    const [isGeoCategoriesLoading, setIsGeoCategoriesLoading] = useState(false);
    const [geoDraftCode, setGeoDraftCode] = useState("");
    const [geoDraftCompany, setGeoDraftCompany] = useState("0");
    const [geoDraftCompanies, setGeoDraftCompanies] = useState(["0"]);
    const [geoCompanySearch, setGeoCompanySearch] = useState("");
    const [geoCompanies, setGeoCompanies] = useState([]);
    const [isGeoCompaniesLoading, setIsGeoCompaniesLoading] = useState(false);
    const [geoDraftPoints, setGeoDraftPoints] = useState([]);
    const [geoDraftHoverPoint, setGeoDraftHoverPoint] = useState(null);
    const [geoDrawTooltip, setGeoDrawTooltip] = useState(null);
    const [isGeoDraftClosed, setIsGeoDraftClosed] = useState(false);
    const [isGeoDraftRegistrationModalOpen, setIsGeoDraftRegistrationModalOpen] = useState(false);
    const [isGeoTrackpadDrawing, setIsGeoTrackpadDrawing] = useState(false);
    const [isGeoDraftSaving, setIsGeoDraftSaving] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const fetchGeoCategories = async () => {
            setIsGeoCategoriesLoading(true);

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_SERVER}/geocercas/getcategoriasgeocercas`
                );
                console.log("Categorias de geocercas obtenidas:", response.data);
                const categories = Array.isArray(response.data?.data)
                    ? response.data.data
                    : Array.isArray(response.data)
                        ? response.data
                        : [];

                if (!isMounted) return;

                setGeoCategories(categories);
                if (categories.length > 0) {
                    const firstCategoryId = categories[0]?.ID;

                    setGeoDraftCategory((currentCategory) => {
                        const categoryExists = categories.some(
                            (category) => String(category.ID) === String(currentCategory)
                        );

                        return categoryExists || firstCategoryId == null
                            ? currentCategory
                            : String(firstCategoryId);
                    });
                }
            } catch (error) {
                console.error("Error al listar categorias de geocercas:", error);
            } finally {
                if (isMounted) setIsGeoCategoriesLoading(false);
            }
        };

        fetchGeoCategories();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        let isMounted = true;

        const fetchGeoCompanies = async () => {
            setIsGeoCompaniesLoading(true);

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_SERVER}/empresas/getempresas`
                );
                const companies = Array.isArray(response.data?.data) ? response.data.data : [];

                if (isMounted) setGeoCompanies(companies);
            } catch (error) {
                console.error("Error al listar empresas para geocercas:", error);
            } finally {
                if (isMounted) setIsGeoCompaniesLoading(false);
            }
        };

        fetchGeoCompanies();

        return () => {
            isMounted = false;
        };
    }, []);


    const [modalContratoSeguimiento, setModalContratoSeguimiento] = useState(false);
    const [modalImagenes, setModalImagenes] = useState(false);
    const [modalVideos, setModalVideos] = useState(false);
    const [multimediaHubTab, setMultimediaHubTab] = useState(multimediaHubTabs.PHOTOS);
    const [modalValitronics, setModalValitronics] = useState(false);
    const [modalCheckList, setModalCheckList] = useState(false);
    const [modalMonitoreo, setModalMonitoreo] = useState(false);
    const [modalTrayecto, setModalTrayecto] = useState(false);
    const [modalConsolidado, setModalConsolidado] = useState(false);
    const [modalEnVivo, setModalEnVivo] = useState(false);
    const [liveStreamUrl, setLiveStreamUrl] = useState("");

    const [showSeguirPanel, setShowSeguirPanel] = useState(false);
    const [panelProps, setPanelProps] = useState({ x: 11, y: 60, width: 210, height: 500 });

    const [contratoSelected, setContratoSelected] = useState(null);
    const [selectedContractID, setSelectedContractID] = useState(null);
    const [rutaSelected, setRutaSelected] = useState(-1);
    const [listComprobantes, setListComprobantes] = useState([]);

    const [geocercaPolygons, setGeocercaPolygons] = useState([]);
    const [uniquesGeocerca, setUniquesGeocerca] = useState([]);
    const [listaMensajes, setListaMensajes] = useState([]);
    const [lastReport, setLastReport] = useState(null);
    const [switchValueGeo, setSwitchValueGeo] = useState(false);

    const [msgsByContrato, setMsgsByContrato] = useState({});
    const [listGeocercas, setListGeocercas] = useState([]);
    const [allGeocercasForTrayecto, setAllGeocercasForTrayecto] = useState([]);
    const [listGeorutas, setListGeorutas] = useState([]);
    const [isGeocercasLoading, setIsGeocercasLoading] = useState(false);
    const [geoListSearch, setGeoListSearch] = useState("");
    const [showAllGeocercasOnMap, setShowAllGeocercasOnMap] = useState(false);
    const [isAllGeocercasMapLoading, setIsAllGeocercasMapLoading] = useState(false);

    const [ultPunto, setUltPunto] = useState(-1);
    const [contractR, setContractR] = useState(-1);

    const [showAllGeorutas, setShowAllGeorutas] = useState(true);
    const [selectedGeorutas, setSelectedGeorutas] = useState([]);

    const [tourRun, setTourRun] = useState(false);
    const [tourStepIndex, setTourStepIndex] = useState(0);
    const [waitMode, setWaitMode] = useState(null);

    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const [mobileInfoOpen, setMobileInfoOpen] = useState(false);
    const [mobileInfoContrato, setMobileInfoContrato] = useState(null);
    const [showRefuerzosPanel, setShowRefuerzosPanel] = useState(() => localStorage.getItem("sw-refuerzos-panel") === "true");

    const handleTrayectoGeocercaSelectedIdsChange = useCallback((nextSelectedIds) => {
        setTrayectoGeocercaSelectedIds((currentSelectedIds) => {
            const resolvedSelectedIds =
                typeof nextSelectedIds === "function"
                    ? nextSelectedIds(currentSelectedIds)
                    : nextSelectedIds;

            const normalizedSelectedIds = Array.isArray(resolvedSelectedIds)
                ? resolvedSelectedIds.map(String)
                : [];
            const selectedGeocercas = allGeocercasForTrayecto.filter((geocerca) =>
                normalizedSelectedIds.includes(String(geocerca?.ID ?? geocerca?.id ?? geocerca?.Id ?? ""))
            );

            console.log("Trayecto seleccionado:", selectedGeoruta);
            console.log("ID del trayecto seleccionado:", selectedGeoruta?.IDTrayecto ?? selectedGeoruta?.IDtrayecto ?? selectedGeoruta?.IdTrayecto ?? selectedGeoruta?.id ?? selectedGeoruta?.ID ?? null);
            console.log("IDs de geocercas seleccionadas del trayecto:", normalizedSelectedIds);
            console.log("Geocercas seleccionadas del trayecto:", selectedGeocercas);

            const hasSameLength = currentSelectedIds.length === normalizedSelectedIds.length;
            const hasSameIds = hasSameLength && currentSelectedIds.every((id, index) => id === normalizedSelectedIds[index]);
            return hasSameIds ? currentSelectedIds : normalizedSelectedIds;
        });
    }, [allGeocercasForTrayecto, selectedGeoruta]);

    const handleTrayectoStartPointChange = useCallback((nextPoint) => {
        setTrayectoStartPoint((currentPoint) => {
            const normalizedNextPoint = normalizeTrayectoPoint(
                typeof nextPoint === "function" ? nextPoint(currentPoint) : nextPoint
            );
            return areTrayectoPointsEqual(currentPoint, normalizedNextPoint)
                ? currentPoint
                : normalizedNextPoint;
        });
    }, []);

    const handleTrayectoEndPointChange = useCallback((nextPoint) => {
        setTrayectoEndPoint((currentPoint) => {
            const normalizedNextPoint = normalizeTrayectoPoint(
                typeof nextPoint === "function" ? nextPoint(currentPoint) : nextPoint
            );
            return areTrayectoPointsEqual(currentPoint, normalizedNextPoint)
                ? currentPoint
                : normalizedNextPoint;
        });
    }, []);

    const getGeocercaRecordId = useCallback((geocerca) => (
        String(geocerca?.ID ?? geocerca?.id ?? geocerca?.Id ?? "")
    ), []);

    const areIdCollectionsEqual = useCallback((left = [], right = []) => {
        const normalizedLeft = [...new Set((Array.isArray(left) ? left : []).map(String))].sort();
        const normalizedRight = [...new Set((Array.isArray(right) ? right : []).map(String))].sort();
        if (normalizedLeft.length !== normalizedRight.length) return false;
        return normalizedLeft.every((value, index) => value === normalizedRight[index]);
    }, []);

    const hasUnsavedTrayectoGeocercaChanges = useMemo(
        () => !areIdCollectionsEqual(trayectoGeocercaSelectedIds, trayectoGeocercaOriginalIds),
        [areIdCollectionsEqual, trayectoGeocercaOriginalIds, trayectoGeocercaSelectedIds]
    );
    const hasUnsavedTrayectoPointChanges = useMemo(
        () => (
            !areTrayectoPointsEqual(trayectoStartPoint, trayectoOriginalStartPoint) ||
            !areTrayectoPointsEqual(trayectoEndPoint, trayectoOriginalEndPoint)
        ),
        [trayectoEndPoint, trayectoOriginalEndPoint, trayectoOriginalStartPoint, trayectoStartPoint]
    );
    const hasUnsavedTrayectoConfigChanges = hasUnsavedTrayectoGeocercaChanges || hasUnsavedTrayectoPointChanges;

    const parseTrayectoGeocercasA = useCallback((georuta) => {
        const rawValue =
            georuta?.GeocercasA ??
            georuta?.geocercasA ??
            georuta?.Geocercasa ??
            georuta?.geocercasa ??
            "";

        return String(rawValue)
            .split(/[\s,;|]+/)
            .map((value) => value.trim())
            .filter(Boolean);
    }, []);

    const fetchAllGeocercasCatalog = useCallback(async () => {
        const requestConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
        };

        let response;
        if (isGeocercasOnly) {
            try {
                response = await axios.post(
                    `${process.env.REACT_APP_SERVER}/geocercas/getgeocercascp`,
                    {},
                    requestConfig
                );
            } catch (cpError) {
                if (cpError.response?.status !== 404) throw cpError;
                response = await axios.get(
                    `${process.env.REACT_APP_SERVER}/maestros/getgeocercas`,
                    requestConfig
                );
            }
        } else {
            response = await axios.get(
                `${process.env.REACT_APP_SERVER}/maestros/getgeocercas`,
                requestConfig
            );
        }

        if (response.data?.success === false) {
            throw new Error(response.data?.message || "No fue posible cargar las geocercas.");
        }

        return Array.isArray(response.data?.data)
            ? response.data.data
            : Array.isArray(response.data)
                ? response.data
                : [];
    }, [isGeocercasOnly]);

    const ensureAllGeocercasForTrayectoLoaded = useCallback(async ({ showLoader = false } = {}) => {
        if (Array.isArray(allGeocercasForTrayecto) && allGeocercasForTrayecto.length > 0) {
            return allGeocercasForTrayecto;
        }

        if (showLoader) {
            Swal.fire({
                title: "Cargando geocercas",
                text: "Estamos preparando las geocercas para trabajar con la georuta.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        }

        try {
            const loadedGeocercas = await fetchAllGeocercasCatalog();
            if (isGeocercasOnly) {
                setAllGeocercasForTrayecto(loadedGeocercas);
            }
            return loadedGeocercas;
        } finally {
            if (showLoader) {
                Swal.close();
            }
        }
    }, [allGeocercasForTrayecto, fetchAllGeocercasCatalog, isGeocercasOnly]);

    const fetchTrayectoById = useCallback(async (trayectoId) => {
        const georutasResponse = await axios.get(
            `${process.env.REACT_APP_SERVER}/operaciones/gettrayectos`
        );

        if (georutasResponse.data?.success === false) {
            throw new Error(georutasResponse.data?.message || "No fue posible obtener los trayectos.");
        }

        const georutas = Array.isArray(georutasResponse.data?.data)
            ? georutasResponse.data.data
            : [];

        return georutas.find((georuta) => String(
            georuta?.IDTrayecto ??
            georuta?.IDtrayecto ??
            georuta?.IdTrayecto ??
            georuta?.id ??
            georuta?.ID ??
            ""
        ) === String(trayectoId)) || null;
    }, []);

    const discardTrayectoGeocercaDraft = useCallback(() => {
        setTrayectoGeocercaSelectedIds(
            Array.isArray(trayectoGeocercaOriginalIds)
                ? trayectoGeocercaOriginalIds.map(String)
                : []
        );
        setTrayectoStartPoint(trayectoOriginalStartPoint ? { ...trayectoOriginalStartPoint } : null);
        setTrayectoEndPoint(trayectoOriginalEndPoint ? { ...trayectoOriginalEndPoint } : null);
    }, [trayectoGeocercaOriginalIds, trayectoOriginalEndPoint, trayectoOriginalStartPoint]);

    const updateTrayectoGeocercas = useCallback(async () => {
        const trayectoId =
            selectedGeoruta?.IDTrayecto ??
            selectedGeoruta?.IDtrayecto ??
            selectedGeoruta?.IdTrayecto ??
            selectedGeoruta?.id ??
            selectedGeoruta?.ID;

        const normalizedSelectedIds = Array.isArray(trayectoGeocercaSelectedIds)
            ? trayectoGeocercaSelectedIds
                .map((id) => String(id).trim())
                .filter(Boolean)
            : [];
        const normalizedStartPoint = normalizeTrayectoPoint(trayectoStartPoint);
        const normalizedEndPoint = normalizeTrayectoPoint(trayectoEndPoint);

        if (!trayectoId) {
            toast.error("No hay un trayecto seleccionado para actualizar.");
            return;
        }

        if (hasUnsavedTrayectoConfigChanges) {
            const saveConfirmation = await Swal.fire({
                icon: "question",
                title: "Cambios sin guardar",
                text: "Tienes cambios sin guardar. Deseas continuar con la actualizacion de la georuta?",
                showCancelButton: true,
                confirmButtonText: "Si, actualizar",
                cancelButtonText: "Seguir editando",
                confirmButtonColor: "#0f4c81",
            });

            if (!saveConfirmation.isConfirmed) {
                return;
            }
        }

        const finalSelectedIds = [...normalizedSelectedIds];
        const startPointPayload = normalizedStartPoint
            ? {
                id: normalizedStartPoint.id || null,
                name: normalizedStartPoint.name || null,
                lat: normalizedStartPoint.lat,
                lng: normalizedStartPoint.lng,
            }
            : null;
        const endPointPayload = normalizedEndPoint
            ? {
                id: normalizedEndPoint.id || null,
                name: normalizedEndPoint.name || null,
                lat: normalizedEndPoint.lat,
                lng: normalizedEndPoint.lng,
            }
            : null;
        const startPointId = Number.parseInt(String(startPointPayload?.id ?? "").trim(), 10);
        const endPointId = Number.parseInt(String(endPointPayload?.id ?? "").trim(), 10);

        const payload = {
            ID: trayectoId,
            GeocercasA: finalSelectedIds.join(","),
        };

        if (Number.isInteger(startPointId)) {
            payload.GeoOrigen = startPointId;
        }

        if (Number.isInteger(endPointId)) {
            payload.GeoDestino = endPointId;
        }

        console.log("Payload cargado:", payload);
        setIsUpdatingTrayecto(true);
        openTrayectoUpdateLoader();
        updateTrayectoUpdateLoader("Preparando geocercas a guardar...", 15);

        try {
            setTrayectoGeocercaSelectedIds(finalSelectedIds);
            setTrayectoStartPoint(normalizedStartPoint ? { ...normalizedStartPoint } : null);
            setTrayectoEndPoint(normalizedEndPoint ? { ...normalizedEndPoint } : null);
            await new Promise((resolve) => window.setTimeout(resolve, 150));

            updateTrayectoUpdateLoader("Actualizando georuta...", 45);
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER}/geocercas/updatetrayecto`,
                payload
            );

            console.log("Respuesta actualizacion trayecto-geocercas:", response.data);
            if (response.data?.success === false) {
                throw new Error(response.data?.message || "No fue posible actualizar el trayecto.");
            }

            updateTrayectoUpdateLoader("Consultando georuta actualizada...", 72);
            const refreshedTrayecto = await fetchTrayectoById(trayectoId);
            const nextTrayecto = refreshedTrayecto || {
                ...selectedGeoruta,
                GeocercasA: finalSelectedIds.join(","),
                ...payload,
            };

            updateTrayectoUpdateLoader("Repintando trayecto y geocercas...", 90);
            await showSelectedGeorutaOnMapRef.current?.(nextTrayecto);

            updateTrayectoUpdateLoader("Proceso finalizado.", 100);
            await new Promise((resolve) => window.setTimeout(resolve, 350));
            Swal.close();
            toast.success("Trayecto actualizado correctamente.");
        } catch (error) {
            console.error("Error al actualizar trayecto:", error);
            Swal.close();
            toast.error(error.response?.data?.message || error.message || "Error al actualizar el trayecto.");
        } finally {
            setIsUpdatingTrayecto(false);
        }
    }, [
        fetchTrayectoById,
        hasUnsavedTrayectoConfigChanges,
        selectedGeoruta,
        trayectoEndPoint,
        trayectoGeocercaSelectedIds,
        trayectoStartPoint,
    ]);

    const [livePanelOpen, setLivePanelOpen] = useState(false);
    const [livePanelLayout, setLivePanelLayout] = useState({ width: 420, height: 520 });
    const [mobileActionsOpen, setMobileActionsOpen] = useState(false);
    const mobileActionsRef = useRef(null);
    const liveStreamsSeededRef = useRef(false);

    useEffect(() => {
        if (!mobileActionsOpen) return undefined;

        const handleOutside = (event) => {
            const target = event.target;
            if (!mobileActionsRef.current || !target) return;
            if (!mobileActionsRef.current.contains(target)) {
                setMobileActionsOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === "Escape") setMobileActionsOpen(false);
        };

        window.addEventListener("mousedown", handleOutside);
        window.addEventListener("touchstart", handleOutside);
        window.addEventListener("keydown", handleEscape);

        return () => {
            window.removeEventListener("mousedown", handleOutside);
            window.removeEventListener("touchstart", handleOutside);
            window.removeEventListener("keydown", handleEscape);
        };
    }, [mobileActionsOpen]);

    useEffect(() => {
        if (!isMobile) return undefined;

        document.body.classList.toggle("mobile-detail-offcanvas-open", mobileInfoOpen);

        return () => {
            document.body.classList.remove("mobile-detail-offcanvas-open");
        };
    }, [isMobile, mobileInfoOpen]);
    const readActiveStreamsFromSession = useCallback(() => {
        const tryParse = (raw) => {
            if (!raw) return null;
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                console.error("Error parseando activeStreams:", error);
                return null;
            }
        };

        const sessionRaw = sessionStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
        const sessionParsed = tryParse(sessionRaw);
        if (sessionParsed) return sessionParsed;

        const localRaw = localStorage.getItem(ACTIVE_STREAMS_STORAGE_KEY);
        const localParsed = tryParse(localRaw);
        if (localParsed) {
            try {
                sessionStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, JSON.stringify(localParsed));
            } catch (error) {
                console.error("Error sincronizando sessionStorage desde localStorage:", error);
            }
            return localParsed;
        }

        return [];
    }, []);
    const [activeStreams, setActiveStreams] = useState(() => readActiveStreamsFromSession());
    const selectedGeocercaRecord = useMemo(() => {
        if (geoFilter.showAll) return null;
        const selectedId = Array.isArray(geoFilter.selectedIds) ? String(geoFilter.selectedIds[0] || "") : "";
        if (!selectedId) return null;
        return (listGeocercas || []).find((g) => String(g?.ID) === selectedId) || null;
    }, [geoFilter, listGeocercas]);

    const filteredGeocercasCards = useMemo(() => {
        const term = String(geoListSearch || "").trim().toLowerCase();
        const source = Array.isArray(listGeocercas) ? listGeocercas : [];
        if (isGeocercasOnly) return source;
        if (!term) return source;

        return source.filter((item) => {
            const name = String(item?.Nombre || "").toLowerCase();
            const desc = String(item?.Descripcion || "").toLowerCase();
            const code = String(item?.Codigo || item?.Code || item?.ID || "").toLowerCase();
            return name.includes(term) || desc.includes(term) || code.includes(term);
        });
    }, [geoListSearch, isGeocercasOnly, listGeocercas]);
    const geoDraftClosedPoints = useMemo(() => {
        const normalizedPoints = (Array.isArray(geoDraftPoints) ? geoDraftPoints : []).filter(
            (point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng)
        );

        if (!isGeoDraftClosed || normalizedPoints.length < 3) return normalizedPoints;

        return [...normalizedPoints, normalizedPoints[0]];
    }, [geoDraftPoints, isGeoDraftClosed]);
    const geoDraftVerticesPreview = useMemo(() => {
        return geoDraftClosedPoints
            .map((point) => `(${Number(point.lat)},${Number(point.lng)})`)
            .join("/");
    }, [geoDraftClosedPoints]);
    const geoDraftVerticesString = useMemo(() => {
        return geoDraftClosedPoints
            .map((point) => `(${Number(point.lat)},${Number(point.lng)})`)
            .join("/");
    }, [geoDraftClosedPoints]);
    const filteredGeoCompanies = useMemo(() => {
        const term = geoCompanySearch.trim().toLowerCase();
        if (!term) return geoCompanies;

        return geoCompanies.filter((company) =>
            String(company.NombreEmpresa || "").toLowerCase().includes(term)
        );
    }, [geoCompanies, geoCompanySearch]);
    const selectedGeoCompanyNames = useMemo(() => {
        if (geoDraftCompanies.includes("0")) return ["TODAS"];

        const selectedIds = new Set(geoDraftCompanies.map(String));
        return geoCompanies
            .filter((company) => selectedIds.has(String(company.IdEmpresa)))
            .map((company) => company.NombreEmpresa);
    }, [geoCompanies, geoDraftCompanies]);
    const toggleGeoCompany = useCallback((companyId) => {
        const normalizedId = String(companyId);

        setGeoDraftCompanies((current) => {
            if (normalizedId === "0") return ["0"];

            const withoutAll = current.filter((id) => id !== "0");
            if (withoutAll.includes(normalizedId)) {
                const next = withoutAll.filter((id) => id !== normalizedId);
                return next.length > 0 ? next : ["0"];
            }

            return [...withoutAll, normalizedId];
        });
    }, []);
    const syncWithSessionStorage = useCallback((nextStreams) => {
        try {
            const payload = JSON.stringify(nextStreams || []);
            sessionStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, payload);
            localStorage.setItem(ACTIVE_STREAMS_STORAGE_KEY, payload);
        } catch (error) {
            console.error("Error sincronizando sessionStorage activeStreams:", error);
        }
    }, []);

    const getContratoStreamingRawUrl = useCallback((contrato) => {
        if (!contrato || typeof contrato !== "object") return "";
        return (
            contrato.StreamingUrl ||
            contrato.streamingUrl ||
            contrato.StreamUrl ||
            contrato.streamUrl ||
            contrato.Url ||
            contrato.URL ||
            contrato.url ||
            ""
        );
    }, []);

    const parseStreamingUrls = useCallback((rawUrl) => {
        if (!rawUrl) return [];
        return String(rawUrl)
            .split(",")
            .map((item) => item.trim())
            .filter(Boolean);
    }, []);

    const resolveLiveStreamUrl = useCallback((msg, deviceId) => {
        const raw =
            msg?.streamId ||
            msg?.streamUrl ||
            msg?.url ||
            msg?.data?.url ||
            "";

        const normalizeName = (value) => {
            if (!value) return "";
            const text = String(value);
            const playMatch = text.match(/play\.html\?name=([^&]+)/i);
            if (playMatch?.[1]) return playMatch[1];
            const liveAppMatch = text.match(/LiveApp\/([^/?#]+)/i);
            if (liveAppMatch?.[1]) return liveAppMatch[1];
            if (text.includes("/")) {
                const last = text.split("/").filter(Boolean).pop();
                if (last) return last;
            }
            return text;
        };

        if (raw && String(raw).toLowerCase().includes("play.html")) return raw;

        const nameFromRaw = normalizeName(raw);
        if (nameFromRaw) {
            return `https://streaming.cargotronics.com:5443//LiveApp/play.html?name=${nameFromRaw}`;
        }

        if (deviceId) {
            return `https://streaming.cargotronics.com:5443//LiveApp/play.html?name=${deviceId}_JT800`;
        }

        return "";
    }, []);

    const buildActiveStreamsFromContratos = useCallback((contratos = []) => {
        if (!Array.isArray(contratos)) return [];

        const byDeviceAndStream = new Map();

        contratos.forEach((contrato) => {
            if (!isStreamingOn(contrato)) return;

            const deviceId = String(contrato?.FKLokDeviceID || "").trim();
            if (!deviceId) return;

            const rawUrl = getContratoStreamingRawUrl(contrato);
            const parsedUrls = parseStreamingUrls(rawUrl);
            const candidates = parsedUrls.length > 0 ? parsedUrls : [rawUrl];

            candidates.forEach((candidate) => {
                const streamId = String(
                    resolveLiveStreamUrl(
                        { streamId: candidate, streamUrl: candidate, url: candidate },
                        deviceId
                    ) || candidate || ""
                ).trim();

                if (!streamId) return;

                const key = `${deviceId}::${streamId}`;
                byDeviceAndStream.set(key, {
                    deviceId,
                    streamId,
                    timestamp: contrato?.LoksysServerTime || new Date().toISOString(),
                });
            });
        });

        return Array.from(byDeviceAndStream.values());
    }, [getContratoStreamingRawUrl, parseStreamingUrls, resolveLiveStreamUrl]);

    const normalizeStreams = useCallback((list = []) =>
        (Array.isArray(list) ? list : [])
            .map((item) => ({
                deviceId: String(item?.deviceId || ""),
                streamId: String(item?.streamId || ""),
                streamUrl: String(item?.streamUrl || item?.url || ""),
            }))
            .sort((a, b) =>
                `${a.deviceId}|${a.streamId}|${a.streamUrl}`.localeCompare(
                    `${b.deviceId}|${b.streamId}|${b.streamUrl}`
                )
            ), []);

    const areStreamsEqual = useCallback((a = [], b = []) => {
        const na = normalizeStreams(a);
        const nb = normalizeStreams(b);
        if (na.length !== nb.length) return false;
        for (let i = 0; i < na.length; i += 1) {
            if (
                na[i].deviceId !== nb[i].deviceId ||
                na[i].streamId !== nb[i].streamId ||
                na[i].streamUrl !== nb[i].streamUrl
            ) {
                return false;
            }
        }
        return true;
    }, [normalizeStreams]);

    const addStream = useCallback((msg) => {
        const deviceId = String(
            msg?.deviceId ||
            msg?.deviceID ||
            msg?.fkLokDeviceID ||
            msg?.FKLokDeviceID ||
            msg?.data?.deviceId ||
            msg?.data?.deviceID ||
            ""
        );
        const streamId = String(
            msg?.streamId ||
            msg?.streamID ||
            msg?.streamUrl ||
            msg?.streamURL ||
            msg?.url ||
            msg?.data?.streamId ||
            msg?.data?.streamUrl ||
            msg?.data?.url ||
            ""
        );
        if (!deviceId) return;

        const resolvedStreamId =
            streamId ||
            resolveLiveStreamUrl({ streamId: "", streamUrl: "", url: "" }, deviceId);
        if (!resolvedStreamId) return;

        setActiveStreams((prev) => {
            const exists = (prev || []).some((s) => s.deviceId === deviceId && s.streamId === resolvedStreamId);
            if (exists) return prev;
            const next = [...(prev || []), { streamId: resolvedStreamId, deviceId }];
            syncWithSessionStorage(next);
            return next;
        });
    }, [resolveLiveStreamUrl, syncWithSessionStorage]);

    const removeStream = useCallback((msg) => {
        const deviceId = String(
            msg?.deviceId ||
            msg?.deviceID ||
            msg?.fkLokDeviceID ||
            msg?.FKLokDeviceID ||
            msg?.data?.deviceId ||
            msg?.data?.deviceID ||
            ""
        );
        const streamId = String(
            msg?.streamId ||
            msg?.streamID ||
            msg?.streamUrl ||
            msg?.streamURL ||
            msg?.url ||
            msg?.data?.streamId ||
            msg?.data?.streamUrl ||
            msg?.data?.url ||
            ""
        );
        if (!deviceId && !streamId) return;

        const normalizeStreamKey = (value) => {
            const raw = String(value || "").trim();
            if (!raw) return "";
            let decoded = raw;
            try {
                decoded = decodeURIComponent(raw);
            } catch { }
            const lower = decoded.toLowerCase();
            const playIdMatch = lower.match(/[?&]id=([^&]+)/i);
            if (playIdMatch?.[1]) return playIdMatch[1];
            const playNameMatch = lower.match(/[?&]name=([^&]+)/i);
            if (playNameMatch?.[1]) return playNameMatch[1];
            const liveAppMatch = lower.match(/liveapp\/([^/?#]+)/i);
            if (liveAppMatch?.[1]) return liveAppMatch[1];
            const parts = lower.split("/").filter(Boolean);
            return parts[parts.length - 1] || lower;
        };

        const incomingKey = normalizeStreamKey(streamId);
        const incomingLooksJt800 =
            String(streamId || "").toLowerCase().includes("jt800") ||
            String(incomingKey || "").includes("jt800");

        setActiveStreams((prev) => {
            const next = (prev || []).filter((s) => {
                const sameDevice = deviceId && String(s?.deviceId || "") === deviceId;
                const storedStream = String(s?.streamId || "");
                const storedKey = normalizeStreamKey(storedStream);
                const exactMatch = !!streamId && storedStream === streamId;
                const normalizedMatch = !!incomingKey && storedKey === incomingKey;
                const jt800Fallback = sameDevice && incomingLooksJt800 && storedKey.includes("jt800");
                if (streamId) {
                    return !(exactMatch || normalizedMatch || jt800Fallback);
                }
                if (sameDevice) return false;
                return true;
            });
            if (next.length === (prev || []).length) return prev;
            syncWithSessionStorage(next);
            return next;
        });
    }, [syncWithSessionStorage]);

    // Nota: activeStreams se mantiene por eventos live (WebSocket).
    // No rehidratar desde contratos para evitar reinsertar streams históricos
    // después de LIVE_END.

    const ensureLiveToastStyles = useCallback(() => {
        if (document.getElementById("live-toast-styles")) return;
        const style = document.createElement("style");
        style.id = "live-toast-styles";
        style.innerHTML = `
      @keyframes liveToastProgress {
        from { width: 100%; }
        to { width: 0%; }
      }
    `;
        document.head.appendChild(style);
    }, []);

    const handleLiveNow = useCallback(
        (msg) => {
            addStream(msg);
            const deviceId = msg?.deviceId;
            if (!deviceId) return;

            const contratos = filteredContracts?.length ? filteredContracts : contracts;
            const contrato = (contratos || []).find(
                (c) => String(c?.FKLokDeviceID) === String(deviceId)
            );

            if (!contrato) return;

            const durationMs = 8000;
            ensureLiveToastStyles();

            const liveStreamUrl = resolveLiveStreamUrl(msg, deviceId);

            toast.custom(
                (t) => (
                    <div
                        onClick={() => {
                            toast.dismiss(t.id);
                            openModalEnVivo(contrato, liveStreamUrl);
                        }}
                        style={{
                            cursor: "pointer",
                            background: "#fff",
                            color: "#111",
                            padding: "10px 14px",
                            borderRadius: 10,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                            borderLeft: "4px solid #1e90ff",
                            width: 280,
                            minWidth: 280,
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <style>{`
              @keyframes liveToastPulse {
                0% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.35); opacity: 0.55; }
                100% { transform: scale(1); opacity: 1; }
              }
            `}</style>
                            <span
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    background: "#ff2d2d",
                                    boxShadow: "0 0 0 4px rgba(255,45,45,0.18)",
                                    animation: "liveToastPulse 1.2s ease-in-out infinite",
                                }}
                            />
                            <strong>En vivo</strong>
                        </div>
                        <div style={{ fontSize: 13, marginTop: 4 }}>
                            {`Este dispositivo comenzó un live (${deviceId})`}
                        </div>
                        <div
                            style={{
                                marginTop: 8,
                                height: 3,
                                background: "#e6eef7",
                                borderRadius: 999,
                                overflow: "hidden",
                            }}>
                            <div
                                style={{
                                    height: "100%",
                                    background: "#1e90ff",
                                    animation: `liveToastProgress ${durationMs}ms linear forwards`,
                                }}
                            />
                        </div>
                    </div>
                ),
                { id: `live-${deviceId}`, duration: durationMs }
            );
        },
        [addStream, ensureLiveToastStyles, filteredContracts, contracts, resolveLiveStreamUrl]
    );

    const handleLiveEnded = useCallback(
        (msg) => {
            removeStream(msg);
        },
        [removeStream]
    );

    useEffect(() => {
        syncWithSessionStorage(activeStreams);
    }, [activeStreams, syncWithSessionStorage]);

    useImperativeHandle(ref, () => ({
        handleLiveNow,
        handleLiveEnded,
    }));
    const deviceViewMode = showTrafficGrid ? "table" : showHorizontalDevices ? "cards" : "left";
    const deviceViewLabel = deviceViewMode === "table" ? "Lista" : deviceViewMode === "cards" ? "Cards" : "Lateral";
    const deviceViewIcon = deviceViewMode === "cards" ? FaThLarge : FaList;
    const deviceListTarget =
        deviceViewMode === "left"
            ? "#tour-left-panel"
            : deviceViewMode === "table"
                ? "#tour-device-table"
                : "#tour-device-cards";

    const allowedDevices = useMemo(() => {
        const source = filteredContracts?.length ? filteredContracts : contracts;
        return new Set(
            (source || [])
                .map((c) => String(c?.FKLokDeviceID || ""))
                .filter(Boolean)
        );
    }, [filteredContracts, contracts]);

    const displayStreams = useMemo(() => {
        const list = activeStreams || [];
        if (allowedDevices.size === 0) return list;
        return list.filter((s) => allowedDevices.has(String(s?.deviceId || "")));
    }, [activeStreams, allowedDevices]);

    const activeStreamDeviceSet = useMemo(() => {
        return new Set(
            (displayStreams || [])
                .map((s) => String(s?.deviceId || ""))
                .filter(Boolean)
        );
    }, [displayStreams]);

    const getContratoByDevice = useCallback(
        (deviceId) => {
            const source = filteredContracts?.length ? filteredContracts : contracts;
            return (source || []).find(
                (c) => String(c?.FKLokDeviceID || "") === String(deviceId || "")
            );
        },
        [filteredContracts, contracts]
    );
    const handleSkipTour = useCallback(() => {
        setTourRun(false);
        setTourStepIndex(0);
        setWaitMode(null);
    }, []);

    const startTour = useCallback(() => {
        setTourRun(false);
        setTourStepIndex(0);
        setWaitMode(null);
        setTimeout(() => setTourRun(true), 50);
    }, []);

    useEffect(()=>{
        console.log("Lista de geocercas:", listGeocercas);
    },[listGeocercas]);

    const tourStepsDynamic = useMemo(() => {
        const steps = [
            {
                target: "#tour-map",
                content: (
                    <div className="tour-first">
                        <p>Este es el mapa en tiempo real. Aqui ves todos los servicios.</p>
                        <button type="button" className="tour-skip-btn" onClick={handleSkipTour}>
                            Saltar tour
                        </button>
                    </div>
                ),
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#tour-search",
                content: "Busca por placa, contenedor, empresa, dispositivo, ruta, etc.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#tour-left-panel",
                content: "Aqui ves las cards de dispositivos o servicios activos.",
                placement: "right",
                disableBeacon: true,
            },
            {
                target: "#tour-advanced-filters",
                content: "Haz clic para abrir Filtros avanzados.",
                placement: "left",
                disableBeacon: true,
                spotlightClicks: true,
                hideCloseButton: true,
                disableOverlay: true,
            },
            {
                target: "#tour-offcanvas-anchor",
                content: "Aqui puedes configurar filtros avanzados. Cierra el panel para continuar.",
                placement: "left",
                disableBeacon: true,
                hideCloseButton: true,
                spotlightPadding: 4,
                disableOverlay: true,
                floaterProps: { disableFlip: true, offset: 12 },
            },
            {
                target: "#tour-geocercas",
                content: "Haz clic para abrir Geocercas.",
                placement: "left",
                disableBeacon: true,
                spotlightClicks: true,
                hideCloseButton: true,
                disableOverlay: true,
            },
            {
                target: "#tour-offcanvas-anchor",
                content: "Aqui puedes seleccionar y aplicar geocercas. Cierra el panel para continuar.",
                placement: "left",
                disableBeacon: true,
                hideCloseButton: true,
                spotlightPadding: 4,
                disableOverlay: true,
                floaterProps: { disableFlip: true, offset: 12 },
            },
            {
                target: "#tour-georutas",
                content: "Haz clic para abrir Georutas.",
                placement: "left",
                disableBeacon: true,
                spotlightClicks: true,
                hideCloseButton: true,
                disableOverlay: true,
            },
            {
                target: "#tour-offcanvas-anchor",
                content: "Aqui puedes seleccionar georutas. Cierra el panel para continuar.",
                placement: "left",
                disableBeacon: true,
                hideCloseButton: true,
                spotlightPadding: 4,
                disableOverlay: true,
                floaterProps: { disableFlip: true, offset: 12 },
            },
            {
                target: "#tour-invias",
                content: "Haz clic para abrir Restricciones viales (Invias).",
                placement: "left",
                disableBeacon: true,
                spotlightClicks: true,
                hideCloseButton: true,
                disableOverlay: true,
            },
            {
                target: "#tour-offcanvas-anchor",
                content: "Aqui puedes elegir paises y aplicar restricciones. Cierra el panel para continuar.",
                placement: "left",
                disableBeacon: true,
                hideCloseButton: true,
                spotlightPadding: 4,
                disableOverlay: true,
                floaterProps: { disableFlip: true, offset: 12 },
            },
            {
                target: "#tour-fast-filters",
                content: "Filtros rapidos: movimiento, stop, bateria baja, desvio, etc.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#tour-fast-filters-panel",
                content: "Aqui ves el detalle de los filtros rapidos activos.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#tour-devices-view",
                content: "Cambio de vista: lateral, cards o tabla. Haz clic para continuar.",
                placement: "bottom",
                disableBeacon: true,
                spotlightClicks: true,
                hideCloseButton: true,
            },
            {
                target: deviceListTarget,
                content: "Aqui esta la lista de dispositivos en esta vista.",
                placement: "top",
                disableBeacon: true,
            },
        ];

        return isMobile
            ? steps.filter((step) => step.target !== "#tour-left-panel")
            : steps;
    }, [deviceListTarget, handleSkipTour, isMobile]);
    const refuerzosForSelected = (() => {
        const placaKey = contratoSelected?.PlacaTruck?.toString().trim();
        if (!placaKey) return [];
        return contracts.filter(
            (c) =>
                c.PlacaTruck?.toString().trim() === placaKey &&
                c.ContractID !== contratoSelected?.ContractID
        );
    })();
    const hasRefuerzos = refuerzosForSelected.length > 0;

    const toggleDeviceView = () => {
        const nextMode =
            deviceViewMode === "left" ? "table" : deviceViewMode === "table" ? "cards" : "left";
        setShowTrafficGrid(nextMode === "table");
        setShowHorizontalDevices(nextMode === "cards");
        if (nextMode === "left") setMenuVisible(true);
        if (tourRun && tourStepIndex === TOUR_STEP_INDEX.devicesViewButton) {
            setTourStepIndex(TOUR_STEP_INDEX.devicesList);
        }
    };

    const getOffcanvasStepInfo = (stepIdx) => {
        const entries = Object.entries(OFFCANVAS_FLOW);
        for (const [key, flow] of entries) {
            if (stepIdx === flow.button) return { key, kind: "button", panelIndex: flow.panel };
            if (stepIdx === flow.panel) return { key, kind: "panel", panelIndex: flow.panel };
        }
        return null;
    };

    const isOffcanvasOpen = (key) => {
        if (key === "advanced") return offcanvasOpen;
        if (key === "geocercas") return offcanvasOpenGeocercas;
        if (key === "georutas") return offcanvasOpenGeorutas;
        if (key === "invias") return inviasOffcanvasOpen;
        return null;
    };

    const showMapDimmer = tourRun && Boolean(getOffcanvasStepInfo(tourStepIndex));
    const offcanvasAnchorRight = 392;

    const handleTourCallback = (data) => {
        const { status, type, index, action } = data;

        // terminar
        if (status === "finished" || status === "skipped") {
            handleSkipTour();
            return;
        }

        // target no existe (según versión puede venir distinto)
        if (type === "target:notFound" || type === "error:target_not_found") {
            setWaitMode(null);
            setTourStepIndex((i) => i + 1);
            return;
        }

        // antes del step: si es un step de offcanvas, entramos en modo "esperar abrir"
        if (type === "step:before") {
            const stepInfo = getOffcanvasStepInfo(index);
            if (stepInfo?.kind === "button") setWaitMode("open");
            else if (stepInfo?.kind === "panel") setWaitMode("close");
            else setWaitMode(null);
            if (index === TOUR_STEP_INDEX.fastFilters) {
                setWaitMode("fastFiltersOpen");
            }
            return;
        }

        // después del step: si NO es offcanvas, avanza normal
        if (type === "step:after") {
            if (action === "prev") {
                setWaitMode(null);
                setTourStepIndex((i) => Math.max(i - 1, 0));
                return;
            }
            // si el usuario dio "next" o "close" y este step NO es de offcanvas, avanzamos
            if (getOffcanvasStepInfo(index)) return;
            if (index === TOUR_STEP_INDEX.devicesViewButton) return;
            if (index === TOUR_STEP_INDEX.fastFilters) return;
            setTourStepIndex((i) => i + 1);
            // si ES de offcanvas, NO avances aquí: lo va a avanzar el useEffect cuando cierre
            return;
        }
    };


    const handleRefuerzosSwitch = (next) => {
        setShowRefuerzosPanel(next);
        localStorage.setItem("sw-refuerzos-panel", next ? "true" : "false");
    };

    const openMarkerLabelsOffcanvas = useCallback(() => {
        setMarkerLabelFieldsDraft(markerLabelFields);
        setMarkerLabelsOffcanvasOpen(true);
    }, [markerLabelFields]);

    const toggleMarkerLabelField = useCallback((fieldKey) => {
        setMarkerLabelFieldsDraft((currentFields) => {
            if (currentFields.includes(fieldKey)) {
                if (currentFields.length === 1) {
                    toast.error("Selecciona al menos un campo para las etiquetas.");
                    return currentFields;
                }
                return currentFields.filter((field) => field !== fieldKey);
            }
            if (currentFields.length >= 3) {
                toast.error("Puedes seleccionar maximo 3 campos para las etiquetas.");
                return currentFields;
            }
            return [...currentFields, fieldKey];
        });
    }, []);

    const applyMarkerLabelFields = useCallback(() => {
        const nextFields = markerLabelFieldsDraft.length > 0 ? markerLabelFieldsDraft : ["plate"];
        try {
            localStorage.setItem(MARKER_LABEL_FIELDS_STORAGE_KEY, JSON.stringify(nextFields));
            localStorage.setItem("sw-placa", "true");

            const persistedFields = JSON.parse(
                localStorage.getItem(MARKER_LABEL_FIELDS_STORAGE_KEY) || "[]"
            );
            const selectionWasSaved =
                Array.isArray(persistedFields) &&
                JSON.stringify(persistedFields) === JSON.stringify(nextFields);

            if (!selectionWasSaved) {
                throw new Error("La seleccion no pudo verificarse en el almacenamiento local.");
            }

            setMarkerLabelFields(nextFields);
            setShowPlateBadges(true);
            setMarkerLabelsOffcanvasOpen(false);
        } catch (error) {
            console.error("Error guardando las etiquetas del Map Center:", error);
            toast.error("No fue posible guardar la seleccion de etiquetas.");
        }
    }, [markerLabelFieldsDraft]);

    const hideMarkerLabels = useCallback(() => {
        setShowPlateBadges(false);
        localStorage.setItem("sw-placa", "false");
        setMarkerLabelsOffcanvasOpen(false);
    }, []);

    useEffect(() => {
        const syncStreams = () => {
            const next = readActiveStreamsFromSession();
            setActiveStreams((prev) => (areStreamsEqual(prev, next) ? prev : next));
        };
        syncStreams();
        const intervalId = setInterval(syncStreams, 1500);
        const onStorage = (e) => {
            if (e.key === ACTIVE_STREAMS_STORAGE_KEY) syncStreams();
        };
        window.addEventListener("storage", onStorage);
        return () => {
            clearInterval(intervalId);
            window.removeEventListener("storage", onStorage);
        };
    }, [areStreamsEqual, readActiveStreamsFromSession]);

    useEffect(() => {
        if (liveStreamsSeededRef.current) return;
        if ((activeStreams || []).length > 0) {
            liveStreamsSeededRef.current = true;
            return;
        }
        const seeded = buildActiveStreamsFromContratos(contracts);
        if (seeded.length === 0) return;
        liveStreamsSeededRef.current = true;
        setActiveStreams(seeded);
        syncWithSessionStorage(seeded);
    }, [activeStreams, buildActiveStreamsFromContratos, contracts, syncWithSessionStorage]);

    useEffect(() => {
        if (!window.google?.maps || !mapRef.current) return;
        const timer = setTimeout(() => {
            google.maps.event.trigger(mapRef.current, "resize");
        }, 0);
        return () => clearTimeout(timer);
    }, [showHorizontalDevices, showTrafficGrid]);

    useEffect(() => {
        const handleFullscreenChange = () => {
            const fullscreenEl =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;

            const isFullscreen = Boolean(fullscreenEl);
            setIsMapFullscreen(isFullscreen);
            setIsCustomFullscreen(fullscreenEl === mapCenterRootRef.current);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.addEventListener("mozfullscreenchange", handleFullscreenChange);
        document.addEventListener("MSFullscreenChange", handleFullscreenChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
            document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
        };
    }, []);

    useEffect(() => {
        document.body.classList.toggle("map-center-fullscreen", isCustomFullscreen);
        return () => {
            document.body.classList.remove("map-center-fullscreen");
        };
    }, [isCustomFullscreen]);

    const toggleCustomFullscreen = () => {
        const rootEl = mapCenterRootRef.current;
        if (!rootEl) return;

        const fullscreenEl =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

        if (fullscreenEl) {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
            return;
        }

        if (rootEl.requestFullscreen) rootEl.requestFullscreen();
        else if (rootEl.webkitRequestFullscreen) rootEl.webkitRequestFullscreen();
        else if (rootEl.mozRequestFullScreen) rootEl.mozRequestFullScreen();
        else if (rootEl.msRequestFullscreen) rootEl.msRequestFullscreen();
    };

    useEffect(() => {
        if (!isResizingBottom) return;

        const clampBottomHeight = (value) => {
            const max = Math.min(520, Math.floor(window.innerHeight * 0.6));
            const min = 160;
            return Math.max(min, Math.min(max, value));
        };

        const handleMove = (event) => {
            const delta = bottomResizeRef.current.startY - event.clientY;
            const nextHeight = bottomResizeRef.current.startHeight + delta;
            setBottomHeight(clampBottomHeight(nextHeight));
        };

        const handleUp = () => {
            setIsResizingBottom(false);
        };

        window.addEventListener("mousemove", handleMove);
        window.addEventListener("mouseup", handleUp);

        return () => {
            window.removeEventListener("mousemove", handleMove);
            window.removeEventListener("mouseup", handleUp);
        };
    }, [isResizingBottom]);

    const hasBottomPanel = showHorizontalDevices || showTrafficGrid;
    const baseHeight = isCustomFullscreen ? "100vh" : "90vh";
    const mapHeight = showTrafficGrid ? `calc(${baseHeight} - ${bottomHeight}px)` : showHorizontalDevices ? "70vh" : baseHeight;
    const offcanvasContainer = isCustomFullscreen && mapCenterRootRef.current ? mapCenterRootRef.current : "body";
    const modalContainer = isCustomFullscreen && mapCenterRootRef.current ? mapCenterRootRef.current : undefined;
    const seguimientoBodyStyle = isCustomFullscreen ? { maxHeight: "calc(100vh - 200px)", overflowY: "auto" } : undefined;

    const closeModales = (modal) => {
        if (modal === "modalContratoSeguimiento") setModalContratoSeguimiento(false);
        if (modal === "modalImagenes") {
            setModalImagenes(false);
            setMultimediaHubTab(multimediaHubTabs.PHOTOS);
        }
        if (modal === "modalReporteServicio") setModalConsolidado(false);
        if (modal === "modalEnVivo") setModalEnVivo(false);
        if (modal === "modalValitronics") {
            setModalValitronics(false);
            setListComprobantes([]);
        }
        if (modal === "modalCheckList") setModalCheckList(false);
        if (modal === "modalMonitoreo") setModalMonitoreo(false);
    };

    const clearHoverCloseTimer = () => {
        if (hoverCloseTimerRef.current) {
            clearTimeout(hoverCloseTimerRef.current);
            hoverCloseTimerRef.current = null;
        }
    };

    const resetHoverInteractionState = () => {
        hoverInteractionRef.current = {
            markerHovered: false,
            markerFocused: false,
            tooltipHovered: false,
            tooltipFocused: false,
            markerPointerDown: false,
            tooltipPointerDown: false,
        };
    };

    const isHoverInteractionActive = () => {
        const interaction = hoverInteractionRef.current;
        return Boolean(
            interaction.markerHovered ||
            interaction.markerFocused ||
            interaction.tooltipHovered ||
            interaction.tooltipFocused
        );
    };

    const getHoverAnchorPixel = (anchorEl, position) => {
        if (anchorEl?.style?.left && anchorEl?.style?.top) {
            const x = Number.parseFloat(anchorEl.style.left);
            const y = Number.parseFloat(anchorEl.style.top);
            if (Number.isFinite(x) && Number.isFinite(y)) {
                return { x, y };
            }
        }

        const mapContainer = mapContainerRef.current;
        if (anchorEl && mapContainer) {
            const anchorRect = anchorEl.getBoundingClientRect();
            const mapRect = mapContainer.getBoundingClientRect();
            return {
                x: anchorRect.left - mapRect.left + anchorRect.width / 2,
                y: anchorRect.top - mapRect.top + anchorRect.height,
            };
        }

        const projection = projectionOverlayRef.current?.getProjection?.();
        if (!projection || !position) return null;

        const pixel = projection.fromLatLngToDivPixel(position);
        if (!pixel) return null;

        return { x: pixel.x, y: pixel.y };
    };

    const isTargetInsideActiveHover = (target) => {
        if (!target) return false;

        const activeHover = activeMarkerHoverRef.current;
        const anchorEl = activeHover?.anchorEl;
        const tooltipEl = hoverTooltipPortalRef.current;

        return Boolean(
            (anchorEl && anchorEl.contains(target)) ||
            (tooltipEl && tooltipEl.contains(target))
        );
    };

    const isTargetInsideNodes = (target, ...nodes) => {
        if (!target) return false;
        return nodes.some((node) => node && node.contains(target));
    };

    const closeHoverInfoWindow = () => {
        clearHoverCloseTimer();
        const activeHover = activeMarkerHoverRef.current;
        if (activeHover?.anchorEl) {
            activeHover.anchorEl.classList.remove("is-hover-active");
            activeHover.anchorEl.style.zIndex = "";
        }
        if (hoverTooltipPortalRef.current) {
            hoverTooltipPortalRef.current.classList.remove("is-visible");
            hoverTooltipPortalRef.current.classList.add("is-hiding");
        }
        activeMarkerHoverRef.current = null;
        resetHoverInteractionState();
    };

    const openHoverInfoWindow = ({ markerId, anchorEl, position, content, contrato }) => {
        if (selectedInfoWindowOpenRef.current) {
            closeHoverInfoWindow();
            return;
        }
        if (!anchorEl || !position || !content) return;

        const projOverlay = projectionOverlayRef.current;
        const floatPane = projOverlay?.getPanes?.()?.floatPane;
        const projection = projOverlay?.getProjection?.();
        if (!floatPane || !projection) return;

        clearHoverCloseTimer();

        const activeHover = activeMarkerHoverRef.current;
        if (activeHover && activeHover.markerId !== markerId) {
            activeHover.anchorEl?.classList.remove("is-hover-active");
            if (activeHover.anchorEl) activeHover.anchorEl.style.zIndex = "";
        }

        if (!hoverTooltipPortalRef.current) {
            const tooltipEl = document.createElement("div");
            tooltipEl.className = "info-window-hover map-floating-hover";
            tooltipEl.tabIndex = 0;
            tooltipEl.addEventListener("pointerdown", (event) => {
                const infoButton = event.target.closest(".hover-marker-info-button");
                if (infoButton) {
                    event.preventDefault();
                    event.stopPropagation();

                    const activeHover = activeMarkerHoverRef.current;
                    const currentContrato = activeHover?.contrato;
                    const markerAnchor = activeHover?.anchorEl;
                    if (!currentContrato) return;

                    closeHoverInfoWindow();
                    if (markerAnchor?.isConnected) {
                        markerAnchor.click();
                    } else {
                        openInfoWindowForContrato(currentContrato, { focusZoom: true });
                    }
                    return;
                }

                hoverInteractionRef.current.tooltipPointerDown = true;
                hoverInteractionRef.current.tooltipFocused = false;
            });
            tooltipEl.addEventListener("mouseenter", () => {
                hoverInteractionRef.current.tooltipHovered = true;
                clearHoverCloseTimer();
            });
            tooltipEl.addEventListener("mouseleave", (event) => {
                hoverInteractionRef.current.tooltipHovered = false;
                if (document.activeElement === tooltipEl) {
                    tooltipEl.blur();
                }
                if (isTargetInsideNodes(event.relatedTarget, activeMarkerHoverRef.current?.anchorEl)) {
                    return;
                }
                scheduleCloseHoverInfoWindow(220, activeMarkerHoverRef.current?.markerId ?? null);
            });
            tooltipEl.addEventListener("focusin", () => {
                const fromPointer = hoverInteractionRef.current.tooltipPointerDown;
                hoverInteractionRef.current.tooltipPointerDown = false;
                hoverInteractionRef.current.tooltipFocused = !fromPointer;
                clearHoverCloseTimer();
            });
            tooltipEl.addEventListener("focusout", (event) => {
                hoverInteractionRef.current.tooltipFocused = false;
                if (isTargetInsideNodes(event.relatedTarget, activeMarkerHoverRef.current?.anchorEl, hoverTooltipPortalRef.current)) {
                    return;
                }
                scheduleCloseHoverInfoWindow(220, activeMarkerHoverRef.current?.markerId ?? null);
            });
            floatPane.appendChild(tooltipEl);
            hoverTooltipPortalRef.current = tooltipEl;
        }

        const pixel = getHoverAnchorPixel(anchorEl, position);
        if (!pixel) return;

        hoverTooltipPortalRef.current.innerHTML = content;
        hoverTooltipPortalRef.current.style.left = `${pixel.x}px`;
        hoverTooltipPortalRef.current.style.top = `${pixel.y}px`;
        anchorEl.classList.add("is-hover-active");
        anchorEl.style.zIndex = "1400";
        hoverTooltipPortalRef.current.classList.remove("is-hiding");
        hoverTooltipPortalRef.current.classList.add("is-visible");

        activeMarkerHoverRef.current = { markerId, anchorEl, position, content, contrato };
    };



    const scheduleCloseHoverInfoWindow = (ms = 180, markerId = null) => {
        clearHoverCloseTimer();
        hoverCloseTimerRef.current = setTimeout(() => {
            if (markerId && activeMarkerHoverRef.current?.markerId !== markerId) return;
            if (isHoverInteractionActive()) return;
            closeHoverInfoWindow();
        }, ms);
    };

    const relayoutHoverInfoWindow = () => {
        if (!hoverTooltipPortalRef.current || !activeMarkerHoverRef.current?.position) return;
        const pixel = getHoverAnchorPixel(
            activeMarkerHoverRef.current.anchorEl,
            activeMarkerHoverRef.current.position
        );
        if (!pixel) return;

        hoverTooltipPortalRef.current.style.left = `${pixel.x}px`;
        hoverTooltipPortalRef.current.style.top = `${pixel.y}px`;
    };

    const buildHoverContentContrato = (c) => `
        <div class="info-window-hover-card">
            <button type="button" class="hover-marker-info-button" aria-label="Ver información completa" title="Ver información completa">
                <span aria-hidden="true">i</span>
            </button>
            <div class="info-window-hover-title">${c.PlacaTruck || "Sin placa"}</div>
            <div class="info-window-hover-grid">
            <div class="info-window-hover-device"><strong>Dispositivo:</strong> ${c.FKLokDeviceID || "-"}</div>
            <div><strong>Contenedor:</strong> ${c.ContainerNum || "-"}</div>
            <div><strong>Ref:</strong> ${c.Ref || "-"}</div>
            <div><strong>Empresa:</strong> ${c.NombreEmpresa || "-"}</div>
            <div><strong>Últ. reporte:</strong> ${formattedGlobalDate(c.LoksysServerTime) ?? "-"}</div>
            </div>
        </div>
    `;

    const escapeMarkerHtml = (value) =>
        String(value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");

    const buildContractMarkerHtml = (contrato) => {
        const getMarkerLabelValue = (option) => {
            if (option.key === "driver") {
                return contrato?.NombreConductor || contrato?.Conductor || contrato?.DriverName;
            }
            return contrato?.[option.field];
        };
        const labelRows = markerLabelFields
            .map((fieldKey) => MARKER_LABEL_FIELD_OPTIONS.find((option) => option.key === fieldKey))
            .filter(Boolean)
            .map((option, index) => {
                const value = String(getMarkerLabelValue(option) ?? "-").trim() || "-";
                return `<div class="${index === 0 ? "marker-plate-badge__plate" : "marker-plate-badge__line"}" title="${escapeMarkerHtml(`${option.label}: ${value}`)}">
                    ${escapeMarkerHtml(value)}
                </div>`;
            });
        const badgeHtml =
            showPlateBadges && labelRows.length > 0
                ? `<div class="marker-plate-badge">${labelRows.join("")}</div>`
                : "";
        return `
            <div class="marker-plate-wrap">
                ${badgeHtml}
                <img class="marker-icon" src="/images/mapcenter_icons/${contrato?.iconmapcenter}.png" style="width:40px;height:40px;" />
            </div>
        `;
    };

    useEffect(() => {
        const handlePointerDownOutsideHover = (event) => {
            if (!activeMarkerHoverRef.current) return;
            if (isTargetInsideActiveHover(event.target)) return;
            closeHoverInfoWindow();
        };

        const handleFocusOutsideHover = (event) => {
            if (!activeMarkerHoverRef.current) return;
            if (isTargetInsideActiveHover(event.target)) return;
            closeHoverInfoWindow();
        };

        document.addEventListener("pointerdown", handlePointerDownOutsideHover, true);
        document.addEventListener("focusin", handleFocusOutsideHover, true);

        return () => {
            document.removeEventListener("pointerdown", handlePointerDownOutsideHover, true);
            document.removeEventListener("focusin", handleFocusOutsideHover, true);
        };
    }, []);


    const saveGeoPreviousView = () => {
        const map = mapRef.current;
        if (!map) return;
        if (prevGeoViewRef.current) return;

        const center = map.getCenter();
        prevGeoViewRef.current = {
            center: center ? { lat: center.lat(), lng: center.lng() } : null,
            zoom: map.getZoom(),
        };
    };

    const restoreGeoPreviousView = () => {
        const map = mapRef.current;
        const prev = prevGeoViewRef.current;
        if (!map || !prev) return;

        if (prev.center) map.panTo(prev.center);
        if (geoZoomTransitionRef.current) {
            window.clearInterval(geoZoomTransitionRef.current);
            geoZoomTransitionRef.current = null;
        }

        if (typeof prev.zoom === "number") {
            let currentZoom = map.getZoom();
            const targetZoom = prev.zoom;

            if (typeof currentZoom === "number" && currentZoom !== targetZoom) {
                const direction = targetZoom > currentZoom ? 1 : -1;
                geoZoomTransitionRef.current = window.setInterval(() => {
                    const nextZoom = currentZoom + direction;
                    const reachedTarget = direction > 0
                        ? nextZoom >= targetZoom
                        : nextZoom <= targetZoom;
                    currentZoom = reachedTarget ? targetZoom : nextZoom;
                    map.setZoom(currentZoom);

                    if (currentZoom === targetZoom) {
                        window.clearInterval(geoZoomTransitionRef.current);
                        geoZoomTransitionRef.current = null;
                    }
                }, 100);
            }
        }
        prevGeoViewRef.current = null;
    };

    const fitToPolygons = (polygons) => {
        const map = mapRef.current;
        if (!map || !polygons?.length) return;

        const bounds = new google.maps.LatLngBounds();
        let hasPoints = false;

        polygons.forEach((poly) => {
            const path = poly.getPath();
            if (!path) return;
            for (let i = 0; i < path.getLength(); i++) {
                bounds.extend(path.getAt(i));
                hasPoints = true;
            }
        });

        if (hasPoints) {
            map.fitBounds(bounds, 80);
            google.maps.event.addListenerOnce(map, "idle", () => {
                if (map.getZoom() > 17) map.setZoom(17);
            });
        }
    };

    const clearGeofenceActionsOverlay = useCallback(() => {
        if (typeof geofenceActionsOverlayCleanupRef.current === "function") {
            geofenceActionsOverlayCleanupRef.current();
        }
        geofenceActionsOverlayCleanupRef.current = null;
        geofenceActionsOverlayElementRef.current = null;
        if (geofenceActionsOverlayRef.current?.setMap) {
            geofenceActionsOverlayRef.current.setMap(null);
        }
        geofenceActionsOverlayRef.current = null;
    }, []);

    const clearGeocercaDecoratorLines = useCallback(() => {
        geocercaDecoratorLinesRef.current.forEach((line) => line.setMap(null));
        geocercaDecoratorLinesRef.current = [];
    }, []);

    const clearGeocercaPulseAnimations = useCallback(() => {
        geocercaPulseAnimationsRef.current.forEach((animationState) => {
            if (animationState?.frameId) window.cancelAnimationFrame(animationState.frameId);
            if (animationState) animationState.cancelled = true;
        });
        geocercaPulseAnimationsRef.current = [];
    }, []);

    const createCandidateGeocercaHatch = (coords, strokeColor = "#2f6fed") => {
        if (!window.google?.maps || !Array.isArray(coords) || coords.length < 3) return [];

        const normalizedCoords = coords
            .filter((coord) => Number.isFinite(Number(coord?.lat)) && Number.isFinite(Number(coord?.lng)))
            .map((coord) => ({ lat: Number(coord.lat), lng: Number(coord.lng) }));

        if (normalizedCoords.length < 3) return [];

        const polygonCoords = normalizedCoords.filter((coord, index) => {
            if (index === 0) return true;
            const previousCoord = normalizedCoords[index - 1];
            return previousCoord.lat !== coord.lat || previousCoord.lng !== coord.lng;
        });

        if (polygonCoords.length >= 2) {
            const firstCoord = polygonCoords[0];
            const lastCoord = polygonCoords[polygonCoords.length - 1];
            if (firstCoord.lat === lastCoord.lat && firstCoord.lng === lastCoord.lng) {
                polygonCoords.pop();
            }
        }

        if (polygonCoords.length < 3) return [];

        const lines = [];
        const lats = polygonCoords.map((coord) => coord.lat);
        const lngs = polygonCoords.map((coord) => coord.lng);
        const minLat = Math.min(...lats);
        const maxLat = Math.max(...lats);
        const minLng = Math.min(...lngs);
        const maxLng = Math.max(...lngs);

        if (!Number.isFinite(minLat) || !Number.isFinite(maxLat) || !Number.isFinite(minLng) || !Number.isFinite(maxLng)) {
            return [];
        }

        const latRange = Math.max(maxLat - minLat, 0.0002);
        const lngRange = Math.max(maxLng - minLng, 0.0002);
        const diagonalSpan = Math.sqrt((latRange ** 2) + (lngRange ** 2));
        const spacing = Math.max(diagonalSpan / 10, 0.00012);
        const extension = diagonalSpan * 1.6;
        const slopeFactor = latRange / lngRange;

        const almostEqual = (a, b, tolerance = 1e-7) => Math.abs(a - b) <= tolerance;
        const pointsEqual = (pointA, pointB, tolerance = 1e-7) =>
            almostEqual(pointA.lat, pointB.lat, tolerance) && almostEqual(pointA.lng, pointB.lng, tolerance);

        const pointInPolygon = (point, polygon) => {
            let inside = false;
            for (let index = 0, previousIndex = polygon.length - 1; index < polygon.length; previousIndex = index++) {
                const current = polygon[index];
                const previous = polygon[previousIndex];
                const intersects =
                    ((current.lng > point.lng) !== (previous.lng > point.lng)) &&
                    (point.lat < (((previous.lat - current.lat) * (point.lng - current.lng)) / ((previous.lng - current.lng) || Number.EPSILON)) + current.lat);
                if (intersects) inside = !inside;
            }
            return inside;
        };

        const segmentIntersection = (startA, endA, startB, endB) => {
            const denominator =
                ((endA.lng - startA.lng) * (endB.lat - startB.lat)) -
                ((endA.lat - startA.lat) * (endB.lng - startB.lng));

            if (Math.abs(denominator) < 1e-12) return null;

            const deltaLat = startB.lat - startA.lat;
            const deltaLng = startB.lng - startA.lng;

            const ua = (((endB.lng - startB.lng) * deltaLat) - ((endB.lat - startB.lat) * deltaLng)) / denominator;
            const ub = (((endA.lng - startA.lng) * deltaLat) - ((endA.lat - startA.lat) * deltaLng)) / denominator;

            if (ua < -1e-7 || ua > 1 + 1e-7 || ub < -1e-7 || ub > 1 + 1e-7) return null;

            return {
                lat: startA.lat + (ua * (endA.lat - startA.lat)),
                lng: startA.lng + (ua * (endA.lng - startA.lng)),
            };
        };

        const clipLineSegmentsToPolygon = (lineStart, lineEnd, polygon) => {
            const candidates = [];
            const addCandidate = (point) => {
                if (!point) return;
                if (candidates.some((candidate) => pointsEqual(candidate, point))) return;
                candidates.push(point);
            };

            if (pointInPolygon(lineStart, polygon)) addCandidate(lineStart);
            if (pointInPolygon(lineEnd, polygon)) addCandidate(lineEnd);

            for (let index = 0; index < polygon.length; index += 1) {
                const edgeStart = polygon[index];
                const edgeEnd = polygon[(index + 1) % polygon.length];
                addCandidate(segmentIntersection(lineStart, lineEnd, edgeStart, edgeEnd));
            }

            if (candidates.length < 2) return [];

            const vectorLat = lineEnd.lat - lineStart.lat;
            const vectorLng = lineEnd.lng - lineStart.lng;
            const lineLengthSquared = (vectorLat ** 2) + (vectorLng ** 2) || 1;

            const orderedPoints = candidates
                .map((point) => ({
                    ...point,
                    projection: (((point.lat - lineStart.lat) * vectorLat) + ((point.lng - lineStart.lng) * vectorLng)) / lineLengthSquared,
                }))
                .sort((pointA, pointB) => pointA.projection - pointB.projection);

            const clippedSegments = [];
            for (let index = 0; index < orderedPoints.length - 1; index += 1) {
                const startPoint = orderedPoints[index];
                const endPoint = orderedPoints[index + 1];
                const midpoint = {
                    lat: (startPoint.lat + endPoint.lat) / 2,
                    lng: (startPoint.lng + endPoint.lng) / 2,
                };

                if (!pointInPolygon(midpoint, polygon)) continue;
                clippedSegments.push([
                    { lat: startPoint.lat, lng: startPoint.lng },
                    { lat: endPoint.lat, lng: endPoint.lng },
                ]);
            }

            return clippedSegments;
        };

        const stripeCount = Math.max(8, Math.min(18, Math.round(diagonalSpan / spacing) + 2));
        const totalSpan = spacing * stripeCount;

        for (let index = -2; index <= stripeCount + 2; index += 1) {
            const offset = (index * spacing) - (totalSpan / 2);
            const lineStart = {
                lat: maxLat + extension - (offset * slopeFactor),
                lng: minLng - extension,
            };
            const lineEnd = {
                lat: minLat - extension - (offset * slopeFactor),
                lng: maxLng + extension,
            };

            const clippedSegments = clipLineSegmentsToPolygon(lineStart, lineEnd, polygonCoords);
            clippedSegments.forEach((segmentPath) => {
                const line = new google.maps.Polyline({
                    path: segmentPath,
                    strokeColor,
                    strokeOpacity: 0.42,
                    strokeWeight: 2,
                    clickable: false,
                    zIndex: 3,
                    map: mapRef.current,
                });
                lines.push(line);
                geocercaDecoratorLinesRef.current.push(line);
            });
        }

        return lines;
    };

    const getPolygonActionAnchor = (polygon) => {
        const path = polygon?.getPath?.();
        if (!path || path.getLength() === 0) return null;

        let north = -Infinity;
        let west = Infinity;
        let east = -Infinity;

        for (let i = 0; i < path.getLength(); i++) {
            const point = path.getAt(i);
            const lat = point.lat();
            const lng = point.lng();
            if (lat > north) north = lat;
            if (lng < west) west = lng;
            if (lng > east) east = lng;
        }

        if (!Number.isFinite(north) || !Number.isFinite(west) || !Number.isFinite(east)) return null;
        return { lat: north, lng: (west + east) / 2 };
    };

    const renderGeofenceActionsOverlay = (geocerca, polygon, options = {}) => {
        if (!mapRef.current || !window.google?.maps || !geocerca || !polygon) return;
        const isEditingPoints = options.editingPoints === true;
        const geocercaId = String(geocerca?.ID ?? geocerca?.id ?? "");
        const geocercaName = escapeTooltipHtml(
            geocerca?.Nombre ??
            geocerca?.nombre ??
            geocerca?.Descripcion ??
            `Geocerca ${geocercaId}`
        );
        const geocercaDescription = escapeTooltipHtml(
            geocerca?.Descripcion ??
            geocerca?.description ??
            ""
        );
        const activeTrayecto = options.activeTrayecto ?? selectedGeoruta;
        const activeTrayectoGeocercaIds = Array.isArray(options.trayectoSelectedIds)
            ? options.trayectoSelectedIds.map(String)
            : trayectoGeocercaSelectedIds;
        const isInActiveTrayecto = activeTrayectoGeocercaIds.includes(geocercaId);
        const canAddToActiveTrayecto =
            isGeocercasOnly &&
            Boolean(activeTrayecto) &&
            geocercaId &&
            !isInActiveTrayecto;
        const canRemoveFromActiveTrayecto =
            isGeocercasOnly &&
            Boolean(activeTrayecto) &&
            geocercaId &&
            isInActiveTrayecto;
        const geocercaCenter = parseGeocercaCenter(geocerca);
        const startPointId = String(options.startPointId ?? trayectoStartPoint?.id ?? "");
        const endPointId = String(options.endPointId ?? trayectoEndPoint?.id ?? "");
        const hasStartPoint = Boolean(startPointId);
        const isStartPoint = startPointId === geocercaId;
        const isEndPoint = endPointId === geocercaId;
        const canMarkEndPoint =
            isGeocercasOnly &&
            Boolean(activeTrayecto) &&
            hasStartPoint &&
            startPointId !== geocercaId;
        const geocercaTypeColors = getGeocercaColors(geocerca);

        clearGeofenceActionsOverlay();

        const anchor = getPolygonActionAnchor(polygon);
        if (!anchor) return;

        const html = `
            <div style="transform: translateY(-20px);">
                <div style="
                    position:relative;
                    display:grid;
                    gap:12px;
                    min-width:220px;
                    max-width:280px;
                    padding:12px;
                    border-radius:18px;
                    background:rgba(255,255,255,0.96);
                    border:1px solid rgba(15,76,129,0.16);
                    box-shadow:0 14px 30px rgba(7,53,79,0.16);
                    backdrop-filter:blur(12px);
                ">
                    <button data-geo-action="close" type="button" aria-label="Cerrar tooltip" title="Cerrar" style="
                        position:absolute;
                        top:8px;
                        right:8px;
                        width:28px;
                        height:28px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:rgba(15,76,129,0.08);
                        color:#31546f;
                        box-shadow:0 4px 10px rgba(15,76,129,0.10);
                        cursor:pointer;
                    ">
                        <i class="bx bx-x" style="font-size:18px;"></i>
                    </button>
                    <div style="display:grid; gap:4px;">
                        <div style="
                            color:#16324a;
                            font-size:15px;
                            font-weight:800;
                            line-height:1.25;
                            text-align:center;
                            word-break:break-word;
                        ">
                            ${geocercaName}
                        </div>
                        ${geocercaDescription ? `
                        <div style="
                            color:#5b7083;
                            font-size:12px;
                            line-height:1.4;
                            text-align:center;
                            word-break:break-word;
                        ">
                            ${geocercaDescription}
                        </div>
                        ` : ""}
                    </div>
                    <div style="
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        gap:10px;
                        flex-wrap:wrap;
                    ">
                    <button data-geo-action="reset" type="button" style="
                        width:38px;
                        height:38px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:linear-gradient(135deg, rgba(255,255,255,0.98), rgba(237,246,252,0.98));
                        color:#0f4c81;
                        box-shadow:0 8px 18px rgba(15,76,129,0.10);
                        cursor:pointer;
                    ">
                        <i class="bx bx-reset" style="font-size:18px;"></i>
                    </button>
                    <button data-geo-action="edit" type="button" style="
                        width:38px;
                        height:38px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:linear-gradient(135deg, #0f4c81 0%, #006699 55%, #1aa0d8 100%);
                        color:#ffffff;
                        box-shadow:0 10px 20px rgba(15,76,129,0.18);
                        cursor:pointer;
                    ">
                        <i class="bx ${isEditingPoints ? "bx-save" : "bx-pencil"}" style="font-size:18px;"></i>
                    </button>
                    ${isGeocercasOnly && activeTrayecto && (!hasStartPoint || isStartPoint) ? `
                    <button data-geo-action="start-point" type="button" title="${isStartPoint ? "Quitar punto inicial" : "Marcar como punto inicial"}" aria-label="${isStartPoint ? "Quitar punto inicial" : "Marcar como punto inicial"}" style="
                        width:38px;
                        height:38px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:${isStartPoint ? "#0f4c81" : "linear-gradient(135deg, #dbeafe 0%, #93c5fd 100%)"};
                        color:${isStartPoint ? "#ffffff" : "#1d4ed8"};
                        box-shadow:0 10px 20px ${isStartPoint ? "rgba(15,76,129,0.26)" : "rgba(59,130,246,0.22)"};
                        cursor:pointer;
                    ">
                        <i class="bx ${isStartPoint ? "bx-minus" : "bx-map-pin"}" style="font-size:18px;"></i>
                    </button>
                    ` : ""}
                    ${canMarkEndPoint ? `
                    <button data-geo-action="end-point" type="button" title="${isEndPoint ? "Quitar punto final" : "Marcar como punto final"}" aria-label="${isEndPoint ? "Quitar punto final" : "Marcar como punto final"}" style="
                        width:38px;
                        height:38px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:${isEndPoint ? "#7c3aed" : "linear-gradient(135deg, #ede9fe 0%, #c4b5fd 100%)"};
                        color:${isEndPoint ? "#ffffff" : "#6d28d9"};
                        box-shadow:0 10px 20px ${isEndPoint ? "rgba(124,58,237,0.28)" : "rgba(139,92,246,0.20)"};
                        cursor:pointer;
                    ">
                        <i class="bx ${isEndPoint ? "bx-x" : "bx-flag"}" style="font-size:18px;"></i>
                    </button>
                    ` : ""}
                    ${canAddToActiveTrayecto || canRemoveFromActiveTrayecto ? `
                    <button data-geo-action="toggle-trayecto" type="button" title="${canRemoveFromActiveTrayecto ? "Quitar del trayecto activo" : "Agregar al trayecto activo"}" aria-label="${canRemoveFromActiveTrayecto ? "Quitar geocerca del trayecto activo" : "Agregar geocerca al trayecto activo"}" style="
                        width:38px;
                        height:38px;
                        border:none;
                        border-radius:999px;
                        display:grid;
                        place-items:center;
                        background:${canRemoveFromActiveTrayecto ? "#b42318" : geocercaTypeColors.stroke};
                        color:#ffffff;
                        box-shadow:0 10px 20px ${canRemoveFromActiveTrayecto ? "rgba(180,35,24,0.34)" : `${geocercaTypeColors.stroke}55`};
                        cursor:pointer;
                    ">
                        <i class="bx ${canRemoveFromActiveTrayecto ? "bx-minus" : "bx-plus"}" style="font-size:22px;"></i>
                    </button>
                    ` : ""}
                    </div>
                </div>
            </div>
        `;

        geofenceActionsOverlayRef.current = new HtmlMarker(
            new window.google.maps.LatLng(anchor.lat, anchor.lng),
            mapRef.current,
            html,
            null,
            (div, overlay) => {
                geofenceActionsOverlayElementRef.current = div;

                const stop = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                };

                const closeButton = div.querySelector('[data-geo-action="close"]');
                const resetButton = div.querySelector('[data-geo-action="reset"]');
                const editButton = div.querySelector('[data-geo-action="edit"]');
                const startPointButton = div.querySelector('[data-geo-action="start-point"]');
                const endPointButton = div.querySelector('[data-geo-action="end-point"]');
                const toggleTrayectoButton = div.querySelector('[data-geo-action="toggle-trayecto"]');

                const handleOutsidePointerDown = (event) => {
                    const overlayElement = geofenceActionsOverlayElementRef.current;
                    const target = event.target;
                    if (!overlayElement || !target) return;
                    if (overlayElement.contains(target)) return;
                    clearGeofenceActionsOverlay();
                };

                const map = mapRef.current;
                const mapDragStartListener = map?.addListener?.("dragstart", () => {
                    clearGeofenceActionsOverlay();
                });
                const mapZoomChangedListener = map?.addListener?.("zoom_changed", () => {
                    clearGeofenceActionsOverlay();
                });
                const mapClickListener = map?.addListener?.("click", () => {
                    clearGeofenceActionsOverlay();
                });
                window.addEventListener("mousedown", handleOutsidePointerDown);

                geofenceActionsOverlayCleanupRef.current = () => {
                    window.removeEventListener("mousedown", handleOutsidePointerDown);
                    if (mapDragStartListener) google.maps.event.removeListener(mapDragStartListener);
                    if (mapZoomChangedListener) google.maps.event.removeListener(mapZoomChangedListener);
                    if (mapClickListener) google.maps.event.removeListener(mapClickListener);
                    geofenceActionsOverlayCleanupRef.current = null;
                    geofenceActionsOverlayElementRef.current = null;
                };

                closeButton?.addEventListener("click", (event) => {
                    stop(event);
                    clearGeofenceActionsOverlay();
                });

                resetButton?.addEventListener("click", (event) => {
                    stop(event);
                    resetGeocercasExperience();
                });

                editButton?.addEventListener("click", (event) => {
                    stop(event);
                    setGeoFilter({ showAll: false, selectedIds: [String(geocerca?.ID)] });
                    validateFilterGeocercas({ showAll: false, selectedIds: [String(geocerca?.ID)] });
                    if (isEditingPoints) {
                        openGeocercaEditModal(geocerca);
                        return;
                    }
                    fitToPolygons([polygon]);
                    startGeocercaPointEdit(geocerca);
                });

                startPointButton?.addEventListener("click", (event) => {
                    stop(event);
                    if (isStartPoint) {
                        setTrayectoStartPoint(null);
                        if (isEndPoint) setTrayectoEndPoint(null);
                        toast.success("Punto inicial retirado de la georuta.");
                        clearGeofenceActionsOverlay();
                        return;
                    }

                    setTrayectoStartPoint({
                        id: geocercaId,
                        name: geocerca?.Nombre ?? geocerca?.nombre ?? geocerca?.Descripcion ?? `Geocerca ${geocercaId}`,
                        lat: geocercaCenter?.lat ?? null,
                        lng: geocercaCenter?.lng ?? null,
                    });

                    if (endPointId === geocercaId) {
                        setTrayectoEndPoint(null);
                    }

                    toast.success("Punto inicial asignado a la georuta.");
                    clearGeofenceActionsOverlay();
                });

                endPointButton?.addEventListener("click", (event) => {
                    stop(event);
                    if (isEndPoint) {
                        setTrayectoEndPoint(null);
                        toast.success("Punto final retirado de la georuta.");
                        clearGeofenceActionsOverlay();
                        return;
                    }

                    setTrayectoEndPoint({
                        id: geocercaId,
                        name: geocerca?.Nombre ?? geocerca?.nombre ?? geocerca?.Descripcion ?? `Geocerca ${geocercaId}`,
                        lat: geocercaCenter?.lat ?? null,
                        lng: geocercaCenter?.lng ?? null,
                    });
                    toast.success("Punto final asignado a la georuta.");
                    clearGeofenceActionsOverlay();
                });

                toggleTrayectoButton?.addEventListener("click", async (event) => {
                    stop(event);
                    const geocercaName =
                        geocerca?.Nombre ??
                        geocerca?.nombre ??
                        geocerca?.Descripcion ??
                        `Geocerca ${geocercaId}`;
                    const isRemoving = activeTrayectoGeocercaIds.includes(geocercaId);
                    const confirmation = await Swal.fire({
                        icon: "question",
                        title: isRemoving ? "Quitar geocerca" : "Agregar geocerca",
                        text: isRemoving
                            ? `Deseas quitar "${geocercaName}" del arreglo temporal del trayecto activo?`
                            : `Deseas agregar "${geocercaName}" al arreglo temporal del trayecto activo?`,
                        showCancelButton: true,
                        confirmButtonText: isRemoving ? "Si, quitar" : "Si, agregar",
                        cancelButtonText: "Cancelar",
                        confirmButtonColor: isRemoving ? "#b42318" : "#7e22ce",
                    });
                    if (!confirmation.isConfirmed) return;

                    setTrayectoGeocercaSelectedIds((currentIds) =>
                        isRemoving
                            ? currentIds.filter((currentId) => currentId !== geocercaId)
                            : currentIds.includes(geocercaId)
                                ? currentIds
                                : [...currentIds, geocercaId]
                    );
                    clearGeofenceActionsOverlay();
                    toast.success(
                        isRemoving
                            ? "Geocerca eliminada del trayecto activo."
                            : "Geocerca agregada al trayecto activo."
                    );
                });

                overlay.setBasePosition(new window.google.maps.LatLng(anchor.lat, anchor.lng));
            }
        );
    };

    const dibujarGeocercas = (geocercasToDraw, doFit = false, options = {}) => {
        if (!mapRef.current || !window.google?.maps) return;

        clearGeocercaPulseAnimations();
        clearGeocercaDecoratorLines();
        geocercaPolygonsRef.current.forEach((p) => p.setMap(null));
        geocercaPolygonsRef.current = [];
        setGeocercaPolygons([]);
        clearGeofenceActionsOverlay();

        if (geofenceInfoWindowRef.current) {
            geofenceInfoWindowRef.current.close();
            geofenceInfoWindowRef.current = null;
        }

        const toDraw = (geocercasToDraw || []).filter((g) => g?.Vertices || g?.vertices);
        if (!toDraw.length) return;

        const highlightedIds = new Set((options.highlightedIds || []).map(String));
        const candidateIds = new Set((options.candidateIds || []).map(String));
        const startPointId = String(options.startPointId ?? "");
        const endPointId = String(options.endPointId ?? "");
        const newPolygons = toDraw.map((g) => {
            const rawVerts = g.vertices ?? g.Vertices;
            const geocercaRecordId = String(g?.ID ?? g?.id);

            const coords = rawVerts
                .split("/")
                .map((str) => str.replace(/[()]/g, "").split(",").map(Number))
                .map(([lat, lng]) => ({ lat, lng }));

            const isHighlighted = highlightedIds.has(geocercaRecordId);
            const isCandidate = candidateIds.has(geocercaRecordId);
            const isStartPoint = startPointId === geocercaRecordId;
            const isEndPoint = endPointId === geocercaRecordId;
            const isTrayectoStyled = isHighlighted || isCandidate || isStartPoint || isEndPoint;
            const colors = getGeocercaColors(g);
            const trayectoStrokeColor = isStartPoint
                ? "#1d4ed8"
                : isEndPoint
                    ? "#7c3aed"
                    : isHighlighted
                        ? "#15803d"
                        : isCandidate
                            ? "#f87171"
                            : colors.stroke;
            const trayectoFillColor = isStartPoint
                ? "#93c5fd"
                : isEndPoint
                    ? "#c4b5fd"
                    : isHighlighted
                        ? "#86efac"
                        : isCandidate
                            ? "#fca5a5"
                            : colors.fill;
            const trayectoBaseFillOpacity = isStartPoint || isEndPoint
                ? 0.34
                : isHighlighted
                    ? 0.24
                    : isCandidate
                        ? 0.24
                        : 0.32;
            const trayectoPulseFillDelta = isStartPoint || isEndPoint
                ? 0.16
                : isHighlighted
                    ? 0.1
                    : isCandidate
                        ? 0.12
                        : 0.14;

            const polygon = new google.maps.Polygon({
                paths: coords,
                strokeColor: isTrayectoStyled ? trayectoStrokeColor : colors.stroke,
                strokeOpacity: isTrayectoStyled ? 0.95 : 0.8,
                strokeWeight: isStartPoint || isEndPoint ? 5 : isTrayectoStyled ? 4 : 3,
                fillColor: isTrayectoStyled ? trayectoFillColor : colors.fill,
                fillOpacity: isTrayectoStyled ? trayectoBaseFillOpacity : 0.35,
                clickable: true,
            });

            polygon.setMap(mapRef.current);

            const candidateDecoratorLines = isTrayectoStyled
                ? createCandidateGeocercaHatch(coords, trayectoStrokeColor)
                : [];

            if ((isHighlighted && options.pulse) || isCandidate || isStartPoint || isEndPoint) {
                const animationDuration = isStartPoint || isEndPoint ? 1800 : isCandidate ? 2400 : 2000;
                const phaseOffset = isStartPoint
                    ? Math.PI / 6
                    : isEndPoint
                        ? Math.PI / 3
                        : isCandidate
                            ? Math.PI / 4
                            : 0;
                const animationState = {
                    frameId: null,
                    cancelled: false,
                };
                let animationStartedAt = null;

                const animatePulse = (timestamp) => {
                    if (animationState.cancelled || !polygon.getMap()) return;
                    if (!animationStartedAt) animationStartedAt = timestamp;

                    const elapsed = timestamp - animationStartedAt;
                    const normalizedTime = elapsed / animationDuration;
                    const wave = (1 - Math.cos((normalizedTime * Math.PI * 2) + phaseOffset)) / 2;
                    const easedWave = wave * wave * (3 - (2 * wave));

                    polygon.setOptions({
                        fillOpacity: isTrayectoStyled
                            ? (trayectoBaseFillOpacity + (easedWave * trayectoPulseFillDelta))
                            : (0.22 + (easedWave * 0.4)),
                        strokeOpacity: 0.72 + (easedWave * 0.24),
                        strokeWeight: isStartPoint || isEndPoint
                            ? (4.8 + (easedWave * 1.35))
                            : isTrayectoStyled
                                ? (3.9 + (easedWave * 1.1))
                            : (3 + (easedWave * 2)),
                    });

                    candidateDecoratorLines.forEach((line) => {
                        line.setOptions({
                            strokeOpacity: 0.34 + (easedWave * 0.22),
                            strokeWeight: 1.85 + (easedWave * 0.5),
                        });
                    });

                    animationState.frameId = window.requestAnimationFrame(animatePulse);
                };

                animationState.frameId = window.requestAnimationFrame(animatePulse);
                geocercaPulseAnimationsRef.current.push(animationState);
            }

            google.maps.event.addListener(polygon, "click", () => {
                const isTrayectoAssociationMode = Boolean(options.activeTrayecto);
                if (isTrayectoAssociationMode && geofenceInfoWindowRef.current) {
                    geofenceInfoWindowRef.current.close();
                    geofenceInfoWindowRef.current = null;
                }
                if (!isTrayectoAssociationMode && isHighlighted && options.onHighlightedClick) {
                    options.onHighlightedClick(geocercaRecordId);
                    return;
                }

                if (!isTrayectoAssociationMode) {
                    setGeoFilter({ showAll: false, selectedIds: [String(g?.ID)] });
                    validateFilterGeocercas({ showAll: false, selectedIds: [String(g?.ID)] });
                }

                renderGeofenceActionsOverlay(g, polygon, {
                    activeTrayecto: options.activeTrayecto,
                    trayectoSelectedIds: options.highlightedIds,
                    startPointId: options.startPointId,
                    endPointId: options.endPointId,
                });
            });

            return polygon;
        });

        setGeocercaPolygons(newPolygons);
        geocercaPolygonsRef.current = newPolygons;
        if (newPolygons.length === 1 && toDraw.length === 1) {
            const selectedGeocerca = toDraw[0];
            const selectedPolygon = newPolygons[0];
            renderGeofenceActionsOverlay(selectedGeocerca, selectedPolygon);

            // fitBounds dispara un nuevo ciclo de render de Google Maps. Se
            // reanclan las acciones al finalizar para que la limpieza del
            // borrador anterior no retire el overlay de la seleccion nueva.
            if (doFit) {
                google.maps.event.addListenerOnce(mapRef.current, "idle", () => {
                    if (!geocercaPolygonsRef.current.includes(selectedPolygon)) return;
                    renderGeofenceActionsOverlay(selectedGeocerca, selectedPolygon);
                });
            }
        }
        if (doFit) fitToPolygons(newPolygons);
    };

    const toggleTrayectoGeocercaFromMap = useCallback((geocercaId) => {
        setTrayectoGeocercaSelectedIds((currentIds) =>
            currentIds.includes(String(geocercaId))
                ? currentIds.filter((currentId) => currentId !== String(geocercaId))
                : [...currentIds, String(geocercaId)]
        );
    }, []);

    const drawGeocercasTrayecto = useCallback((
        geocercas,
        selectedIds = [],
        candidateIds = [],
        activeTrayecto = null,
        trayectoPoints = {}
    ) => {
        const allGeocercas = Array.isArray(geocercas) ? geocercas : [];
        dibujarGeocercas(allGeocercas, false, {
            highlightedIds: selectedIds,
            candidateIds,
            pulse: true,
            onHighlightedClick: toggleTrayectoGeocercaFromMap,
            activeTrayecto,
            startPointId: trayectoPoints.startPointId,
            endPointId: trayectoPoints.endPointId,
        });
    }, [toggleTrayectoGeocercaFromMap]);

    const clearGeocercasTrayecto = useCallback(() => {
        clearGeocercaPulseAnimations();
        clearGeocercaDecoratorLines();
        geocercaPolygonsRef.current.forEach((polygon) => polygon.setMap(null));
        geocercaPolygonsRef.current = [];
        setGeocercaPolygons([]);
        clearGeofenceActionsOverlay();
    }, [clearGeocercaDecoratorLines, clearGeofenceActionsOverlay]);

    useEffect(() => {
        if (
            !isGeocercasOnly ||
            showAllGeocercasOnMap ||
            !selectedGeoruta ||
            allGeocercasForTrayecto.length === 0
        ) return;

        const selectedIdsSet = new Set((trayectoGeocercaSelectedIds || []).map(String));
        const nearbyCandidateIds = (trayectoNearbyDetectedIds || []).filter(
            (id) => !selectedIdsSet.has(String(id))
        );
        const candidateIdsSet = new Set(nearbyCandidateIds.map(String));
        const selectedGeocercas = allGeocercasForTrayecto.filter((geocerca) =>
            selectedIdsSet.has(getGeocercaRecordId(geocerca))
        );
        const candidateGeocercas = allGeocercasForTrayecto.filter((geocerca) =>
            candidateIdsSet.has(getGeocercaRecordId(geocerca))
        );
        const geocercasToDraw = [...selectedGeocercas];

        candidateGeocercas.forEach((geocerca) => {
            const geocercaId = getGeocercaRecordId(geocerca);
            if (!geocercasToDraw.some((currentGeocerca) => getGeocercaRecordId(currentGeocerca) === geocercaId)) {
                geocercasToDraw.push(geocerca);
            }
        });

        if (geocercasToDraw.length === 0) {
            clearGeocercasTrayecto();
            return;
        }

        drawGeocercasTrayecto(
            geocercasToDraw,
            trayectoGeocercaSelectedIds,
            nearbyCandidateIds,
            selectedGeoruta,
            {
                startPointId: trayectoStartPoint?.id,
                endPointId: trayectoEndPoint?.id,
            }
        );
    }, [
        allGeocercasForTrayecto,
        clearGeocercasTrayecto,
        drawGeocercasTrayecto,
        getGeocercaRecordId,
        isGeocercasOnly,
        selectedGeoruta,
        showAllGeocercasOnMap,
        trayectoEndPoint,
        trayectoNearbyDetectedIds,
        trayectoGeocercaSelectedIds,
        trayectoStartPoint,
    ]);

    const clearArrowLines = () => {
        arrowLinesRef.current.forEach((l) => l.setMap(null));
        arrowLinesRef.current = [];
    };

    const clearTrayectoLines = () => {
        trayectoLinesRef.current.forEach((l) => l.setMap(null));
        trayectoLinesRef.current = [];
    };

    const clearClusters = () => {
        clusterOverlaysRef.current.forEach((o) => o.setMap(null));
        clusterOverlaysRef.current = [];
    };

    const clearPolylines = () => {
        polylineRef.current.forEach((pl) => pl.setMap(null));
        polylineRef.current = [];
    };

    const clearMarkers = () => {
        markersRef.current.forEach(({ overlay, marker }) => {
            if (overlay) overlay.setMap(null);
            if (marker) marker.setMap(null);
        });
        markersRef.current = [];
        Object.values(markersByIdRef.current).forEach(({ overlay }) => {
            if (overlay?.setMap) overlay.setMap(null);
        });
        markersByIdRef.current = {};
    };

    const clearInviasMarkers = () => {
        inviasMarkersRef.current.forEach((marker) => marker.setMap(null));
        inviasMarkersRef.current = [];
        if (inviasInfoWindowRef.current) {
            inviasInfoWindowRef.current.close();
            inviasInfoWindowRef.current = null;
        }
    };

    const clearYellowCircle = () => {
        if (zoomListenerRef.current) {
            google.maps.event.removeListener(zoomListenerRef.current);
            zoomListenerRef.current = null;
        }
        if (circleRef.current) {
            circleRef.current.setMap(null);
            circleRef.current = null;
        }
    };

    const clearCircle = () => {
        if (circleRef.current) {
            circleRef.current.setMap(null);
            circleRef.current = null;
        }
    };

    const clearOverlay = () => {
        if (singleOverlayRef.current) {
            singleOverlayRef.current.setMap(null);
            singleOverlayRef.current = null;
        }
    };

    const clearGeoDraftGeometry = useCallback(() => {
        geoDraftPathListenersRef.current.forEach((listener) => listener?.remove?.());
        geoDraftPathListenersRef.current = [];

        geoDraftPointMarkersRef.current.forEach((marker) => marker?.setMap?.(null));
        geoDraftPointMarkersRef.current = [];

        if (geoDraftPolylineRef.current) {
            geoDraftPolylineRef.current.setMap(null);
            geoDraftPolylineRef.current = null;
        }

        if (geoDraftPreviewPolylineRef.current) {
            geoDraftPreviewPolylineRef.current.setMap(null);
            geoDraftPreviewPolylineRef.current = null;
        }

        if (geoDraftPolygonRef.current) {
            geoDraftPolygonRef.current.setMap(null);
            geoDraftPolygonRef.current = null;
        }
    }, []);

    const normalizeGeoDraftPoint = useCallback((latLngLike) => {
        if (!latLngLike) return null;
        if (typeof latLngLike.lat === "function" && typeof latLngLike.lng === "function") {
            return { lat: latLngLike.lat(), lng: latLngLike.lng() };
        }
        if (typeof latLngLike.lat === "number" && typeof latLngLike.lng === "number") {
            return { lat: latLngLike.lat, lng: latLngLike.lng };
        }
        return null;
    }, []);

    const readGeoDraftPath = useCallback((path) => {
        const points = [];
        if (!path) return points;
        for (let i = 0; i < path.getLength(); i++) {
            const point = path.getAt(i);
            points.push({ lat: point.lat(), lng: point.lng() });
        }
        return points;
    }, []);

    const parseGeocercaVertices = useCallback((vertices) => {
        return String(vertices || "")
            .split("/")
            .map((segment) => segment.replace(/[()]/g, "").split(",").map(Number))
            .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng))
            .map(([lat, lng]) => ({ lat, lng }));
    }, []);

    const buildInitialDraftGuidePoint = useCallback((point) => {
        if (!point) return null;
        const zoom = mapRef.current?.getZoom?.() ?? 2;
        const latOffset = (360 / Math.pow(2, zoom + 8)) * 28;
        return {
            lat: point.lat + latOffset,
            lng: point.lng,
        };
    }, []);

    const renderGeoDraftGeometry = useCallback((points, hoverPoint = null) => {
        if (!mapRef.current || !window.google?.maps) return;

        clearGeoDraftGeometry();

        const normalizedPoints = (Array.isArray(points) ? points : []).filter(
            (point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng)
        );

        if (normalizedPoints.length === 0) return;

        const helperGuidePoint =
            !isGeoDraftClosed && geoDraftMode === "points" && normalizedPoints.length === 1 && !hoverPoint
                ? buildInitialDraftGuidePoint(normalizedPoints[0])
                : null;

        geoDraftPointMarkersRef.current = normalizedPoints.map((point, index) => {
            const marker = new google.maps.Marker({
                map: mapRef.current,
                position: point,
                clickable: normalizedPoints.length >= 3 && index === 0,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: index === 0 ? 6 : 5,
                    fillColor: index === 0 ? "#0f4c81" : "#ffffff",
                    fillOpacity: 1,
                    strokeColor: "#0f4c81",
                    strokeWeight: 2,
                },
                zIndex: 1400 + index,
            });

            if (normalizedPoints.length >= 3 && index === 0) {
                marker.setTitle("Clic para cerrar la geocerca");
                marker.addListener("click", () => {
                    setGeoDraftPoints(normalizedPoints);
                    setIsGeoDraftClosed(true);
                    setGeoDraftHoverPoint(null);
                    geoTrackpadIsDrawingRef.current = false;
                    setIsGeoTrackpadDrawing(false);
                    setIsGeoDraftRegistrationModalOpen(true);
                });
            }

            return marker;
        });

        if (normalizedPoints.length >= 2) {
            geoDraftPolylineRef.current = new google.maps.Polyline({
                path: isGeoDraftClosed && normalizedPoints.length >= 3
                    ? [...normalizedPoints, normalizedPoints[0]]
                    : normalizedPoints,
                strokeColor: "#0f4c81",
                strokeOpacity: 0.95,
                strokeWeight: 3,
                clickable: false,
                zIndex: 1200,
                map: mapRef.current,
            });
        }

        const previewTarget = !isGeoDraftClosed && geoDraftMode === "points"
            ? (hoverPoint || helperGuidePoint)
            : null;
        if (previewTarget) {
            geoDraftPreviewPolylineRef.current = new google.maps.Polyline({
                path: [normalizedPoints[normalizedPoints.length - 1], previewTarget],
                strokeColor: "#0f4c81",
                strokeOpacity: 0.55,
                strokeWeight: 2,
                clickable: false,
                zIndex: 1199,
                map: mapRef.current,
            });
        }

        if (isGeoDraftClosed && normalizedPoints.length >= 3) {
            const polygon = new google.maps.Polygon({
                paths: normalizedPoints,
                strokeColor: "#0f4c81",
                strokeOpacity: 0.95,
                strokeWeight: 3,
                fillColor: "#0f4c81",
                fillOpacity: 0.22,
                editable: true,
                clickable: false,
                map: mapRef.current,
            });

            const path = polygon.getPath();
            const syncPath = () => setGeoDraftPoints(readGeoDraftPath(path));
            geoDraftPathListenersRef.current = [
                google.maps.event.addListener(path, "set_at", syncPath),
                google.maps.event.addListener(path, "insert_at", syncPath),
                google.maps.event.addListener(path, "remove_at", syncPath),
            ];
            geoDraftPolygonRef.current = polygon;

            const activeDraftGeocerca = activeGeoDraftRecordRef.current || selectedGeocercaRecord;
            if (geoCrudMode === "edit" && activeDraftGeocerca) {
                renderGeofenceActionsOverlay(activeDraftGeocerca, polygon, { editingPoints: true });
            }
        }
    }, [buildInitialDraftGuidePoint, clearGeoDraftGeometry, geoCrudMode, geoDraftMode, isGeoDraftClosed, readGeoDraftPath, selectedGeocercaRecord]);

    const resetGeoDraft = useCallback(() => {
        activeGeoDraftRecordRef.current = null;
        geoTrackpadIsDrawingRef.current = false;
        setIsGeoTrackpadDrawing(false);
        setGeoDraftMode("points");
        setGeoDraftName("");
        setGeoDraftDescription("");
        setGeoDraftCategory("1");
        setGeoDraftActive(true);
        setGeoDraftCode("");
        setGeoDraftCompany("0");
        setGeoDraftCompanies(["0"]);
        setGeoCompanySearch("");
        setGeoDraftPoints([]);
        setGeoDraftHoverPoint(null);
        setGeoDrawTooltip(null);
        setIsGeoDraftClosed(false);
        setIsGeoDraftRegistrationModalOpen(false);
        clearGeoDraftGeometry();
    }, [clearGeoDraftGeometry]);

    const restartGeoDraftGeometry = useCallback(() => {
        geoTrackpadIsDrawingRef.current = false;
        setIsGeoTrackpadDrawing(false);
        setGeoDraftPoints([]);
        setGeoDraftHoverPoint(null);
        setGeoDrawTooltip(null);
        setIsGeoDraftClosed(false);
        setIsGeoDraftRegistrationModalOpen(false);
        clearGeoDraftGeometry();
        toast("Geocerca reiniciada. Puedes comenzar a dibujar nuevamente.");
    }, [clearGeoDraftGeometry]);

    const startGeoDraft = useCallback((mode = "points") => {
        activeGeoDraftRecordRef.current = null;
        setGeoCrudMode("create");
        setGeoDraftMode(mode);
        setGeoDraftName("");
        setGeoDraftDescription("");
        setGeoDraftCategory("1");
        setGeoDraftActive(true);
        setGeoDraftCode("");
        setGeoDraftCompany("0");
        setGeoDraftCompanies(["0"]);
        setGeoCompanySearch("");
        setGeoDraftPoints([]);
        setGeoDrawTooltip(null);
        setIsGeoDraftClosed(false);
        setIsGeoDraftRegistrationModalOpen(false);
        geoTrackpadIsDrawingRef.current = false;
        setIsGeoTrackpadDrawing(false);
        clearGeoDraftGeometry();
        setOffcanvasOpenGeocercas(true);
    }, [clearGeoDraftGeometry]);

    const cancelGeoDraft = useCallback(() => {
        resetGeoDraft();
        setGeoCrudMode("browse");
        toast("Dibujo de geocerca cancelado.");
    }, [resetGeoDraft]);

    const closeGeoDraftRegistrationModal = useCallback(() => {
        if (geoCrudMode === "create") {
            cancelGeoDraft();
            return;
        }

        setIsGeoDraftRegistrationModalOpen(false);
    }, [cancelGeoDraft, geoCrudMode]);

    const updateGeoDrawTooltip = useCallback((event) => {
        const mouseEvent = event?.domEvent;
        const x = Number(mouseEvent?.clientX);
        const y = Number(mouseEvent?.clientY);

        if (Number.isFinite(x) && Number.isFinite(y)) {
            setGeoDrawTooltip({ x, y });
        }
    }, []);

    const seedGeocercaEditDraft = useCallback((geocercaToEdit = null, openModal = false, overridePoints = null) => {
        const targetGeocerca = geocercaToEdit || selectedGeocercaRecord;
        if (!targetGeocerca) {
            toast("Selecciona una geocerca para editarla.");
            return;
        }
        activeGeoDraftRecordRef.current = targetGeocerca;

        const sanitizedOverridePoints = Array.isArray(overridePoints)
            ? overridePoints.filter((point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng))
            : [];

        const isEditingCurrentDraft =
            geoCrudMode === "edit" &&
            Array.isArray(geoDraftPoints) &&
            geoDraftPoints.length >= 3 &&
            String(targetGeocerca?.ID || "") === String(activeGeoDraftRecordRef.current?.ID || selectedGeocercaRecord?.ID || "");

        // Los puntos leídos del polígono editable son la fuente más reciente.
        // No deben depender de que el estado del filtro ya haya seleccionado la geocerca.
        const resolvedVertices = sanitizedOverridePoints.length >= 3
            ? sanitizedOverridePoints
                .map((point) => `(${Number(point.lat).toFixed(6)},${Number(point.lng).toFixed(6)})`)
                .join("/")
            : isEditingCurrentDraft
                ? geoDraftVerticesString
                : (targetGeocerca?.Vertices || targetGeocerca?.vertices);

        setGeoCrudMode("edit");
        setGeoDraftMode("points");
        setGeoDraftName(targetGeocerca?.Nombre || "");
        setGeoDraftDescription(targetGeocerca?.Descripcion || "");
        setGeoDraftCategory(String(targetGeocerca?.FKCatGeoCerca || 1));
        setGeoDraftActive(normalizeGeocercaActive(
            targetGeocerca?.active ?? targetGeocerca?.Active ?? targetGeocerca?.activo ?? targetGeocerca?.Activo
        ));
        setGeoDraftCode(normalizeGeocercaCode(targetGeocerca?.Codigo ?? targetGeocerca?.Code));
        setGeoDraftCompany(String(targetGeocerca?.FKICEmpresa ?? 0));
        const selectedCompanyIds = String(targetGeocerca?.Empresas || "")
            .split("|")
            .map((id) => id.trim())
            .filter(Boolean);
        setGeoDraftCompanies(selectedCompanyIds.length > 0
            ? selectedCompanyIds
            : [String(targetGeocerca?.FKICEmpresa ?? 0)]);
        setGeoCompanySearch("");
        setGeoDraftPoints(parseGeocercaVertices(resolvedVertices));
        setIsGeoDraftClosed(true);
        setIsGeoDraftRegistrationModalOpen(openModal);
        geoTrackpadIsDrawingRef.current = false;
        setIsGeoTrackpadDrawing(false);
        setOffcanvasOpenGeocercas(true);
    }, [geoCrudMode, geoDraftPoints, geoDraftVerticesString, parseGeocercaVertices, selectedGeocercaRecord]);

    const startGeocercaPointEdit = useCallback((geocercaToEdit = null) => {
        const targetGeocerca = geocercaToEdit || selectedGeocercaRecord;
        if (!targetGeocerca) {
            toast("Selecciona una geocerca para editarla.");
            return;
        }

        setGeoFilter({ showAll: false, selectedIds: [String(targetGeocerca?.ID)] });
        validateFilterGeocercas({ showAll: false, selectedIds: [String(targetGeocerca?.ID)] });
        geocercaPolygonsRef.current.forEach((p) => p.setMap(null));
        geocercaPolygonsRef.current = [];
        setGeocercaPolygons([]);
        clearGeofenceActionsOverlay();
        seedGeocercaEditDraft(targetGeocerca, false);
    }, [clearGeofenceActionsOverlay, geocercaPolygons, seedGeocercaEditDraft, selectedGeocercaRecord]);

    const openGeocercaEditModal = useCallback((geocercaToEdit = null) => {
        const currentDraftPath = geoDraftPolygonRef.current?.getPath?.();
        const currentDraftPoints = currentDraftPath ? readGeoDraftPath(currentDraftPath) : null;
        seedGeocercaEditDraft(geocercaToEdit, true, currentDraftPoints);
    }, [readGeoDraftPath, seedGeocercaEditDraft]);

    const editSelectedGeocercaDraft = useCallback(() => {
        startGeocercaPointEdit();
    }, [startGeocercaPointEdit]);

    const commitGeoDraftToModal = useCallback(async () => {
        if ((geoDraftPoints || []).length < 3) {
            toast("Agrega al menos 3 puntos para crear la geocerca.");
            return;
        }

        const selectedCompanyIds = geoDraftCompanies.includes("0")
            ? ["0"]
            : geoDraftCompanies;
        const companiesPayload = `|${selectedCompanyIds.join("|")}|`;
        const closedVertices = geoDraftPoints.length >= 3
            ? [...geoDraftPoints, geoDraftPoints[0]]
                .map((point) => `(${Number(point.lat)},${Number(point.lng)})`)
                .join("/")
            : "";
        const polygonCoordinates = geoDraftPoints.length >= 3
            ? [...geoDraftPoints, geoDraftPoints[0]]
                .map((point) => `${Number(point.lat)} ${Number(point.lng)}`)
                .join(", ")
            : "";
        const geofencePayload = {
            nombre: geoDraftName?.trim() || "",
            vertices: closedVertices,
            descripcion: geoDraftDescription?.trim() || "",
            tipo: Number(geoDraftCategory || 1),
            cod: geoDraftCode === "" ? 0 : Number.parseInt(geoDraftCode, 10),
            empresa: Number(geoDraftCompany || 0),
            policad: polygonCoordinates,
        };

        if (geoCrudMode !== "edit") {
            console.log("Submit creacion de geocerca");
            console.log("Payload creacion de geocerca:", geofencePayload);
            setIsGeoDraftSaving(true);
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_SERVER}/geocercas/creargeocerca`,
                    geofencePayload
                );

                if (response.data?.success === false) {
                    throw new Error(response.data?.message || "No fue posible crear la geocerca.");
                }

                const geofencesResponse = isGeocercasOnly
                    ? await axios.post(
                        `${process.env.REACT_APP_SERVER}/geocercas/getgeocercas`,
                        { nombre: String(geoListSearch || "").trim() }
                    )
                    : await axios.get(`${process.env.REACT_APP_SERVER}/maestros/getgeocercas`);
                if (geofencesResponse.data?.success === false) {
                    throw new Error(geofencesResponse.data?.message || "No fue posible recargar las geocercas.");
                }

                const loadedGeofences = Array.isArray(geofencesResponse.data?.data)
                    ? geofencesResponse.data.data
                    : [];
                setListGeocercas(loadedGeofences);
                setGeoFilter({ showAll: false, selectedIds: [] });
                validateFilterGeocercas({ showAll: false, selectedIds: [] });
                setGeoCrudMode("browse");
                resetGeoDraft();
                toast.success("Geocerca creada correctamente.");
                return;
            } catch (error) {
                console.error("Error al crear la geocerca:", error);
                toast.error(error.response?.data?.message || error.message || "Error al crear la geocerca.");
                return;
            } finally {
                setIsGeoDraftSaving(false);
            }
        }

        const activeGeocercaRecord = activeGeoDraftRecordRef.current || selectedGeocercaRecord;
        const updateGeofencePayload = {
            id: Number(activeGeocercaRecord?.ID),
            ...geofencePayload,
            empresas: companiesPayload,
            active: geoDraftActive ? 1 : 0,
        };

        console.log("Submit actualizacion de geocerca");
        console.log("Payload actualizacion de geocerca:", updateGeofencePayload);
        setIsGeoDraftSaving(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER}/geocercas/updategeocerca`,
                updateGeofencePayload
            );

            if (response.data?.success === false) {
                throw new Error(response.data?.message || "No fue posible actualizar la geocerca.");
            }

            const geofencesResponse = isGeocercasOnly
                ? await axios.post(
                    `${process.env.REACT_APP_SERVER}/geocercas/getgeocercas`,
                    { nombre: String(geoListSearch || "").trim() }
                )
                : await axios.get(`${process.env.REACT_APP_SERVER}/maestros/getgeocercas`);
            if (geofencesResponse.data?.success === false) {
                throw new Error(geofencesResponse.data?.message || "No fue posible recargar las geocercas.");
            }

            const loadedGeofences = Array.isArray(geofencesResponse.data?.data)
                ? geofencesResponse.data.data
                : [];
            setListGeocercas(loadedGeofences);
            if (isGeocercasOnly && selectedGeoruta) {
                try {
                    // La lista visible puede estar filtrada; el trayecto necesita
                    // el catalogo completo para conservar todas sus geocercas.
                    const refreshedCatalog = await fetchAllGeocercasCatalog();
                    setAllGeocercasForTrayecto(refreshedCatalog);
                } catch (catalogError) {
                    console.error("Error recargando el catalogo del trayecto:", catalogError);
                    // La actualizacion principal ya fue exitosa. Como respaldo,
                    // se reemplaza solo la geocerca editada y se conservan las demas.
                    setAllGeocercasForTrayecto((currentCatalog) =>
                        currentCatalog.map((currentGeocerca) =>
                            String(currentGeocerca?.ID) === String(activeGeocercaRecord?.ID)
                                ? {
                                    ...currentGeocerca,
                                    Nombre: geofencePayload.nombre,
                                    Descripcion: geofencePayload.descripcion,
                                    Vertices: closedVertices,
                                    FKCatGeoCerca: geofencePayload.tipo,
                                }
                                : currentGeocerca
                        )
                    );
                }
            }
            setGeoFilter({ showAll: false, selectedIds: [] });
            validateFilterGeocercas({ showAll: false, selectedIds: [] });
            geocercaPolygonsRef.current.forEach((polygon) => polygon.setMap(null));
            geocercaPolygonsRef.current = [];
            setGeocercaPolygons([]);
            clearGeofenceActionsOverlay();
            setGeoCrudMode("browse");
            resetGeoDraft();
            toast.success("Geocerca actualizada correctamente.");
            return;
        } catch (error) {
            console.error("Error al actualizar la geocerca:", error);
            toast.error(error.response?.data?.message || error.message || "Error al actualizar la geocerca.");
            return;
        } finally {
            setIsGeoDraftSaving(false);
        }
    }, [
        clearGeoDraftGeometry,
        geoCrudMode,
        geoDraftCategory,
        geoDraftActive,
        geoDraftCode,
        geoDraftCompany,
        geoDraftCompanies,
        geoDraftDescription,
        geoDraftName,
        geoDraftPoints,
        geoListSearch,
        fetchAllGeocercasCatalog,
        isGeocercasOnly,
        resetGeoDraft,
        selectedGeoruta,
        selectedGeocercaRecord,
    ]);

    const validateFilterGeocercas = ({ showAll, selectedIds }) => {
        const hasSelected = Array.isArray(selectedIds) && selectedIds.length > 0;
        setFastGeocerca(!!showAll || hasSelected);
    };

    const validateFilterGeorutas = ({ showAll, selectedIds }) => {
        const hasSelected = Array.isArray(selectedIds) && selectedIds.length > 0;
        setFastGeoruta(!!showAll || hasSelected);
    };

    const resetGeocercasExperience = useCallback(() => {
        setGeoFilter({ showAll: false, selectedIds: [] });
        validateFilterGeocercas({ showAll: false, selectedIds: [] });
        setGeoCrudMode("browse");
        resetGeoDraft();

        geocercaPolygonsRef.current.forEach((p) => p.setMap(null));
        geocercaPolygonsRef.current = [];
        setGeocercaPolygons([]);
        clearGeofenceActionsOverlay();

        if (geofenceInfoWindowRef.current) {
            geofenceInfoWindowRef.current.close();
            geofenceInfoWindowRef.current = null;
        }

        restoreGeoPreviousView();
    }, [geocercaPolygons, resetGeoDraft]);

    const geocercasCrudPanelContent = (
        <>
            {(geoCrudMode === "create" || geoCrudMode === "edit") ? (
                <div
                    style={{
                        boxSizing: "border-box",
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        display: "grid",
                        gap: 12,
                        marginTop: 14,
                        padding: 14,
                        borderRadius: 18,
                        background: "linear-gradient(180deg, rgba(240,248,252,0.95) 0%, #ffffff 100%)",
                        border: "1px solid rgba(15,76,129,0.12)",
                        boxShadow: "0 12px 30px rgba(15,76,129,0.08)",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, minWidth: 0 }}>
                        <div>
                            <div style={{ fontSize: 12, letterSpacing: "0.08em", textTransform: "uppercase", color: "#0f4c81", fontWeight: 700 }}>
                                {geoCrudMode === "edit" ? "Editar geocerca" : "Crear geocerca"}
                            </div>
                            <div style={{ color: "#16324a", fontWeight: 700 }}>
                                {geoDraftMode === "trackpad" ? "Modo trackpad" : "Modo seleccion de puntos"}
                            </div>
                        </div>
                        <button
                            type="button"
                            className="buttonSecondary"
                            onClick={() => {
                                setGeoCrudMode("browse");
                                resetGeoDraft();
                            }}
                        >
                            Volver
                        </button>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 10, width: "100%", minWidth: 0 }}>
                        <button
                            type="button"
                            className={geoDraftMode === "points" ? "buttonPrimary" : "buttonSecondary"}
                            onClick={() => {
                                setGeoDraftMode("points");
                                geoTrackpadIsDrawingRef.current = false;
                                setIsGeoTrackpadDrawing(false);
                            }}
                        >
                            Seleccion de puntos
                        </button>
                        <button
                            type="button"
                            className={geoDraftMode === "trackpad" ? "buttonPrimary" : "buttonSecondary"}
                            onClick={() => {
                                setGeoDraftMode("trackpad");
                                toast("Manten clic sostenido y dibuja sobre el mapa.");
                            }}
                        >
                            Trackpad
                        </button>
                    </div>

                    <div
                        style={{
                            padding: "12px 14px",
                            borderRadius: 14,
                            background: "rgba(15,76,129,0.06)",
                            color: "#23445f",
                            fontSize: 13,
                            lineHeight: 1.45,
                        }}
                    >
                        <strong>Puntos:</strong> {geoDraftPoints.length}
                        <br />
                        {isGeoDraftClosed
                            ? "Figura cerrada. Ya puedes registrar o ajustar la geocerca."
                            : geoDraftMode === "trackpad"
                                ? (isGeoTrackpadDrawing ? "Dibujando sobre el mapa..." : "Haz clic sostenido, dibuja y luego cierra tocando el primer punto.")
                                : "Haz clic sobre el mapa para agregar vertices y cierra tocando el primer punto."}
                    </div>

                    {geoDraftVerticesPreview && (
                        <div
                            style={{
                                boxSizing: "border-box",
                                width: "100%",
                                maxWidth: "100%",
                                maxHeight: 88,
                                overflowY: "auto",
                                overflowX: "hidden",
                                padding: "10px 12px",
                                borderRadius: 12,
                                background: "#fff",
                                border: "1px solid rgba(15,76,129,0.1)",
                                fontSize: 11,
                                color: "#32516a",
                            }}
                        >
                            {geoDraftVerticesPreview}
                        </div>
                    )}

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 10, width: "100%", minWidth: 0 }}>
                        <button
                            type="button"
                            className="buttonSecondary"
                            onClick={() => setGeoDraftPoints((prev) => prev.slice(0, -1))}
                            disabled={geoDraftPoints.length === 0}
                        >
                            Deshacer punto
                        </button>
                        <button
                            type="button"
                            className="buttonSecondary"
                            onClick={restartGeoDraftGeometry}
                            disabled={geoDraftPoints.length === 0}
                        >
                            Reiniciar geocerca
                        </button>
                        <button
                            type="button"
                            className="buttonPrimary"
                            onClick={() => setIsGeoDraftRegistrationModalOpen(true)}
                            disabled={!isGeoDraftClosed || geoDraftPoints.length < 3}
                        >
                            {geoCrudMode === "edit" ? "Editar registro" : "Registrar geocerca"}
                        </button>
                        <button
                            type="button"
                            className="buttonPrimary"
                            onClick={() => {
                                setGeoCrudMode("browse");
                                saveGeoPreviousView();
                                applyGeocercas();
                            }}
                        >
                            Aplicar seleccion
                        </button>
                    </div>
                </div>
            ) : (
                <div style={{ display: "grid", gap: 12, marginTop: 14, width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden" }}>
                    <FilteredBodyGeocercas
                        listGeocercas={listGeocercas}
                        showAll={geoFilter.showAll}
                        selectedIds={geoFilter.selectedIds}
                        setShowAll={(v) => setGeoFilter((prev) => ({ ...prev, showAll: v }))}
                        setSelectedIds={(updater) => {
                            setGeoFilter((prev) => ({
                                ...prev,
                                selectedIds: typeof updater === "function" ? updater(prev.selectedIds) : updater,
                            }));
                        }}
                        filterActive={validateFilterGeocercas}
                    />

                    <div className="geo-actions">
                        <button
                            type="button"
                            className="buttonSecondary"
                            onClick={resetGeocercasExperience}
                        >
                            Limpiar
                        </button>

                        <button
                            type="button"
                            className="buttonPrimary"
                            onClick={() => {
                                saveGeoPreviousView();
                                applyGeocercas();
                            }}
                        >
                            Aplicar
                        </button>
                    </div>
                </div>
            )}
        </>
    );

    const INVIAS_TYPE_META = {
        1: { label: "Cierre Programado", color: "#f0ad4e" },
        2: { label: "Cierre Total", color: "#b52b27" },
        3: { label: "Paso a un Carril", color: "#f0ad4e" },
        4: { label: "Paso Alternado", color: "#f0ad4e" },
        5: { label: "Paso Restringido", color: "#f0ad4e" },
        6: { label: "Plan Retorno", color: "#f0ad4e" },
        7: { label: "Restricción de Carga", color: "#f0ad4e" },
        8: { label: "Congestión Vehicular", color: "#f0ad4e" },
        10: { label: "Manejo de Trafico", color: "#f0ad4e" },
        11: { label: "Cierre Temporal", color: "#f0ad4e" },
        12: { label: "Cierre Parcial", color: "#f0ad4e" },
        13: { label: "Cierres Esporádicos", color: "#f0ad4e" },
        14: { label: "Cierre Preventivo", color: "#f0ad4e" },
        15: { label: "Cierre Intermitente", color: "#f0ad4e" },
        16: { label: "Cierre Total Preventivo", color: "#b52b27" },
        17: { label: "Contraflujo", color: "#f0ad4e" },
        18: { label: "Reversible", color: "#f0ad4e" },
        19: { label: "Inactivo", color: "#f0ad4e" },
    };

    const getInviasTypeMeta = (tipo) => {
        const key = Number(tipo);
        return INVIAS_TYPE_META[key] || { label: "Sin tipo", color: "#95a5a6" };
    };

    const INVIAS_COUNTRIES = [
        { value: "colombia", label: "Colombia" },
    ];

    const buildInviasMarkerHtml = (tipo) => {
        const meta = getInviasTypeMeta(tipo);
        const tipoNum = Number(tipo);
        const iconHtml = tipoNum === 2 || tipoNum === 16
            ? INVIAS_CANCEL_ICON_HTML
            : INVIAS_WARNING_ICON_HTML;
        return `
            <div style="width:18px;height:18px;border-radius:50%;background:${meta.color};opacity:0.85;display:flex;align-items:center;justify-content:center;border:2px solid #ffffff;color:#ffffff;font-size:10px;font-weight:700;box-shadow:0 1px 4px rgba(0,0,0,0.25);">
                ${iconHtml}
            </div>
        `;
    };

    const drawInviasMarkers = (featureCollection) => {
        if (!mapRef.current || !window.google?.maps) return;

        clearInviasMarkers();

        const features = featureCollection?.features || [];
        features.forEach((feature) => {
            const tipo = feature?.properties?.tipo;
            const coords = feature?.geometry?.coordinates;
            if (!Array.isArray(coords) || coords.length < 2) return;

            const [lngRaw, latRaw] = coords;
            const lat = Number(latRaw);
            const lng = Number(lngRaw);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

            const position = new google.maps.LatLng(lat, lng);
            const marker = new HtmlMarker(
                position,
                mapRef.current,
                buildInviasMarkerHtml(tipo),
                () => {
                    const props = feature?.properties || {};
                    const meta = getInviasTypeMeta(props?.tipo);
                    const content = `
                        <div style="max-width:320px;font-family:Arial,sans-serif;">
                            <div style="font-weight:700;margin-bottom:6px; font-size:20px">${props.nom_via || "Via"}</div>
                            </br>
                            <div><strong>Tipo:</strong> ${meta.label}</div>
                            </br>
                            <div><strong>Sitio:</strong> ${props.sitio || "-"}</div>
                            </br>
                            <div><strong>Descripcion:</strong> ${props.descripcion || "-"}</div>
                            </br>
                            <div><strong>Ruta alterna:</strong> ${props.rut_alterna || "-"}</div>
                        </div>
                    `;

                    if (!inviasInfoWindowRef.current) {
                        inviasInfoWindowRef.current = new google.maps.InfoWindow();
                    }
                    inviasInfoWindowRef.current.setContent(content);
                    inviasInfoWindowRef.current.setPosition(position);
                    inviasInfoWindowRef.current.open(mapRef.current);
                }
            );

            marker.setPosition(position);

            inviasMarkersRef.current.push(marker);
        });
    };

    // ===== SPIDERFY/CLUSTER =====
    const SPIDERFY_MIN_PX = 34;
    const SPIDERFY_ZOOM = 16;
    const CLUSTER_MAX_ZOOM = 6;

    const createClusterOverlay = (latLng, count, onClick) => {
        const html = `
        <div class="cluster-wrap" aria-label="Cluster ${count}">
        <div class="cluster-ring">
            <div class="cluster-inner">
            ${count}
            </div>
        </div>
        </div>

        <style>
        .cluster-wrap{
            transform: translate(-50%, -50%);
            cursor: default;
            user-select: none;
        }

        /* círculo exterior: transparente */
        .cluster-ring{
            width: 36px;
            height: 36px;
            border-radius: 50%;
            border: 1px solid rgba(0, 160, 220, 0.9);
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(0,0,0,.25);
            cursor: default;
        }

        /* círculo interior + número centrado */
        .cluster-inner{
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: #0A67A8;
            color: #fff;
            font-weight: 800;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: default;
        }

        .cluster-ring:hover{
            transform: scale(1.08);
            filter: brightness(1.05);
        }

        .cluster-ring:active{
            transform: scale(0.96);
        }
        </style>
    `;

        return new HtmlMarker(latLng, mapRef.current, html, onClick, (div) => {
            if (!div) return;
            div.style.cursor = "default";
            div.style.touchAction = "manipulation";
            div.style.userSelect = "none";
            div.querySelectorAll("*").forEach((element) => {
                element.style.cursor = "default";
                element.style.userSelect = "none";
            });
        });
    };



    // Logica de trayectos

    const fetchPolylineByTrayecto = async (trayectoId) => {
        const { data: resp } = await axios.post(
            `${process.env.REACT_APP_SERVER}/operaciones/getpolylinetrayecto`,
            JSON.stringify({ id: trayectoId }),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            }
        );

        if (!resp?.success) return null;

        // OJO: por tu estructura resp.data[0].Polyline
        const row = Array.isArray(resp.data) ? resp.data[0] : null;
        return row?.Polyline || null; // string con "||||"
    };

    const drawOneTrayectoPolyline = (polylineStr, options = {}) => {
        const map = mapRef.current;
        if (!map || !polylineStr || !window.google?.maps?.geometry) return { bounds: null };

        const bounds = new google.maps.LatLngBounds();
        const segmentos = String(polylineStr).split("||||").filter(Boolean);

        segmentos.forEach((seg) => {
            const path = google.maps.geometry.encoding.decodePath(seg);

            const pl = new google.maps.Polyline({
                path,
                geodesic: true,
                strokeColor: "#ffae00ff",
                strokeOpacity: options.strokeOpacity ?? 0.7,
                strokeWeight: options.strokeWeight ?? 6,
                map,
            });

            trayectoLinesRef.current.push(pl);
            path.forEach((pt) => bounds.extend(pt));
        });

        return { bounds };
    };


    const drawSelectedTrayectos = async ({ showAll, selectedIds }) => {
        const map = mapRef.current;
        if (!map) return;

        clearTrayectoLines();
        clearYellowCircle();

        // arma IDs
        const ids = showAll
            ? Array.from(new Set(
                (contracts || [])
                    .map(c => Number(c.IDTrayecto ?? c.trayecto ?? 0))
                    .filter(n => Number.isFinite(n) && n > 0)
            ))
            : (Array.isArray(selectedIds) ? selectedIds : [])
                .map(x => Number(x))
                .filter(n => Number.isFinite(n) && n > 0);

        if (!ids.length) return;

        const globalBounds = new google.maps.LatLngBounds();
        let hasBounds = false;

        // (simple) secuencial para no reventar el backend
        for (const id of ids) {
            const polyStr = await fetchPolylineByTrayecto(id);
            if (!polyStr) continue;

            const { bounds } = drawOneTrayectoPolyline(polyStr);
            if (bounds) {
                // merge bounds
                globalBounds.union(bounds);
                hasBounds = true;
            }
        }

        if (hasBounds) {
            map.fitBounds(globalBounds, 80);
            google.maps.event.addListenerOnce(map, "idle", () => {
                if (map.getZoom() > 15) map.setZoom(15);
            });
        }
    };

    const showSelectedGeorutaOnMap = useCallback(async (georuta) => {
        const selectedId =
            georuta?.IDTrayecto ??
            georuta?.IDtrayecto ??
            georuta?.IdTrayecto ??
            georuta?.id ??
            georuta?.ID;

        if (!selectedId) return;

        const nextFilter = { showAll: false, selectedIds: [selectedId] };
        const loadedGeocercas = await ensureAllGeocercasForTrayectoLoaded();
        const associatedIds = parseTrayectoGeocercasA(georuta);
        const associatedIdsSet = new Set(associatedIds.map(String));
        const initialStartPoint = extractTrayectoPointFromGeoruta(georuta, "start");
        const initialEndPoint = extractTrayectoPointFromGeoruta(georuta, "end");
        const geocercasById = new Map(
            loadedGeocercas.map((geocerca) => [getGeocercaRecordId(geocerca), geocerca])
        );
        const startPointId = String(initialStartPoint?.id ?? "");
        const endPointId = String(initialEndPoint?.id ?? "");
        const associatedGeocercas = loadedGeocercas.filter((geocerca) => {
            const geocercaId = getGeocercaRecordId(geocerca);
            return (
                associatedIdsSet.has(geocercaId) ||
                geocercaId === startPointId ||
                geocercaId === endPointId
            );
        });
        const hydratedStartPoint = initialStartPoint?.id && geocercasById.has(initialStartPoint.id)
            ? normalizeTrayectoPoint({
                ...initialStartPoint,
                id: initialStartPoint.id,
                name: getGeocercaPointName(geocercasById.get(initialStartPoint.id)) || initialStartPoint.name,
                ...parseGeocercaCenter(geocercasById.get(initialStartPoint.id)),
            })
            : initialStartPoint;
        const hydratedEndPoint = initialEndPoint?.id && geocercasById.has(initialEndPoint.id)
            ? normalizeTrayectoPoint({
                ...initialEndPoint,
                id: initialEndPoint.id,
                name: getGeocercaPointName(geocercasById.get(initialEndPoint.id)) || initialEndPoint.name,
                ...parseGeocercaCenter(geocercasById.get(initialEndPoint.id)),
            })
            : initialEndPoint;

        console.log("Objeto georuta pintada:", {
            georuta,
            geocercasAutorizadas: associatedIds,
            geoOrigen: hydratedStartPoint,
            geoDestino: hydratedEndPoint,
        });

        if (geofenceInfoWindowRef.current) {
            geofenceInfoWindowRef.current.close();
            geofenceInfoWindowRef.current = null;
        }

        saveGeoPreviousView();
        if (geoCrudMode === "edit") {
            setGeoCrudMode("browse");
            resetGeoDraft();
        }

        setShowAllGeocercasOnMap(false);
        setSelectedGeoruta(georuta);
        setAllGeocercasForTrayecto(loadedGeocercas);
        setTrayectoGeocercaSelectedIds(associatedIds);
        setTrayectoGeocercaOriginalIds(associatedIds);
        setTrayectoNearbyDetectedIds([]);
        setTrayectoStartPoint(hydratedStartPoint ? { ...hydratedStartPoint } : null);
        setTrayectoEndPoint(hydratedEndPoint ? { ...hydratedEndPoint } : null);
        setTrayectoOriginalStartPoint(hydratedStartPoint ? { ...hydratedStartPoint } : null);
        setTrayectoOriginalEndPoint(hydratedEndPoint ? { ...hydratedEndPoint } : null);
        setGeorutaFilter(nextFilter);
        validateFilterGeorutas(nextFilter);

        clearGeocercasTrayecto();
        await drawSelectedTrayectos(nextFilter);

        if (associatedGeocercas.length > 0) {
            drawGeocercasTrayecto(associatedGeocercas, associatedIds, [], georuta, {
                startPointId: hydratedStartPoint?.id,
                endPointId: hydratedEndPoint?.id,
            });
        }
    }, [
        clearGeocercasTrayecto,
        drawGeocercasTrayecto,
        drawSelectedTrayectos,
        ensureAllGeocercasForTrayectoLoaded,
        geoCrudMode,
        getGeocercaRecordId,
        parseTrayectoGeocercasA,
        resetGeoDraft,
    ]);

    useEffect(() => {
        showSelectedGeorutaOnMapRef.current = showSelectedGeorutaOnMap;
    }, [showSelectedGeorutaOnMap]);



    const relayoutCloseVehicles = () => {
        const map = mapRef.current;
        const projOverlay = projectionOverlayRef.current;
        if (!map || !projOverlay) return;

        relayoutHoverInfoWindow();

        const projection = projOverlay.getProjection();
        if (!projection) return;

        clearClusters();

        Object.values(markersByIdRef.current).forEach(({ overlay }) => {
            if (!overlay) return;
            overlay.resetToBase?.();
        });

        const zoom = map.getZoom();

        const items = Object.entries(markersByIdRef.current)
            .map(([id, { overlay }]) => {
                if (!overlay?.basePosition) return null;
                const p = projection.fromLatLngToDivPixel(overlay.basePosition);
                if (!p) return null;
                return { id, overlay, p };
            })
            .filter(Boolean);

        if (items.length <= 1) return;

        const densityBoost = Math.min(3, Math.floor(items.length / 10));
        // 0 → pocos
        // 1 → medio
        // 2–3 → muchos markers

        const zoomBoost = Math.max(0, zoom - 12); // desde zoom 12 en adelante

        const dynamicTolerance =
            SPIDERFY_MIN_PX +
            densityBoost * 20 +   // más markers → más tolerancia
            zoomBoost * 6;        // más zoom → más tolerancia

        const cell = dynamicTolerance;

        const grid = new Map();

        for (const it of items) {
            const gx = Math.round(it.p.x / cell);
            const gy = Math.round(it.p.y / cell);
            const key = `${gx}_${gy}`;
            if (!grid.has(key)) grid.set(key, []);
            grid.get(key).push(it);
        }

        const groups = [];
        for (const bucket of grid.values()) {
            const used = new Set();
            for (let i = 0; i < bucket.length; i++) {
                if (used.has(i)) continue;
                const group = [bucket[i]];
                used.add(i);

                for (let j = i + 1; j < bucket.length; j++) {
                    if (used.has(j)) continue;
                    const dx = bucket[i].p.x - bucket[j].p.x;
                    const dy = bucket[i].p.y - bucket[j].p.y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < SPIDERFY_MIN_PX) {
                        group.push(bucket[j]);
                        used.add(j);
                    }
                }
                groups.push(group);
            }
        }

        groups.forEach((group) => {
            if (group.length <= 1) return;

            const cx = group.reduce((a, g) => a + g.p.x, 0) / group.length;
            const cy = group.reduce((a, g) => a + g.p.y, 0) / group.length;
            const centerLatLng = projection.fromDivPixelToLatLng(new google.maps.Point(cx, cy));

            // Reglas
            const FORCE_CLUSTER_COUNT = 5; // si el grupo tiene >= esto, clusteriza aunque haya mucho zoom

            const shouldCluster =
                zoom <= CLUSTER_MAX_ZOOM || group.length >= FORCE_CLUSTER_COUNT;

            if (shouldCluster) {
                // Oculta los markers del grupo
                group.forEach((g) => g.overlay.setHidden?.(true));

                // Crea el cluster overlay
                const cluster = createClusterOverlay(centerLatLng, group.length, () => {
                    const bounds = new google.maps.LatLngBounds();
                    let validPoints = 0;

                    group.forEach((item) => {
                        const basePosition = item?.overlay?.basePosition;
                        if (!basePosition) return;
                        bounds.extend(basePosition);
                        validPoints += 1;
                    });

                    if (validPoints > 1 && !bounds.isEmpty()) {
                        const currentZoom = map.getZoom() ?? 0;
                        map.fitBounds(bounds, 80);

                        window.setTimeout(() => {
                            const zoomAfterFit = map.getZoom() ?? currentZoom;
                            if (zoomAfterFit <= currentZoom) {
                                map.panTo(centerLatLng);
                                map.setZoom(Math.min(currentZoom + 2, 20));
                            }
                        }, 180);
                        return;
                    }

                    map.panTo(centerLatLng);

                    // Si estás muy cerca y aun así clusterizó por densidad,
                    // NO te dispares el zoom infinito. Sube 1–2 niveles como máximo.
                    const nextZoom = Math.min(map.getZoom() + 2, 20);
                    map.setZoom(nextZoom);
                });

                clusterOverlaysRef.current.push(cluster);
                return;
            }


            if (zoom >= SPIDERFY_ZOOM) {
                const radius = 18 + Math.min(40, group.length * 3);
                const step = (Math.PI * 2) / group.length;

                group.forEach((g, idx) => {
                    const angle = idx * step;
                    const nx = cx + radius * Math.cos(angle);
                    const ny = cy + radius * Math.sin(angle);
                    const ll = projection.fromDivPixelToLatLng(new google.maps.Point(nx, ny));
                    g.overlay.setHidden?.(false);
                    g.overlay.setPosition?.(ll);
                });
            }
        });
    };

    const drawYellowCircle = (lat, lng) => {
        const pos = new google.maps.LatLng(+lat, +lng);
        clearYellowCircle();

        circleRef.current = new google.maps.Circle({
            map: mapRef.current,
            center: pos,
            radius: 5,
            strokeWeight: 3,
            strokeColor: "black",
            fillColor: "#E0E302",
            fillOpacity: 0.9,
            zIndex: 0,
        });

        const updateRadius = () => {
            if (!circleRef.current || !mapRef.current) return;
            const scale = Math.pow(2, 20 - mapRef.current.getZoom());
            circleRef.current.setRadius(5 * scale);
        };

        zoomListenerRef.current = mapRef.current.addListener("zoom_changed", updateRadius);
        updateRadius();
    };

    const drawSingleMarker = (lat, lng) => {
        const latNum = parseFloat(lat);
        const lngNum = parseFloat(lng);
        if (Number.isNaN(latNum) || Number.isNaN(lngNum) || !mapRef.current) return;

        const position = new google.maps.LatLng(latNum, lngNum);

        if (singleOverlayRef.current) {
            singleOverlayRef.current.setMap(null);
            singleOverlayRef.current = null;
        }

        // const estado = () => {
        //     const detenido =
        //         c.IconMoving === "/images/stop.png" ||
        //         c.IconMoving === "/images/stopAlert.png";

        //     const enMovimiento = c.IconMoving === "/images/moving.png";

        //     const tieneDesvio =
        //         c.IconDesvio === "/images/desvioalerta.png" ||
        //         c.IconDesvio === "/images/desvio.gif";

        //     if (c.Locked) {
        //         if (detenido) return tieneDesvio ? "cerrado_detenido_desvio" : "cerrado_detenido";
        //         if (enMovimiento) return tieneDesvio ? "cerrado_movimiento_desvio" : "cerrado_movimiento";
        //     } else {
        //         if (detenido) return tieneDesvio ? "abierto_detenido_desvio" : "abierto_detenido";
        //         if (enMovimiento) return tieneDesvio ? "abierto_movimiento_desvio" : "abierto_movimiento";
        //     }

        //     return "desconocido";
        // };


        // ✅ FIX: aquí antes usabas `c` (no existía)
        const tooltipText = `Dispositivo: ${contratoSelected?.FKLokDeviceID || ""}\nPlaca: ${contratoSelected?.PlacaTruck || ""}\nContenedor: ${contratoSelected?.ContainerNum || ""}\nRef: ${contratoSelected?.Ref || ""}`;

        const html = buildContractMarkerHtml(contratoSelected);

        singleOverlayRef.current = new HtmlMarker(position, mapRef.current, html, () => {
            if (contratoSelected) openInfoWindowForContrato(contratoSelected, { focusZoom: true });
        });

        drawYellowCircle(latNum, lngNum);
    };

    const closeInfoWindow = () => {
        selectedInfoWindowOpenRef.current = false;
        const activeInfoWindow = infoWindowRef.current;
        infoWindowRef.current = null;
        if (activeInfoWindow) activeInfoWindow.close();
        setMobileInfoOpen(false);
        setMobileInfoContrato(null);
        setSelectedContractID(null);
        if (isMobile) setMenuVisible(true);
    };

    useEffect(() => {
        const handleInfoWindowEscape = (event) => {
            if (event.key !== "Escape" || !selectedInfoWindowOpenRef.current) return;

            event.preventDefault();
            event.stopPropagation();
            closeInfoWindow();
        };

        window.addEventListener("keydown", handleInfoWindowEscape, true);
        return () => {
            window.removeEventListener("keydown", handleInfoWindowEscape, true);
        };
    }, [isMobile]);

    const openModalSeguirPanel = (contrato) => {
        closeInfoWindow();

        setContratoSelected(contrato);
        setShowSeguirPanel(true);

        clearArrowLines();
        clearTrayectoLines();
        clearCircle();

        ListReports(contrato, 0, 1);
    };

    const ListarComprobantes = (contrato) => {
        const json = JSON.stringify({ contrato });
        axios
            .post(process.env.REACT_APP_SERVER + "/operaciones/getcomprobantevalitronics", json, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success === false) {
                    Swal.fire({
                        icon: "error",
                        title: "Error al listar comprobantes",
                        text: res.data.message || "No se pudieron obtener los comprobantes.",
                    });
                } else {
                    setListComprobantes(res.data.data);
                }
            });
    };

    const openModalContratoSeguimiento = (contrato) => {
        setContratoSelected(contrato);
        setRutaSelected(contrato.trayecto);
        setModalContratoSeguimiento(true);
    };

    const openModalContratoSeguimiento2 = (contrato) => {
        setModalImagenes(false);
        if (window?.$) window.$("#ModalGaleriaMapCenter").modal("hide");

        setContratoSelected(contrato);
        setRutaSelected(contrato.trayecto);
        setModalContratoSeguimiento(true);
        if (window?.$) window.$("#ModalSeguimientoMapCenter").modal("show");
    };

    const openMultimediaHub = (contrato, tab = multimediaHubTabs.PHOTOS) => {
        const selected =
            contracts.find((c) => String(c?.ContractID) === String(contrato?.ContractID)) || contrato;
        if (!selected) return;

        setContratoSelected(selected);
        setSelectedContractID(selected.ContractID);
        setMultimediaHubTab(tab);
        setModalImagenes(true);
    };

    const openTracking2 = (contrato) => {
        setContratoSelected(contrato);
        setRutaSelected(contrato.trayecto);
        setModalMonitoreo(false);
        setModalContratoSeguimiento(true);
        if (window?.$) window.$("#ModalSeguimientoMapCenter").modal("show");
    };

    const openModalImagens = (contrato) => {
        openMultimediaHub(contrato, multimediaHubTabs.PHOTOS);
    };

    const openImagenes2 = (contrato) => {
        openMultimediaHub(contrato, multimediaHubTabs.PHOTOS);
    };

    const openImagenes3 = (contrato) => {
        setModalMonitoreo(false);
        openMultimediaHub(contrato, multimediaHubTabs.PHOTOS);
    };

    const openModalVideos = () => setModalVideos(true);
    const openModalEnVivo = (contrato, streamUrl = "") => {
        setContratoSelected(contrato);
        setLiveStreamUrl(streamUrl || "");
        setModalEnVivo(true);
    };
    const openModalEnVivoFromLiveList = (contrato, streamUrl = "") => {
        if (isMobile && livePanelOpen) {
            setLivePanelOpen(false);
            window.setTimeout(() => {
                openModalEnVivo(contrato, streamUrl);
            }, 230);
            return;
        }
        openModalEnVivo(contrato, streamUrl);
    };

    const openModalValitronics = (contrato) => {
        ListarComprobantes(contrato);
        setModalValitronics(true);
    };

    const openModalCheckList = () => setModalCheckList(true);

    const openModalMonitoreo = () => {
        if (window?.$) window.$("#ModalGaleriaMapCenter").modal("hide");
        setModalMonitoreo(true);
    };

    const openModalTrayecto = () => setModalTrayecto(true);

    const openModalConsolidado = (contrato) => {
        setContratoSelected(contrato);
        setModalConsolidado(true);
        if (window?.$) window.$("#ModalReporteServicioMapCenter").modal("show");
    };

    const openModalConsolidado4 = (contrato) => {
        setContratoSelected(contrato);
        setSelectedContractID(contrato.ContractID);
        setModalMonitoreo(false);
        setModalConsolidado(true);
    };

    const openModalConsolidado3 = (contrato) => {
        const selected = contracts.find((c) => c === contrato);
        setContratoSelected(selected);
        setSelectedContractID(contrato.ContractID);
        if (selected) {
            if (window?.$) window.$("#ModalGaleriaMapCenter").modal("hide");
            setModalConsolidado(true);
        }
    };

    const eliminar = () => {
        const elementos = document.getElementsByClassName("object-box");
        Array.from(elementos).forEach((el) => el.parentNode?.removeChild(el));
    };

    const listContracts = async () => {
        const routeSelected = "operaciones/getcontratostrafico";
        try {
            const res = await axios.get(`${process.env.REACT_APP_SERVER}/${routeSelected}`, {
                withCredentials: true,
            });

            if (res.data.success === false) {
                Swal.fire({
                    icon: "error",
                    title: "Error al listar contratos",
                    text: res.data.message || "No se pudieron obtener los contratos.",
                });
                window.location.href = "/";
            } else {
                const contratosConEstadoExpandido = res.data.data?.map((contrato) => {
                    const formattedDate = contrato.tiempoUnix
                        ? formattedGlobalDate(new Date(contrato.tiempoUnix * 1000).toISOString())
                        : null;
                    return { ...contrato, formattedDate };
                });

                setContracts(contratosConEstadoExpandido);
                setFilteredContracts(contratosConEstadoExpandido);
            }
        } catch (error) {
            console.error("Error al listar contratos:", error);
        }
    };

    const isStreamingOn = (contrato) => {
        const value = contrato?.StreamingOn ?? contrato?.streamingOn;
        return value === true || value === "true" || value === 1 || value === "1";
    };

    const alerts = [
        {
            icon: "/images/trayectonull.png",
            count: contracts.filter((c) => c.DescripcionTrayecto == null && c.FKLokTipoEquipo === 9).length,
            filter: "noTrayecto",
            active: isNoRutaActive,
        },
        {
            icon: "/images/moving.png",
            count: contracts.filter((c) =>
                contracts.some((a) => a.PlacaTruck === c.PlacaTruck && a.ContainerNum === c.ContainerNum && a.ContractID !== c.ContractID)
            ).length,
            filter: "refuerzo",
            active: isRefuerzoActive,
        },
        {
            icon: "/images/moving.png",
            count: contracts.filter((c) => (c.IconMoving || "").includes("moving")).length,
            filter: "moving",
            active: isMovingActive,
        },
        {
            icon: "/images/stop.png",
            count: contracts.filter((c) => (c.IconMoving || "").includes("stop")).length,
            filter: "stop",
            active: isStopActive,
        },
        {
            icon: "/images/stopAlert.png",
            count: contracts.filter((c) => (c.IconMoving || "").includes("stopAlert")).length,
            filter: "stopAlert",
            active: isStopAlertActive,
        },
        {
            icon: "/images/desvioalerta.png",
            count: contracts.filter((c) => (c.IconDesvio || "").includes("desvioalerta")).length,
            filter: "desvioalerta",
            active: isDesvioAlertActive,
        },
        {
            icon: "/images/batt-low.png",
            count: contracts.filter((c) => (c.icon_bat || "").includes("batt-low")).length,
            filter: "batt-low",
            active: isLowBatteryActive,
        },
        {
            icon: "/images/openedpadlockalerta.gif",
            count: contracts.filter((c) => (c.IconLocked || "").includes("candado") || (c.IconLocked || "").includes("openedpadlockalerta")).length,
            filter: "candado",
            active: isOpenActive,
        },
        {
            icon: "/images/unsecured.gif",
            count: unsecuredCount,
            filter: "unsecured",
            active: isUnsecuredActive,
        },
        {
            icon: "/images/timer-regular-24.png",
            count: contracts.filter((c) => {
                return getElapsedMinutesFromUtc(c.LoksysServerTime) >= 30;
            }).length,
            filter: "tiempo",
            active: isTimeExchangeActive,
        },
        {
            icon: null,
            count: contracts.filter((c) => {
                const deviceId = String(c?.FKLokDeviceID || "");
                return isStreamingOn(c) || activeStreamDeviceSet.has(deviceId);
            }).length,
            filter: "streaming",
            active: isStreamingActive,
        },
        {
            icon: "/images/NoGPS.png",
            count: contracts.filter((c) => c.bitGPS === true).length,
            filter: "noGps",
            active: isNoGpsActive,
        },
    ];

    const resetAllFilters = () => {
        setIsMovingActive(false);
        setIsStopActive(false);
        setIsStopAlertActive(false);
        setIsDesvioAlertActive(false);
        setIsLowBatteryActive(false);
        setIsOpenActive(false);
        setIsTimeExchangeActive(false);
        setIsRefuerzoActive(false);
        setIsNoGpsActive(false);
        setIsNoRutaActive(false);
        setIsStreamingActive(false);
        setIsUnsecuredActive(false);
    };

    const handleFilterButtons2 = (value) => {
        const activateFilter = (setter, filterFn) => {
            setter((prev) => {
                const newState = !prev;
                resetAllFilters();
                setter(newState);

                if (newState) {
                    activeQuickFilterRef.current = value;
                    const filtered = contracts.filter(filterFn);
                    setFilteredContracts(filtered);
                    if (isMobile) setFastFilter(false);
                } else {
                    activeQuickFilterRef.current = null;
                    setFilteredContracts(contracts);
                    if (isMobile) setFastFilter(false);
                }
                return newState;
            });
        };

        switch (value) {
            case "moving":
                activateFilter(setIsMovingActive, (c) => (c.IconMoving || "").includes("moving"));
                break;
            case "stop":
                activateFilter(setIsStopActive, (c) => (c.IconMoving || "").includes("stop"));
                break;
            case "stopAlert":
                activateFilter(setIsStopAlertActive, (c) => (c.IconMoving || "").includes("stopAlert"));
                break;
            case "desvioalerta":
                activateFilter(setIsDesvioAlertActive, (c) => (c.IconDesvio || "").includes("desvioalerta"));
                break;
            case "batt-low":
                activateFilter(setIsLowBatteryActive, (c) => (c.icon_bat || "").includes("batt-low"));
                break;
            case "candado":
                activateFilter(setIsOpenActive, (c) => (c.IconLocked || "").includes("candado") || (c.IconLocked || "").includes("openedpadlockalerta"));
                break;
            case "unsecured":
                activateFilter(setIsUnsecuredActive, (c) => isUnsecuredContrato(c));
                break;
            case "tiempo":
                activateFilter(setIsTimeExchangeActive, (c) => {
                    return getElapsedMinutesFromUtc(c.LoksysServerTime) >= 30;
                });
                break;
            case "refuerzo":
                activateFilter(setIsRefuerzoActive, (c) => {
                    if (!c.PlacaTruck || !c.ContainerNum) return false;
                    const anexos = contracts.filter((a) => a.PlacaTruck && a.ContainerNum && a.PlacaTruck === c.PlacaTruck && a.ContainerNum === c.ContainerNum && a.ContractID !== c.ContractID);
                    return anexos.length > 0;
                });
                break;
            case "noGps":
                activateFilter(setIsNoGpsActive, (c) => c.bitGPS === true);
                break;
            case "noTrayecto":
                activateFilter(setIsNoRutaActive, (c) => c.DescripcionTrayecto == null && c.FKLokTipoEquipo === 9);
                break;
            case "streaming":
                activateFilter(setIsStreamingActive, (c) => {
                    const deviceId = String(c?.FKLokDeviceID || "");
                    return isStreamingOn(c) || activeStreamDeviceSet.has(deviceId);
                });
                break;
            default:
                resetAllFilters();
                activeQuickFilterRef.current = null;
                setFilteredContracts(contracts);
                break;
        }
    };

    const filterBySearch = (list, term) => {
        const t = term.trim().toLowerCase();
        if (!t) return list;
        return list.filter((item) => JSON.stringify(item).toLowerCase().includes(t));
    };

    const applySearchTerm = (term) => {
        setSearch(term);
        const filtered = filterBySearch(contracts, term);
        setFilteredContracts(filtered);
    };

    const handleSearchChange = (e) => {
        applySearchTerm(e.target.value);
    };

    const openInfoWindowForContrato = (contrato, options = {}) => {

        closeHoverInfoWindow();
        if (!window.google?.maps || !mapRef.current) return;

        closeInfoWindow();
        selectedInfoWindowOpenRef.current = true;

        const lat = parseFloat(contrato.LastMsgLat);
        const lng = parseFloat(contrato.LastMsgLong);
        const hasValidPosition = !Number.isNaN(lat) && !Number.isNaN(lng);

        setSelectedContractID(contrato.ContractID);

        if (isMobile) {
            setMobileInfoContrato(contrato);
            setMobileInfoOpen(true);
            setMenuVisible(false);

            if (hasValidPosition) {
                const mobilePosition = new google.maps.LatLng(lat, lng);
                if (options.focusZoom) {
                    const currentZoom = mapRef.current.getZoom?.() ?? 0;
                    const targetZoom = Math.max(currentZoom, 8);
                    mapRef.current.panTo(mobilePosition);
                    if (currentZoom < targetZoom) mapRef.current.setZoom(targetZoom);
                } else {
                    mapRef.current.panTo(mobilePosition);
                }
            }
            return;
        }

        const container = document.createElement("div");
        container.className = "info-window-selected";
        const root = createRoot(container);
        flushSync(() => {
            root.render(
                <InfoWindowContent
                    contrato={contrato}
                    openModalContratoSeguimiento={() => openModalContratoSeguimiento(contrato)}
                    openReporteConsolidado={() => openModalConsolidado(contrato)}
                    openModalGaleria={() => openModalImagens(contrato)}
                    openModalSeguir={() => openModalSeguirPanel(contrato)}
                    openModalEnVivo={() => openModalEnVivo(contrato)}
                    onClose={closeInfoWindow}
                />
            );
        });

        if (!hasValidPosition) {
            selectedInfoWindowOpenRef.current = false;
            return;
        }
        const position = new google.maps.LatLng(lat, lng);

        const openWindow = () => {
            infoWindowRef.current = new google.maps.InfoWindow({
                content: container,
                position,
                pixelOffset: new google.maps.Size(0, -20),
            });

            infoWindowRef.current.addListener("closeclick", () => {
                closeInfoWindow();
            });
            infoWindowRef.current.addListener("domready", () => {
                const selectedContainer = document.querySelector(".info-window-selected");
                const iwBody = selectedContainer?.closest(".gm-style-iw-d");
                const iwContainer = selectedContainer?.closest(".gm-style-iw");
                const iwOuter = iwContainer?.parentElement;
                const closeBtn = iwOuter?.querySelector(".gm-ui-hover-effect");
                if (closeBtn) closeBtn.style.display = isMobile ? "none" : "";
                if (iwOuter) {
                    iwOuter.style.zIndex = "12020";
                    iwOuter.classList.toggle("info-window-mobile-shell", isMobile);
                }
                if (iwContainer) {
                    iwContainer.classList.add("info-window-selected-container");
                    iwContainer.style.setProperty("overflow-y", "visible", "important");
                    iwContainer.style.overflowX = "hidden";
                    iwContainer.style.setProperty("max-height", "none", "important");
                    if (isMobile) {
                        iwContainer.style.width = "100vw";
                        iwContainer.style.maxWidth = "100vw";
                    }
                }
                if (iwBody) {
                    iwBody.classList.add("info-window-selected-body");
                    iwBody.style.overflowX = "hidden";
                    if (!isMobile) {
                        iwBody.style.setProperty("overflow-y", "visible", "important");
                        iwBody.style.setProperty("max-height", "none", "important");
                    }
                }
                iwBody?.classList.toggle("info-window-mobile-body", isMobile);
                if (isMobile && container?.firstChild instanceof HTMLElement) {
                    container.firstChild.style.width = "100vw";
                    container.firstChild.style.maxWidth = "100vw";
                }
            });

            infoWindowRef.current.open(mapRef.current);
            if (isMobile) setMenuVisible(false);
        };

        if (options.focusZoom) {
            const currentZoom = mapRef.current.getZoom?.() ?? 0;
            const targetZoom = Math.max(currentZoom, 8);
            openWindow();
            mapRef.current.panTo(position);
            if (currentZoom < targetZoom) mapRef.current.setZoom(targetZoom);
        } else {
            openWindow();
            mapRef.current.panTo(position);
        }
    };

    const bindMarkerOpenAction = (entry) => {
        const anchorEl = entry.anchorEl;
        if (!anchorEl) return;

        anchorEl.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const currentContrato = entry.contrato;
            if (!currentContrato) return;
            closeHoverInfoWindow();
            openInfoWindowForContrato(currentContrato, { focusZoom: true });
        };
    };

    const bindContractMarkerInteractions = (entry) => {
        const anchorEl = entry.anchorEl;
        if (!anchorEl || anchorEl.dataset.hoverBound === "1") return;

        anchorEl.classList.add("marker-hover-anchor");
        anchorEl.tabIndex = 0;
        anchorEl.style.cursor = "default";
        anchorEl.dataset.hoverBound = "1";
        bindMarkerOpenAction(entry);
        anchorEl.addEventListener("pointerdown", () => {
            hoverInteractionRef.current.markerPointerDown = true;
            hoverInteractionRef.current.markerFocused = false;
        });
        const openTooltip = () => {
            const currentContrato = entry.contrato;
            const currentPosition = entry.overlay?.basePosition || entry.position;
            if (!currentContrato || !currentPosition) return;

            openHoverInfoWindow({
                markerId: currentContrato.ContractID,
                anchorEl,
                position: currentPosition,
                content: buildHoverContentContrato(currentContrato),
                contrato: currentContrato,
            });
        };

        const closeTooltip = () => {
            scheduleCloseHoverInfoWindow(220, entry.contrato?.ContractID ?? null);
        };

        anchorEl.addEventListener("mouseenter", () => {
            hoverInteractionRef.current.markerHovered = true;
            openTooltip();
        });
        anchorEl.addEventListener("mouseleave", (event) => {
            hoverInteractionRef.current.markerHovered = false;
            if (document.activeElement === anchorEl) {
                anchorEl.blur();
            }
            if (isTargetInsideNodes(event.relatedTarget, hoverTooltipPortalRef.current)) {
                return;
            }
            closeTooltip();
        });
        anchorEl.addEventListener("focusin", () => {
            const fromPointer = hoverInteractionRef.current.markerPointerDown;
            hoverInteractionRef.current.markerPointerDown = false;
            hoverInteractionRef.current.markerFocused = !fromPointer;
            if (document.activeElement?.closest?.(".marker-info-button")) return;
            openTooltip();
        });
        anchorEl.addEventListener("focusout", (event) => {
            hoverInteractionRef.current.markerFocused = false;
            if (isTargetInsideNodes(event.relatedTarget, anchorEl, hoverTooltipPortalRef.current)) return;
            closeTooltip();
        });
    };

    const addMarkers = () => {
        const map = mapRef.current;
        if (!map) return;

        const activeHoverMarkerId = activeMarkerHoverRef.current?.markerId ?? null;
        const shouldPreserveHover = activeHoverMarkerId !== null
            && filteredContracts.some((item) => item.ContractID === activeHoverMarkerId);

        if (!shouldPreserveHover) {
            closeHoverInfoWindow();
        }

        const nextMarkersById = {};
        const visibleIds = new Set();

        filteredContracts.forEach((c) => {
            if (showSeguirPanel && contratoSelected?.ContractID === c.ContractID) return;

            const lat = parseFloat(c.LastMsgLat);
            const lng = parseFloat(c.LastMsgLong);
            if (Number.isNaN(lat) || Number.isNaN(lng)) return;

            visibleIds.add(String(c.ContractID));
            const position = new google.maps.LatLng(lat, lng);
            const html = buildContractMarkerHtml(c);

            let entry = markersByIdRef.current[c.ContractID];

            if (!entry?.overlay) {
                entry = {
                    contrato: c,
                    position,
                    overlay: null,
                    anchorEl: null,
                };

                const overlay = new HtmlMarker(
                    position,
                    map,
                    html,
                    null,
                    (divEl) => {
                        entry.anchorEl = divEl;
                        bindContractMarkerInteractions(entry);
                    }
                );

                if (!overlay) return;
                entry.overlay = overlay;
            }

            entry.contrato = c;
            entry.position = position;
            entry.overlay.setBasePosition?.(position);
            entry.overlay.setPosition?.(position);
            entry.overlay.setHidden?.(false);
            entry.overlay.setHtml?.(html);

            if (entry.anchorEl) {
                bindMarkerOpenAction(entry);
                entry.anchorEl.setAttribute(
                    "aria-label",
                    `Mostrar resumen de ${c.PlacaTruck || c.Ref || "vehículo"}`
                );
            }

            nextMarkersById[c.ContractID] = entry;

            if (shouldPreserveHover && c.ContractID === activeHoverMarkerId && entry.anchorEl) {
                openHoverInfoWindow({
                    markerId: c.ContractID,
                    anchorEl: entry.anchorEl,
                    position,
                    content: buildHoverContentContrato(c),
                    contrato: c,
                });
            }
        });

        Object.entries(markersByIdRef.current).forEach(([contractId, entry]) => {
            if (visibleIds.has(String(contractId))) return;
            entry?.overlay?.setMap?.(null);
        });

        markersByIdRef.current = nextMarkersById;

        if (!showSeguirPanel && !userZoomedRef.current) {
            const bounds = new google.maps.LatLngBounds();

            Object.values(markersByIdRef.current).forEach(({ overlay }) => {
                if (overlay?.basePosition) bounds.extend(overlay.basePosition);
                else if (overlay?.position) bounds.extend(overlay.position);
            });

            if (!bounds.isEmpty()) {
                map.fitBounds(bounds);
                google.maps.event.addListenerOnce(map, "idle", () => {
                    if (map.getZoom() > 15) map.setZoom(15);
                    relayoutCloseVehicles();
                });
            }
        }

        if (showSeguirPanel && contratoSelected) {
            const c = filteredContracts.find((x) => x.ContractID === contratoSelected.ContractID);
            if (c) drawSingleMarker(c.LastMsgLat, c.LastMsgLong);
        }

        relayoutCloseVehicles();
    };

    const updateContratos = (newContracts) => {
        setContracts(newContracts);
    };

    const connectSocket = () => {
        const token = localStorage.getItem("tkn");
        if (socketRef.current) socketRef.current.close();

        const ws = new WebSocket(`wss://${process.env.REACT_APP_SERVER_WEBSOCKET}/trafico/`, token);
        socketRef.current = ws;

        ws.onopen = () => console.warn("WebSocket de mapcenter conectado");


        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.event === true && data.data) {
                updateContratos(data.data);

                if (contratoSelected) {
                    ListReports(contratoSelected, 0, 1);
                }
            }
        };

        ws.onerror = (error) => console.error("Error en la conexión WebSocket (contratosMapcenter):", error);

        ws.onclose = (event) => {
            console.error("Conexión cerrada (contratosMapcenter):", event.reason);
            setTimeout(() => connectSocket(), 2000);
        };
    };

    useEffect(() => {
        return () => {
            if (socketRef.current) socketRef.current.close();
            clearGeocercaPulseAnimations();
        };
    }, []);

    const sortByCriteria = (list, val) => {
        // si ya tienes esta función en otro lado, puedes quitar esto y usar la tuya.
        // Aquí dejo un fallback seguro.
        return list;
    };

    const applyFilters2 = (incomingFilters, contractsBase) => {
        const array = Array.isArray(incomingFilters)
            ? incomingFilters
            : Array.isArray(incomingFilters?.filters)
                ? incomingFilters.filters
                : [];

        setArrayFilter(array);
        setNotificationCircle(array.length > 0);
        localStorage.setItem("arrayFilters", JSON.stringify({ filters: array }));

        const term = search.trim().toLowerCase();
        let result = contractsBase.filter((c) =>
            (c.FKLokDeviceID || "").toLowerCase().includes(term) ||
            (c.PlacaTruck || "").toLowerCase().includes(term) ||
            (c.ContainerNum || "").toLowerCase().includes(term) ||
            (c.NombreConductor || "").toLowerCase().includes(term) ||
            (c.DescripcionRuta || "").toLowerCase().includes(term) ||
            (c.DescripcionTrayecto || "").toLowerCase().includes(term) ||
            (c.Ciudad || "").toLowerCase().includes(term) ||
            (c.CiudadOrigen || "").toLowerCase().includes(term) ||
            (c.CiudadDestino || "").toLowerCase().includes(term) ||
            (c.geocerca || "").toLowerCase().includes(term) ||
            (c.LastReportUbica || "").toLowerCase().includes(term) ||
            (c.NombreEmpresa || "").toLowerCase().includes(term) ||
            (c.NombreTranspo || "").toLowerCase().includes(term) ||
            String(c.ContractID || "").toLowerCase().includes(term)
        );

        array.forEach((f) => {
            const key = Object.keys(f)[0];
            const val = f[key];

            switch (key) {
                case "filterEmpresa":
                    result = result.filter((c) =>
                        getCompanyFilterCandidates(c).some((company) => val.includes(company))
                    );
                    break;
                case "filterEstado":
                    result = result.filter((c) => val.includes(c.TipoReporte));
                    break;
                case "filterRuta":
                    result = result.filter((c) => val.includes(c.DescripcionRuta));
                    break;
                case "filterCiudadOrigen":
                    result = result.filter((c) => val.includes(c.CiudadOrigen));
                    break;
                case "filterCiudadDestino":
                    result = result.filter((c) => val.includes(c.CiudadDestino));
                    break;
                case "filterDispositivo":
                    result = result.filter((c) => val.includes(c.FKLokDeviceID));
                    break;
                case "filterAlerta":
                    result = result.filter((c) => {
                        const alertIcons = [
                            c.IconMoving,
                            c.IconBack,
                            c.icon_bat,
                            c.IconDesvio,
                            c.IconLocked,
                            c.IconSeguro,
                            c.IconValitronics,
                        ].map((ic) => ic?.split("/").pop().replace(/\.(png|gif)$/, ""));

                        const byIcon = alertIcons.some((name) => val.alertas?.includes(name) && name !== "transparent");

                        let byTimeReport = false;
                        if (val.tiempoUltReporte) {
                            const diffMin = getElapsedMinutesFromUtc(c.LoksysServerTime);
                            byTimeReport = diffMin >= parseInt(val.tiempoUltReporte, 10);
                        }

                        let byStopTime = false;
                        if (val.tiempoDetencion) {
                            byStopTime = parseInt(c.tiempodetencion || 0, 10) >= parseInt(val.tiempoDetencion, 10);
                        }

                        const byNoGps = val.alertas?.includes("nogps") && c.bitGPS === true;
                        const byNoRoute =
                            val.alertas?.includes("trayectonull") && c.DescripcionTrayecto == null && c.FKLokTipoEquipo === 9;

                        return byIcon || byTimeReport || byStopTime || byNoGps || byNoRoute;
                    });
                    break;
                case "orderByCriteria":
                    result = sortByCriteria(result, val);
                    break;
                default:
                    break;
            }
        });

        setCounters(result);
        return result;
    };

    const setCounters = (result) => {
        const countOpenChain = result.filter((c) => (c.IconLocked || "").includes("candado") || (c.IconLocked || "").includes("openedpadlockalerta")).length;
        const countLowBattery = result.filter((c) => (c.icon_bat || "").includes("batt-low")).length;
        const countMoving = result.filter((c) => (c.IconMoving || "").includes("moving")).length;
        const countStop = result.filter((c) => (c.IconMoving || "").includes("stop")).length;
        const countStopAlert = result.filter((c) => (c.IconMoving || "").includes("stopAlert")).length;
        const countDesvio = result.filter((c) => (c.IconDesvio || "").includes("desvioalerta")).length;
        const countNoGps = result.filter((c) => c.bitGPS === true).length;
        const countNoRuta = result.filter((c) => c.DescripcionTrayecto === null && c.FKLokTipoEquipo === 9).length;
        const countUnsecured = result.filter((c) => isUnsecuredContrato(c)).length;

        setOpenCount(countOpenChain);
        setLowBatteryCount(countLowBattery);
        setMovingCount(countMoving);
        setStopCount(countStop);
        setStopAlertCount(countStopAlert);
        setDesvioCount(countDesvio);
        setNoGpsCount(countNoGps);
        setNoRutaCount(countNoRuta);
        setUnsecuredCount(countUnsecured);
    };

    const handleNewValueSavedFilter = (newFilters) => {
        setSavedFilters(newFilters);
    };

    const getPolygonCenter = (polygon) => {
        const path = polygon.getPath().getArray();
        if (path.length === 0) return { lat: 0, lng: 0 };

        const { latSum, lngSum } = path.reduce(
            (acc, pt) => ({ latSum: acc.latSum + pt.lat(), lngSum: acc.lngSum + pt.lng() }),
            { latSum: 0, lngSum: 0 }
        );

        const count = path.length;
        return { lat: latSum / count, lng: lngSum / count };
    };

    const mostrarInformacionGeocerca = (geocerca, polygon) => {
        const { lat, lng } = getPolygonCenter(polygon);
        const position = new google.maps.LatLng(lat, lng);

        const content = `
      <div>
        <h5>${geocerca.Nombre}</h5>
        <p>${geocerca.Descripcion}</p>
      </div>
    `;

        if (geofenceInfoWindowRef.current) geofenceInfoWindowRef.current.close();

        const info = new google.maps.InfoWindow({ content, position });
        info.open(mapRef.current);
        geofenceInfoWindowRef.current = info;
    };

    const mostrarInformacionMarker = (geocerca, marker) => {
        const position = marker.getPosition();
        const content = `
        <div>
            <h5>${geocerca.Nombre}</h5>
            <p>${geocerca.Descripcion}</p>
        </div>
    `;
        if (infoWindowMarkerRef.current) infoWindowMarkerRef.current.close();

        const info = new google.maps.InfoWindow({ content, position });
        info.open(mapRef.current);
        infoWindowMarkerRef.current = info;
    }

    const applyGeocercas = () => {
        saveGeoPreviousView();

        if (!geoFilter.showAll && (!geoFilter.selectedIds || geoFilter.selectedIds.length === 0)) {
            geocercaPolygonsRef.current.forEach((p) => p.setMap(null));
            geocercaPolygonsRef.current = [];
            setGeocercaPolygons([]);
            clearGeofenceActionsOverlay();
            if (geofenceInfoWindowRef.current) {
                geofenceInfoWindowRef.current.close();
                geofenceInfoWindowRef.current = null;
            }
            return;
        }

        if (geoFilter.showAll) {
            dibujarGeocercas(listGeocercas, true);
            return;
        }

        const selectedSet = new Set((geoFilter.selectedIds || []).map(String));
        const subset = listGeocercas.filter((g) => selectedSet.has(String(g.ID)));
        dibujarGeocercas(subset, true);
    };

    const fetchAllGeocercas = (nombre = "") => {
        const requestId = geoFetchRequestRef.current + 1;
        geoFetchRequestRef.current = requestId;
        const requestConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
        };
        const normalizedName = String(nombre || "").trim();

        setIsGeocercasLoading(true);
        const request = isGeocercasOnly
            ? axios.post(
                `${process.env.REACT_APP_SERVER}/geocercas/getgeocercas`,
                { nombre: normalizedName },
                requestConfig
            )
            : axios.get(
                `${process.env.REACT_APP_SERVER}/maestros/getgeocercas`,
                requestConfig
            );

        request
            .then((response) => {
                if (requestId !== geoFetchRequestRef.current) return;
                const geocercas = Array.isArray(response.data?.data)
                    ? response.data.data
                    : Array.isArray(response.data)
                        ? response.data
                        : [];
                console.log("Geocercas obtenidas:", geocercas);
                setListGeocercas(geocercas);
            })
            .catch((error) => console.error("Error al listar geocercas:", error))
            .finally(() => {
                if (requestId === geoFetchRequestRef.current) {
                    setIsGeocercasLoading(false);
                }
            });
    };



    const initializeMap = () => {
        if (!window.google?.maps || mapRef.current || !mapContainerRef.current) return;

        const maps = window.google.maps;

        const map = new maps.Map(mapContainerRef.current, {
            center: { lat: 20.0, lng: 0.0 },
            zoom: 2,
            mapTypeId: "roadmap",
            zoomControl: false,
            rotateControl: false,
            fullscreenControl: false,
            streetViewControl: true,
            streetViewControlOptions: { position: maps.ControlPosition.LEFT_BOTTOM },
            mapTypeControl: !isMobile,
            mapTypeControlOptions: {
                style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: maps.ControlPosition.LEFT_TOP,
                mapTypeIds: ["roadmap", "satellite", "openstreetmap"],
            },
        });

        mapRef.current = map;
        registerOpenStreetMap(window.google, map, { showControl: true });
        infoWindowRef.current = new maps.InfoWindow();

        const proj = new maps.OverlayView();
        proj.onAdd = () => { };
        proj.draw = () => { };
        proj.onRemove = () => { };
        proj.setMap(map);
        projectionOverlayRef.current = proj;

        map.addListener("zoom_changed", () => {
            userZoomedRef.current = true;
            closeHoverInfoWindow();
            relayoutCloseVehicles();
        });
        map.addListener("click", () => closeHoverInfoWindow());
        map.addListener("dragstart", () => closeHoverInfoWindow());
        map.addListener("dragend", () => relayoutCloseVehicles());
        map.addListener("idle", () => relayoutCloseVehicles());
    };

    useEffect(() => {
        const stepInfo = getOffcanvasStepInfo(tourStepIndex);
        if (!stepInfo) return;

        const open = isOffcanvasOpen(stepInfo.key);

        // Paso 1: esperar que lo ABRA
        if (waitMode === "open" && stepInfo.kind === "button") {
            if (open) {
                // ya lo abrió, ahora debe cerrarlo
                setWaitMode("close");
                setTourStepIndex(stepInfo.panelIndex);
            }
            return;
        }

        // Paso 2: esperar que lo CIERRE
        if (waitMode === "close") {
            if (!open) {
                // ya lo cerró -> siguiente paso
                setWaitMode(null);
                setTourStepIndex(stepInfo.panelIndex + 1);
            }
        }
    }, [
        tourStepIndex,
        waitMode,
        offcanvasOpen,
        offcanvasOpenGeocercas,
        offcanvasOpenGeorutas,
        inviasOffcanvasOpen,
    ]);

    useEffect(() => {
        if (waitMode !== "fastFiltersOpen") return;
        if (!fastFilter) return;
        setWaitMode(null);
        setTourStepIndex(TOUR_STEP_INDEX.fastFiltersPanel);
    }, [waitMode, fastFilter]);



    useEffect(() => {
        if (window.google?.maps) initializeMap();
    }, []);

    useEffect(() => {
        if (
            !mapRef.current ||
            !placeSearchInputRef.current ||
            !window.google?.maps?.places
        ) return undefined;

        const maps = window.google.maps;
        const autocomplete = new maps.places.Autocomplete(placeSearchInputRef.current, {
            fields: ["formatted_address", "geometry", "name"],
        });
        autocomplete.bindTo("bounds", mapRef.current);
        placeAutocompleteRef.current = autocomplete;

        const placeChangedListener = autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place?.geometry?.location) {
                toast.error("Selecciona un sitio de las sugerencias de Google Maps.");
                return;
            }

            setPlaceSearch(place.formatted_address || place.name || "");

            if (placeSearchMarkerRef.current) {
                placeSearchMarkerRef.current.setMap(null);
            }
            placeSearchMarkerRef.current = new maps.Marker({
                map: mapRef.current,
                position: place.geometry.location,
                title: place.name || place.formatted_address || "Sitio seleccionado",
                animation: maps.Animation.DROP,
            });

            if (place.geometry.viewport) {
                mapRef.current.fitBounds(place.geometry.viewport);
            } else {
                mapRef.current.setCenter(place.geometry.location);
                mapRef.current.setZoom(16);
            }
        });

        return () => {
            placeChangedListener.remove();
            autocomplete.unbindAll();
            placeAutocompleteRef.current = null;
            if (placeSearchMarkerRef.current) {
                placeSearchMarkerRef.current.setMap(null);
                placeSearchMarkerRef.current = null;
            }
        };
    }, [isGeocercasOnly]);

    useEffect(() => {
        if (!mapRef.current || !window.google?.maps) return undefined;
        renderGeoDraftGeometry(geoDraftPoints, geoDraftHoverPoint);

        return () => {
            clearGeoDraftGeometry();
        };
    }, [clearGeoDraftGeometry, geoDraftHoverPoint, geoDraftPoints, renderGeoDraftGeometry]);

    useEffect(() => {
        const map = mapRef.current;
        const canUseInlineGeoCrud = isGeocercasOnly || offcanvasOpenGeocercas;
        if (!map || !window.google?.maps || geoCrudMode === "browse" || !canUseInlineGeoCrud) return undefined;

        map.setOptions({
            draggableCursor: "crosshair",
            draggable: geoDraftMode !== "trackpad",
        });

        const rightClickListener = !isGeoDraftClosed
            ? map.addListener("rightclick", (event) => {
                event?.domEvent?.preventDefault?.();
                cancelGeoDraft();
            })
            : null;

        if (geoDraftMode === "points" && !isGeoDraftClosed) {
            const clickListener = map.addListener("click", (event) => {
                const nextPoint = normalizeGeoDraftPoint(event?.latLng);
                if (!nextPoint) return;
                setGeoDraftPoints((prev) => [...prev, nextPoint]);
            });

            const moveListener = map.addListener("mousemove", (event) => {
                updateGeoDrawTooltip(event);
                const hoverPoint = normalizeGeoDraftPoint(event?.latLng);
                setGeoDraftHoverPoint(hoverPoint);
            });

            return () => {
                clickListener.remove();
                moveListener.remove();
                rightClickListener?.remove();
                setGeoDraftHoverPoint(null);
                setGeoDrawTooltip(null);
                map.setOptions({ draggableCursor: null, draggable: true });
            };
        }

        if (geoDraftMode === "trackpad" && !isGeoDraftClosed) {
            const shouldAppendPoint = (prevPoint, nextPoint) => {
                if (!prevPoint) return true;
                const latDiff = Math.abs(prevPoint.lat - nextPoint.lat);
                const lngDiff = Math.abs(prevPoint.lng - nextPoint.lng);
                return latDiff + lngDiff > 0.0025;
            };

            const startListener = map.addListener("mousedown", (event) => {
                const nextPoint = normalizeGeoDraftPoint(event?.latLng);
                geoTrackpadIsDrawingRef.current = true;
                setIsGeoTrackpadDrawing(true);
                if (!nextPoint) return;
                setGeoDraftPoints((prev) => [...prev, nextPoint]);
            });

            const moveListener = map.addListener("mousemove", (event) => {
                updateGeoDrawTooltip(event);
                if (!geoTrackpadIsDrawingRef.current) return;
                const nextPoint = normalizeGeoDraftPoint(event?.latLng);
                if (!nextPoint) return;

                setGeoDraftPoints((prev) => {
                    const lastPoint = prev[prev.length - 1];
                    if (!shouldAppendPoint(lastPoint, nextPoint)) return prev;
                    return [...prev, nextPoint];
                });
            });

            const stopDrawing = () => {
                geoTrackpadIsDrawingRef.current = false;
                setIsGeoTrackpadDrawing(false);
            };

            const upListener = map.addListener("mouseup", stopDrawing);
            const dragEndListener = map.addListener("dragend", stopDrawing);
            const idleWindowMouseUp = () => stopDrawing();
            window.addEventListener("mouseup", idleWindowMouseUp);

            return () => {
                startListener.remove();
                moveListener.remove();
                upListener.remove();
                dragEndListener.remove();
                rightClickListener?.remove();
                window.removeEventListener("mouseup", idleWindowMouseUp);
                stopDrawing();
                setGeoDraftHoverPoint(null);
                setGeoDrawTooltip(null);
                map.setOptions({ draggableCursor: null, draggable: true });
            };
        }

        return () => {
            rightClickListener?.remove();
            setGeoDraftHoverPoint(null);
            setGeoDrawTooltip(null);
            map.setOptions({ draggableCursor: null, draggable: true });
        };
    }, [cancelGeoDraft, geoCrudMode, geoDraftMode, isGeoDraftClosed, normalizeGeoDraftPoint, offcanvasOpenGeocercas, isGeocercasOnly, updateGeoDrawTooltip]);

    useEffect(() => {
        if (isGeocercasOnly) return;
        listContracts();
        connectSocket();
    }, [isGeocercasOnly]);

    useEffect(() => {
        console.log("Contractos actualizados ", contracts);
    }, [contracts])

    useEffect(() => {
        if (initialPanelSeededRef.current) return;
        initialPanelSeededRef.current = true;

        if (initialOpenPanel === "filters") setOffcanvasOpen(true);
        if (initialOpenPanel === "geocercas") setOffcanvasOpenGeocercas(true);
        if (initialOpenPanel === "georutas") setOffcanvasOpenGeorutas(true);
        if (initialOpenPanel === "invias") {
            setInviasCountriesDraft(inviasCountries);
            setInviasOffcanvasOpen(true);
        }
    }, [initialOpenPanel, inviasCountries]);

    useEffect(() => {
        if (isGeocercasOnly) return;
        addMarkers();
    }, [filteredContracts, markerLabelFields, showPlateBadges, isGeocercasOnly]);

    useEffect(() => {
        if (!showRefuerzosPanel) return;
        const placa = contratoSelected?.PlacaTruck?.toString().trim();
        if (!placa) return;
        applySearchTerm(placa);
    }, [showRefuerzosPanel, contratoSelected, contracts]);

    useEffect(() => {
        const prev = prevContratoRef.current;
        const curr = contratoSelected;
        if (prev && curr) {
            const diffs = Object.entries(curr)
                .filter(([key]) => key.startsWith("Icon") && prev[key] !== curr[key])
                .map(([key]) => key);
            if (diffs.length) setChangedIcons(diffs);
        }
        prevContratoRef.current = curr;
    }, [contratoSelected]);

    useEffect(() => {
        if (!contratoSelected) return;
        const updated = contracts.find((c) => c.ContractID === contratoSelected.ContractID);
        if (updated) setContratoSelected(updated);
    }, [contracts]);

    useEffect(() => {
        const uniques = [...new Set(listaMensajes.map((o) => o.NombreGeocerca).filter((x) => x !== null))];
        const geocercaWithVertices = uniques
            .map((geocerca) => {
                const objeto = listaMensajes.find((item) => item.NombreGeocerca === geocerca && item.Vertices);
                return objeto ? { geocerca, vertices: objeto.Vertices } : null;
            })
            .filter(Boolean);

        setUniquesGeocerca(geocercaWithVertices);
        setLastReport(listaMensajes[0]);
    }, [listaMensajes]);

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("arrayFilters"));
        if (storedFilters && Array.isArray(storedFilters.filters)) {
            setArrayFilter(storedFilters.filters);
            // si quieres re-aplicar: déjalo como lo tienes en tu versión original
            setNotificationCircle(storedFilters.filters.length > 0);
        } else {
            setArrayFilter([]);
        }
    }, []);

    useEffect(() => {
        if (!isGeocercasOnly) return undefined;

        const searchTimer = window.setTimeout(() => {
            fetchAllGeocercas(geoListSearch);
        }, 350);

        return () => window.clearTimeout(searchTimer);
    }, [geoListSearch, isGeocercasOnly]);

    useEffect(() => {
        if (!isGeocercasOnly || geoCrudMode === "browse") return;

        setGeoCrudMode("browse");
        resetGeoDraft();
        setGeoFilter({ showAll: false, selectedIds: [] });
        validateFilterGeocercas({ showAll: false, selectedIds: [] });
        clearGeofenceActionsOverlay();
        geocercaPolygonsRef.current.forEach((polygon) => polygon.setMap(null));
        geocercaPolygonsRef.current = [];
        setGeocercaPolygons([]);
    }, [geoListSearch, isGeocercasOnly]);

    useEffect(() => {
        if (isGeocercasOnly) return;
        if (offcanvasOpenGeocercas && listGeocercas.length === 0) fetchAllGeocercas();
    }, [offcanvasOpenGeocercas, isGeocercasOnly, listGeocercas.length]);



    useEffect(() => {
        // re-filtro total (búsqueda + filtros avanzados + quickfilter)
        let lista = filterBySearch(contracts, search);

        const raw = JSON.parse(localStorage.getItem("arrayFilters")) || {};
        const adv = Array.isArray(raw.filters) ? raw.filters : [];
        lista = applyFilters2(adv, lista);

        const q = activeQuickFilterRef.current;
        if (q) {
            lista = lista.filter((c) => {
                switch (q) {
                    case "moving":
                        return (c.IconMoving || "").includes("moving");
                    case "stop":
                        return (c.IconMoving || "").includes("stop");
                    case "stopAlert":
                        return (c.IconMoving || "").includes("stopAlert");
                    case "desvioalerta":
                        return (c.IconDesvio || "").includes("desvioalerta");
                    case "batt-low":
                        return (c.icon_bat || "").includes("batt-low");
                    case "candado":
                        return /(candado|openedpadlockalerta)/.test(c.IconLocked || "");
                    case "unsecured":
                        return isUnsecuredContrato(c);
                    case "tiempo": {
                        return getElapsedMinutesFromUtc(c.LoksysServerTime) >= 30;
                    }
                    case "refuerzo":
                        return contracts.some((a) => a.PlacaTruck === c.PlacaTruck && a.ContainerNum === c.ContainerNum && a.ContractID !== c.ContractID);
                    case "noGps":
                        return c.bitGPS === true;
                    case "noTrayecto":
                        return c.DescripcionTrayecto == null && c.FKLokTipoEquipo === 9;
                    case "streaming":
                        return isStreamingOn(c) || activeStreamDeviceSet.has(String(c?.FKLokDeviceID || ""));
                    default:
                        return true;
                }
            });
        }

        setFilteredContracts(lista);
    }, [contracts, search, activeStreamDeviceSet]);

    useEffect(() => {
        if (!showSeguirPanel) {
            clearMarkers();
            clearPolylines();
            clearCircle();
            addMarkers();
            setSearch("");
        }
    }, [showSeguirPanel]);

    useEffect(() => {
        let isMounted = true;

        if (!inviasActive) {
            clearInviasMarkers();
            setInviasLoading(false);
            setInviasPendingApply(false);
            return () => {
                isMounted = false;
            };
        }

        const loadInvias = async () => {
            try {
                setInviasLoading(true);
                const inviasEndpoint = `${process.env.REACT_APP_SERVER}/operaciones/getinviasinformation`;
                const { data } = await axios.get(
                    inviasEndpoint,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                        },
                        withCredentials: true,
                    }
                );

                if (!isMounted) return;

                if (data?.info?.error) {
                    const inviasError = data.info.error;
                    setInviasActive(false);
                    clearInviasMarkers();
                    Swal.fire({
                        icon: "error",
                        title: "Error al cargar Invias",
                        text: inviasError.message || "No se pudo obtener la informacion de Invias.",
                    });
                    return;
                }

                if (!data?.success || !data?.info) {
                    setInviasActive(false);
                    Swal.fire({
                        icon: "error",
                        title: "Error al cargar Invias",
                        text: data?.message || "No se pudo obtener la informacion de Invias.",
                    });
                    return;
                }
                // console.log(data.info.features.length + " incidentes de Invias cargados.");
                drawInviasMarkers(data.info);
                if (inviasPendingApply) {
                    setInviasOffcanvasOpen(false);
                    setInviasPendingApply(false);
                }
            } catch (error) {
                if (!isMounted) return;
                setInviasActive(false);
                Swal.fire({
                    icon: "error",
                    title: "Error al cargar Invias",
                    text: "No se pudo obtener la informacion de Invias.",
                });
            } finally {
                if (isMounted) setInviasLoading(false);
            }
        };

        loadInvias();

        return () => {
            isMounted = false;
        };
    }, [inviasActive, inviasCountries]);

    useEffect(() => () => clearInviasMarkers(), []);

    // ====== REPORTES (dejo tu estructura: si ya tienes drawTrayecto/ListReports completos, reemplaza aquí) ======
    const drawTrayecto = async (trayectoId) => {
        clearTrayectoLines();
        clearYellowCircle();
        if (!trayectoId) return;

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/getpolylinetrayecto`,
                JSON.stringify({ id: trayectoId }),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                }
            );
            if (!resp.success) return;

            const segmentos = resp.data[0].Polyline.split("||||");
            const allCoords = [];
            const bounds = new google.maps.LatLngBounds();

            segmentos.forEach((seg) => {
                const path = google.maps.geometry.encoding.decodePath(seg);
                allCoords.push(...path);

                const pl = new google.maps.Polyline({
                    path,
                    geodesic: true,
                    strokeColor: "#ffae00ff",
                    strokeOpacity: 0.6,
                    strokeWeight: 8,
                    map: mapRef.current,
                });

                trayectoLinesRef.current.push(pl);
                path.forEach((pt) => bounds.extend(pt));
            });

            mapRef.current.fitBounds(bounds, 80);
            google.maps.event.addListenerOnce(mapRef.current, "idle", () => {
                if (mapRef.current.getZoom() > 15) mapRef.current.setZoom(15);
            });

            const last = allCoords[allCoords.length - 1];
            if (last) drawYellowCircle(last.lat(), last.lng());
        } catch (err) {
            console.error("Error dibujando trayecto:", err);
        }
    };

    const ListReports = async (contrato, all, op) => {
        const payload = {
            fechainicio: contrato.fecha,
            fechafin: contrato.fechafin,
            device: contrato.FKLokDeviceID,
            utcMinutos: 5,
            allreport: all,
            tipo: contrato.Active,
            tipoequipo: contrato.FKLokTipoEquipo,
        };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/getreportesdevice`,
                JSON.stringify(payload),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );

            if (!resp.success) {
                return Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: resp.message || "No se obtuvieron reportes.",
                });
            }

            Swal.close();
            const mensajes = resp.data;
            setListaMensajes(mensajes);

            clearArrowLines();
            clearTrayectoLines();
            clearCircle();

            if (contrato.trayecto) {
                await drawTrayecto(contrato.trayecto);
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error al obtener los reportes",
                text: error.message,
            });
        }
    };

    const ensureMutedStreamUrl = (url) => {
        if (!url) return url;
        const lower = String(url).toLowerCase();
        const hasMute = lower.includes("mute=");
        const hasMuted = lower.includes("muted=");
        const hasAutoplay = lower.includes("autoplay=");
        let next = url;
        if (!hasMute && !hasMuted) next += `${next.includes("?") ? "&" : "?"}mute=true`;
        if (!hasAutoplay) next += `${next.includes("?") ? "&" : "?"}autoplay=true`;
        return next;
    };

    const renderActiveStreams = () => {
        if (!displayStreams || displayStreams.length === 0) {
            return (
                <div style={{ color: "#6c757d", fontSize: 14 }}>
                    No hay transmisiones activas.
                </div>
            );
        }

        const term = liveSearch.trim().toLowerCase();
        const filteredStreams = term
            ? displayStreams.filter((stream) => {
                const contrato = getContratoByDevice(stream.deviceId) || { FKLokDeviceID: stream.deviceId };
                    const dispositivo = contrato.FKLokDeviceID || stream.deviceId || "N/D";
                    const placa = contrato.PlacaTruck || "N/D";
                    const cliente = contrato.NombreEmpresa || "N/D";            const match = `${dispositivo} ${placa} ${cliente}`.toLowerCase();
                return match.includes(term);
            })
            : displayStreams;
        const panelWidth = Number(livePanelLayout?.width || 420);
        const compactRows = panelWidth < 560;
        const gridCols = compactRows ? 1 : panelWidth >= 980 ? 3 : panelWidth >= 700 ? 2 : 1;

        return (
            <div style={{ display: "grid", gap: 12 }}>
                <div style={{ position: "sticky", top: 0, zIndex: 2, background: "#fff", padding: "6px 4px" }}>
                    <div className="input-group">
                        <span className="input-group-text">
                            <FaSearch />
                        </span>
                        <Input
                            type="text"
                            className="form-control"
                            placeholder="Buscar live..."
                            value={liveSearch}
                            onChange={(e) => setLiveSearch(e.target.value)}
                        />
                    </div>
                </div>

                {filteredStreams.length === 0 ? (
                    <div style={{ color: "#6c757d", fontSize: 14 }}>
                        No hay transmisiones que coincidan con la búsqueda.
                    </div>
                ) : (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`,
                            gap: 12,
                            alignItems: "start",
                        }}
                    >
                        {filteredStreams.map((stream) => {
                    const contrato = getContratoByDevice(stream.deviceId) || { FKLokDeviceID: stream.deviceId };
                    const dispositivo = contrato.FKLokDeviceID || stream.deviceId || "N/D";
                    const placa = contrato.PlacaTruck || "N/D";
                    const cliente = contrato.NombreEmpresa || "N/D";
                    const handleOpenLive = () => openModalEnVivoFromLiveList(contrato, stream.streamId);

                    return (
                        <div
                            key={stream.streamId}
                            style={{
                                background: "#fff",
                                borderRadius: 10,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                overflow: "hidden",
                                border: "1px solid #e6eef7",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: compactRows ? "row" : "column",
                                alignItems: "stretch",
                                minWidth: 0,
                            }}
                            onClick={handleOpenLive}>
                            <div
                                style={{
                                    padding: compactRows ? "10px 12px" : "8px 10px",
                                    flex: "1 1 auto",
                                    minWidth: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                                onClick={handleOpenLive}
                            >
                                <div style={{ fontWeight: 700, fontSize: compactRows ? 15 : 18 }}>{dispositivo}</div>
                                <div style={{ fontSize: 12, color: "#5f6b7a", marginTop: compactRows ? 4 : 2 }}>
                                    Placa: {placa} · Cliente: {cliente}
                                </div>
                            </div>
                            <div
                                style={{
                                    flex: compactRows ? "0 0 42%" : "0 0 auto",
                                    width: compactRows ? "42%" : "100%",
                                    minWidth: compactRows ? 132 : "100%",
                                    maxWidth: compactRows ? 180 : "100%",
                                    borderLeft: compactRows ? "1px solid #e6eef7" : "none",
                                    borderTop: compactRows ? "none" : "1px solid #e6eef7",
                                    background: "#eef4fa",
                                }}
                            >
                                <iframe
                                    title={`live-${stream.deviceId}`}
                                    src={ensureMutedStreamUrl(stream.streamId)}
                                    width="100%"
                                    height={compactRows ? "112" : gridCols >= 3 ? "170" : "220"}
                                    allow="autoplay; fullscreen"
                                    style={{ border: "none", display: "block", pointerEvents: "none" }}
                                />
                            </div>
                        </div>
                    );
                        })}
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        if (document.getElementById("mapcenter-live-badge-styles")) return;
        const style = document.createElement("style");
        style.id = "mapcenter-live-badge-styles";
        style.innerHTML = `
      @keyframes mapcenterLivePulseDot {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.35); opacity: 0.55; }
        100% { transform: scale(1); opacity: 1; }
      }
      @keyframes mapcenterLivePulseWrap {
        0% { box-shadow: 0 0 0 0 rgba(255, 45, 45, 0.28); }
        70% { box-shadow: 0 0 0 6px rgba(255, 45, 45, 0); }
        100% { box-shadow: 0 0 0 0 rgba(255, 45, 45, 0); }
      }
    `;
        document.head.appendChild(style);
    }, []);

    const renderLiveBadge = (deviceId) => {
        const isLive = activeStreamDeviceSet.has(String(deviceId || ""));
        if (!isLive) return null;
        return (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "1px 8px",
                    borderRadius: 999,
                    background: "rgba(255, 45, 45, 0.12)",
                    color: "#d90429",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: 0.3,
                    lineHeight: 1.5,
                    border: "1px solid rgba(255, 45, 45, 0.35)",
                    animation: "mapcenterLivePulseWrap 1.5s ease-in-out infinite",
                }}
                title="Streaming activo"
            >
                <span
                    aria-hidden="true"
                    style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "#ff2d2d",
                        animation: "mapcenterLivePulseDot 1.2s ease-in-out infinite",
                    }}
                />
                LIVE
            </span>
        );
    };
    const selectGeocercaFromCard = (geocerca) => {
        if (!geocerca?.ID) return;
        const selectedId = String(geocerca.ID);
        setShowAllGeocercasOnMap(false);
        saveGeoPreviousView();
        setGeoFilter({ showAll: false, selectedIds: [selectedId] });
        validateFilterGeocercas({ showAll: false, selectedIds: [selectedId] });
        dibujarGeocercas([geocerca], true);
    };
    const toggleAllGeocercasOnMap = async () => {
        if (showAllGeocercasOnMap) {
            setShowAllGeocercasOnMap(false);
            geocercaPolygonsRef.current.forEach((polygon) => polygon.setMap(null));
            geocercaPolygonsRef.current = [];
            setGeocercaPolygons([]);
            clearGeofenceActionsOverlay();

            if (selectedGeoruta && allGeocercasForTrayecto.length > 0) {
                const selectedIdsSet = new Set((trayectoGeocercaSelectedIds || []).map(String));
                const selectedGeocercas = allGeocercasForTrayecto.filter((geocerca) =>
                    selectedIdsSet.has(getGeocercaRecordId(geocerca))
                );
                if (selectedGeocercas.length > 0) {
                    drawGeocercasTrayecto(selectedGeocercas, trayectoGeocercaSelectedIds, [], selectedGeoruta, {
                        startPointId: trayectoStartPoint?.id,
                        endPointId: trayectoEndPoint?.id,
                    });
                    return;
                }
            }

            const selectedIds = new Set((geoFilter.selectedIds || []).map(String));
            const selectedGeocercas = listGeocercas.filter((geocerca) =>
                selectedIds.has(String(geocerca?.ID))
            );
            if (selectedGeocercas.length > 0) {
                dibujarGeocercas(selectedGeocercas, false);
            }
            return;
        }

        setIsAllGeocercasMapLoading(true);
        Swal.fire({
            title: "Cargando geocercas",
            text: "Estamos listando todas las geocercas en el mapa.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        try {
            const allGeocercas = await fetchAllGeocercasCatalog();

            saveGeoPreviousView();
            if (geoCrudMode === "edit") {
                setGeoCrudMode("browse");
                resetGeoDraft();
            }
            if (isGeocercasOnly) setAllGeocercasForTrayecto(allGeocercas);
            dibujarGeocercas(allGeocercas, true);
            setShowAllGeocercasOnMap(true);

            if (allGeocercas.length === 0) {
                toast("No hay geocercas disponibles para mostrar.");
            }
        } catch (error) {
            console.error("Error al cargar todas las geocercas:", error);
            toast.error(error.response?.data?.message || error.message || "Error al cargar las geocercas.");
        } finally {
            setIsAllGeocercasMapLoading(false);
            Swal.close();
        }
    };
    const geocercasPlaceSearch = isGeocercasOnly ? (
        <div className="geocercas-place-search" role="search">
            <FaSearch className="geocercas-place-search__icon" aria-hidden="true" />
            <input
                ref={placeSearchInputRef}
                className="geocercas-place-search__input"
                type="search"
                value={placeSearch}
                onChange={(event) => setPlaceSearch(event.target.value)}
                placeholder="Buscar sitio en Google Maps"
                aria-label="Buscar sitio en Google Maps"
                autoComplete="off"
            />
            {placeSearch && (
                <button
                    type="button"
                    className="geocercas-place-search__clear"
                    onClick={() => {
                        setPlaceSearch("");
                        if (placeSearchMarkerRef.current) {
                            placeSearchMarkerRef.current.setMap(null);
                            placeSearchMarkerRef.current = null;
                        }
                        placeSearchInputRef.current?.focus();
                    }}
                    aria-label="Limpiar busqueda de sitio"
                    title="Limpiar busqueda"
                >
                    ×
                </button>
            )}
        </div>
    ) : null;
    // En responsive el buscador de Google Maps comparte el espacio visual con
    // la lista de contratos. Solo debe aparecer cuando esa lista esta cerrada.
    // En desktop se mantiene visible como antes.
    const mapCenterPlaceSearch = !isGeocercasOnly && (!isMobile || !menuVisible) ? (
        <div className={`mapcenter-place-search-shell ${fastFilter ? "with-fast-filters" : ""}`}>
            <div className="geocercas-place-search mapcenter-place-search" role="search">
                <FaSearch className="geocercas-place-search__icon" aria-hidden="true" />
                <input
                    ref={placeSearchInputRef}
                    className="geocercas-place-search__input"
                    type="search"
                    value={placeSearch}
                    onChange={(event) => setPlaceSearch(event.target.value)}
                    placeholder="Buscar sitio en Google Maps"
                    aria-label="Buscar sitio en Google Maps"
                    autoComplete="off"
                />
                {placeSearch && (
                    <button
                        type="button"
                        className="geocercas-place-search__clear"
                        onClick={() => {
                            setPlaceSearch("");
                            if (placeSearchMarkerRef.current) {
                                placeSearchMarkerRef.current.setMap(null);
                                placeSearchMarkerRef.current = null;
                            }
                            placeSearchInputRef.current?.focus();
                        }}
                        aria-label="Limpiar busqueda de sitio"
                        title="Limpiar busqueda"
                    >
                        ×
                    </button>
                )}
            </div>
        </div>
    ) : null;
    const geocercasCardsPanel = isGeocercasOnly ? (
        <div
            style={{
                position: "absolute",
                top: 72,
                left: isMobile ? 8 : 12,
                bottom: isMobile ? 18 : 96,
                width: isMobile ? "calc(100vw - 88px)" : 340,
                maxWidth: "calc(100vw - 96px)",
                zIndex: 1201,
                display: "flex",
                flexDirection: "column",
                gap: 10,
            }}
        >
            {geocercasPlaceSearch}

            <div style={{ display: "flex", alignItems: "stretch", gap: 8, width: "100%" }}>
                <button
                    type="button"
                    onClick={toggleAllGeocercasOnMap}
                    disabled={isAllGeocercasMapLoading}
                    title={showAllGeocercasOnMap ? "Ocultar todas las geocercas" : "Cargar todas las geocercas"}
                    aria-label={showAllGeocercasOnMap ? "Ocultar todas las geocercas" : "Cargar todas las geocercas"}
                    style={{
                        flex: "0 0 54px",
                        width: 54,
                        minHeight: 54,
                        border: showAllGeocercasOnMap ? "1px solid #0f4c81" : "1px solid rgba(15,76,129,0.18)",
                        borderRadius: 18,
                        display: "grid",
                        placeItems: "center",
                        background: showAllGeocercasOnMap
                            ? "linear-gradient(135deg, #0f4c81 0%, #006699 100%)"
                            : "rgba(255,255,255,0.96)",
                        boxShadow: "0 16px 30px rgba(7, 53, 79, 0.16)",
                        color: showAllGeocercasOnMap ? "#ffffff" : "#0f4c81",
                        cursor: isAllGeocercasMapLoading ? "wait" : "pointer",
                        opacity: isAllGeocercasMapLoading ? 0.7 : 1,
                    }}
                >
                    {showAllGeocercasOnMap ? <FaEyeSlash size={19} /> : <FaLayerGroup size={19} />}
                </button>

                <button
                    type="button"
                    onClick={() => startGeoDraft("points")}
                    style={{
                        flex: "1 1 auto",
                        minWidth: 0,
                        border: "1px solid rgba(15,76,129,0.2)",
                        borderRadius: 18,
                        minHeight: 54,
                        padding: "0 18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        background: "linear-gradient(135deg, #0f4c81 0%, #006699 55%, #1aa0d8 100%)",
                        boxShadow: "0 20px 34px rgba(7, 53, 79, 0.2)",
                        color: "#ffffff",
                        cursor: "pointer",
                        fontWeight: 800,
                    }}
                >
                    <span style={{ fontSize: 15 }}>Nueva geocerca</span>
                    <span
                        style={{
                            width: 28,
                            height: 28,
                            borderRadius: 999,
                            display: "grid",
                            placeItems: "center",
                            background: "rgba(255,255,255,0.18)",
                            fontSize: 20,
                            lineHeight: 1,
                        }}
                    >
                        +
                    </span>
                </button>
            </div>

            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 14,
                    padding: isMobile ? "14px" : "16px",
                    borderRadius: "26px",
                    boxSizing: "border-box",
                    overflow: "hidden",
                    background: "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(243,249,253,0.98) 100%)",
                    border: "1px solid rgba(15,76,129,0.14)",
                    boxShadow: "0 28px 54px rgba(7, 53, 79, 0.18)",
                    backdropFilter: "blur(16px)",
                }}
            >
                <div style={{ display: "grid", gap: 6 }}>
                    <div style={{ fontSize: "0.72rem", fontWeight: 800, letterSpacing: "0.14em", textTransform: "uppercase", color: "#0f4c81" }}>
                        Geocercas
                    </div>
                    <div style={{ fontSize: "1.2rem", fontWeight: 800, color: "#16324a", lineHeight: 1.1 }}>
                        Explora y selecciona
                    </div>
                    <div style={{ fontSize: 13, color: "#5d7489" }}>
                        {isGeocercasLoading ? "Cargando geocercas..." : `${filteredGeocercasCards.length} resultados disponibles`}
                    </div>
                </div>
    
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr auto",
                        gap: 10,
                        alignItems: "center",
                        padding: "12px 14px",
                        borderRadius: 18,
                        background: "rgba(255,255,255,0.86)",
                        border: "1px solid rgba(15,76,129,0.1)",
                        boxSizing: "border-box",
                    }}
                >
                    <Input
                        type="text"
                        value={geoListSearch}
                        onChange={(e) => setGeoListSearch(e.target.value)}
                        placeholder="Buscar por nombre, codigo o descripcion..."
                        style={{ width: "100%", minWidth: 0, boxSizing: "border-box", border: "none", boxShadow: "none", padding: 0, background: "transparent" }}
                    />
                    <div
                        style={{
                            minWidth: 44,
                            height: 44,
                            borderRadius: 14,
                            display: "grid",
                            placeItems: "center",
                            background: "linear-gradient(135deg, rgba(15,76,129,0.12), rgba(26,160,216,0.18))",
                            color: "#0f4c81",
                            fontWeight: 800,
                        }}
                    >
                        {filteredGeocercasCards.length}
                    </div>
                </div>

                <div
                    style={{
                        flex: 1,
                        minHeight: 0,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                        overflowY: "auto",
                        overflowX: "hidden",
                        display: "grid",
                        alignContent: "start",
                        alignItems: "start",
                        gridAutoRows: "max-content",
                        gap: 12,
                        paddingRight: 10,
                    }}
                >
                    {isGeocercasLoading ? (
                        Array.from({ length: 4 }).map((_, index) => (
                            <div
                                key={`geo-skeleton-${index}`}
                                style={{
                                    padding: "16px",
                                    borderRadius: 20,
                                    background: "linear-gradient(135deg, rgba(232,241,248,0.95), rgba(245,250,253,0.98))",
                                    border: "1px solid rgba(15,76,129,0.08)",
                                    boxShadow: "0 12px 28px rgba(15, 76, 129, 0.08)",
                                    animation: "geoPulse 1.4s ease-in-out infinite",
                                }}
                            >
                                <div style={{ height: 12, width: "34%", borderRadius: 999, background: "rgba(15,76,129,0.12)", marginBottom: 12 }} />
                                <div style={{ height: 16, width: "82%", borderRadius: 999, background: "rgba(15,76,129,0.18)", marginBottom: 10 }} />
                                <div style={{ height: 11, width: "100%", borderRadius: 999, background: "rgba(15,76,129,0.1)", marginBottom: 8 }} />
                                <div style={{ height: 11, width: "68%", borderRadius: 999, background: "rgba(15,76,129,0.1)" }} />
                            </div>
                        ))
                    ) : filteredGeocercasCards.length === 0 ? (
                        <div
                            style={{
                                padding: "22px 18px",
                                borderRadius: 20,
                                textAlign: "center",
                                background: "rgba(255,255,255,0.82)",
                                border: "1px dashed rgba(15,76,129,0.22)",
                                color: "#5d7489",
                            }}
                        >
                            No encontramos geocercas con ese criterio.
                        </div>
                    ) : (
                        filteredGeocercasCards.map((geocerca) => {
                            const geocercaId = String(geocerca?.ID || "");
                            const isSelected = geoFilter.selectedIds?.map(String)?.includes(geocercaId);
                            const verticesCount = parseGeocercaVertices(geocerca?.Vertices || geocerca?.vertices).length;
                            const categoryId = geocerca?.FKCatGeoCerca ?? geocerca?.fkCatGeoCerca ?? geocerca?.FK_CAT_GEO;
                            const categoryFromCatalog = geoCategories.find(
                                (category) => String(category?.ID) === String(categoryId)
                            );
                            const categoryName = String(
                                geocerca?.CategoriaNombre ??
                                geocerca?.categoriaNombre ??
                                geocerca?.categorianombre ??
                                geocerca?.CATEGORIANOMBRE ??
                                geocerca?.NombreCategoria ??
                                categoryFromCatalog?.Descripcion ??
                                "Sin categoria"
                            );
                            const categoryColor =
                                categoryFromCatalog?.Color ??
                                categoryFromCatalog?.color ??
                                geocerca?.CategoriaColor ??
                                geocerca?.categoriaColor;
                            const categoryBadgeColors = getGeoCategoryBadgeColors(categoryColor);
                            return (
                            <button
                                key={geocercaId}
                                type="button"
                                onClick={() => selectGeocercaFromCard(geocerca)}
                                style={{
                                    textAlign: "left",
                                    alignSelf: "start",
                                    width: "100%",
                                    maxWidth: "100%",
                                    minWidth: 0,
                                    boxSizing: "border-box",
                                    padding: "16px 16px 15px",
                                    borderRadius: 22,
                                    border: isSelected ? "1px solid rgba(15,76,129,0.32)" : "1px solid rgba(15,76,129,0.09)",
                                    background: isSelected
                                        ? "linear-gradient(135deg, rgba(15,76,129,0.16), rgba(26,160,216,0.16))"
                                        : "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(244,249,252,0.95))",
                                    boxShadow: isSelected
                                        ? "0 18px 34px rgba(15, 76, 129, 0.16)"
                                        : "0 12px 26px rgba(15, 76, 129, 0.08)",
                                    color: "#16324a",
                                    cursor: "pointer",
                                    transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
                                }}
                            >
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "flex-start", marginBottom: 8, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                                    <div style={{ minWidth: 0, flex: "1 1 auto", maxWidth: "100%" }}>
                                        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase", color: "#0f4c81", marginBottom: 5 }}>
                                            {geocerca?.Codigo || geocerca?.Code || `ID ${geocercaId}`}
                                        </div>
                                        <div style={{ fontSize: 16, fontWeight: 800, lineHeight: 1.2, wordBreak: "break-word", maxWidth: "100%" }}>
                                            {geocerca?.Nombre || "Geocerca sin nombre"}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            flex: "0 0 auto",
                                            padding: "6px 10px",
                                            borderRadius: 999,
                                            background: "rgba(15,76,129,0.08)",
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: "#0f4c81",
                                        }}
                                    >
                                        {verticesCount} pts
                                    </div>
                                </div>

                                <div
                                    style={{
                                        fontSize: 13,
                                        lineHeight: 1.45,
                                        color: "#587086",
                                        marginBottom: 12,
                                        width: "100%",
                                        maxWidth: "100%",
                                        minWidth: 0,
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    }}
                                >
                                    {geocerca?.Descripcion || "Sin descripcion registrada."}
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "flex-start", width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                                    <span
                                        title={`Categoria: ${categoryName}`}
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            maxWidth: "70%",
                                            padding: "5px 9px",
                                            borderRadius: 999,
                                            background: categoryBadgeColors.background,
                                            border: `1px solid ${categoryBadgeColors.border}`,
                                            color: categoryBadgeColors.color,
                                            fontSize: 11,
                                            fontWeight: 800,
                                            lineHeight: 1.2,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {categoryName}
                                    </span>
                                    <div style={{ fontSize: 12, fontWeight: 700, color: isSelected ? "#0b4676" : "#1a6c9d", flex: "0 0 auto", whiteSpace: "nowrap" }}>
                                        {isSelected ? "Seleccionada" : "Ver en mapa"}
                                    </div>
                                </div>
                            </button>
                            );
                        })
                    )}
                </div>
            </div>

            <style>{`
                @keyframes geoPulse {
                    0%, 100% { opacity: 0.72; }
                    50% { opacity: 1; }
                }
            `}</style>
        </div>
    ) : null;

    return (
        <div
            ref={mapCenterRootRef}
            className={[
                "map-center-root",
                showHorizontalDevices || showTrafficGrid ? "has-bottom-grid" : "",
                isCustomFullscreen ? "is-fullscreen" : "",
            ].join(" ").trim()}
        >
            <Joyride
                steps={tourStepsDynamic}
                run={tourRun && !isMobile}
                stepIndex={tourStepIndex}
                continuous
                showBackButton
                showSkipButton={false}
                showProgress
                scrollToFirstStep
                disableOverlayClose
                spotlightClicks
                callback={handleTourCallback}
                locale={{
                    back: "Atras",
                    last: "Finalizar",
                    next: "Siguiente",
                    nextLabelWithProgress: "Siguiente (Paso {step} de {steps})",
                }}
                styles={{
                    options: { zIndex: 999999 },
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.35)",
                    },
                }}
            />
            <div className="map-container" style={{ height: mapHeight, position: "relative" }}>
                {geoDrawTooltip && geoCrudMode !== "browse" && !isGeoDraftClosed && (
                    <div
                        role="status"
                        style={{
                            position: "fixed",
                            left: geoDrawTooltip.x,
                            top: geoDrawTooltip.y,
                            transform: "translate(14px, -42px)",
                            zIndex: 1001,
                            pointerEvents: "none",
                            padding: "7px 10px",
                            borderRadius: 8,
                            background: "rgba(15, 35, 52, 0.94)",
                            color: "#ffffff",
                            fontSize: 12,
                            fontWeight: 600,
                            lineHeight: 1.25,
                            whiteSpace: "nowrap",
                            boxShadow: "0 6px 16px rgba(15, 35, 52, 0.25)",
                        }}
                    >
                        Para cancelar el dibujo, presiona clic derecho.
                    </div>
                )}
                {showMapDimmer && (
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(0, 0, 0, 0.35)",
                            pointerEvents: "none",
                            zIndex: 2,
                        }}
                    />
                )}
                {showMapDimmer && (
                    <div
                        id="tour-offcanvas-anchor"
                        style={{
                            position: "absolute",
                            top: 120,
                            right: offcanvasAnchorRight,
                            width: 1,
                            height: 1,
                            pointerEvents: "none",
                            zIndex: 2,
                        }}
                    />
                )}
                <div className="map-fullscreen-control">
                    <Button
                        color="light"
                        className={`map-fullscreen-button ${isCustomFullscreen ? "active" : ""}`}
                        onClick={toggleCustomFullscreen}
                        title={isCustomFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
                        aria-label={isCustomFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
                    >
                        {isCustomFullscreen ? <FaCompress size={16} /> : <FaExpand size={16} />}
                    </Button>
                </div>
                <img
                    className="map-cargotronics-logo"
                    src="/Cargotronics.png"
                    alt="Cargotronics"
                />
                {mapCenterPlaceSearch}
                {geocercasCardsPanel}
                {!isGeocercasOnly && fastFilter && (
                    <div id="tour-fast-filters-panel" className="alerts-row">
                        {alerts.map((alert, idx) => {
                            const isRefuerzo = alert.filter?.trim().toLowerCase() === "refuerzo";
                            const isLive = alert.filter?.trim().toLowerCase() === "streaming";
                            return (
                                <div
                                    key={alert.filter ?? idx}
                                    className={`alert-icon ${alert.active ? "active" : "inactive"}`}
                                    onClick={() => handleFilterButtons2(alert.filter)}>
                                    {isRefuerzo ? (
                                        <div className="icon-refuerzo" title="Refuerzo">
                                            R
                                        </div>
                                    ) : isLive ? (
                                        <span className="map-live-dot" aria-hidden="true" title="Streaming activo"></span>
                                    ) : (
                                        <img src={alert.icon} alt="Alerta" width={25} height={25} />
                                    )}

                                    <span className="badge badge-count" title={`Total: ${alert.count}`}>
                                        {alert.count}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                )}

                {!isGeocercasOnly && <div className="map-actions-stack">
                    <div className="action-item">
                        <Button
                            id="tour-fast-filters"
                            color="light"
                            className={`fast-filters-button ${fastFilter ? "active" : ""}`}
                            onClick={() => setFastFilter((v) => !v)}
                            title="Filtros rápidos"
                            aria-label="Filtros rápidos">
                            <FaFilter size={16} />
                            <span>Filtros rápidos</span>
                        </Button>
                    </div>

                    <div className="action-item">
                        <Button
                            id="tour-geocercas"
                            color="light"
                            className={`fast-geocerca-button ${fastGeocerca ? "active" : ""}`}
                            onClick={() => setOffcanvasOpenGeocercas((v) => !v)}
                            title="Geocercas"
                            aria-label="Geocercas">
                            <SiGraphql size={18} />
                            <span>Geocercas</span>
                        </Button>
                    </div>

                    <div className="action-item">
                        <Button
                            id="tour-georutas"
                            color="light"
                            className={`fast-georutas-button ${fastGeoruta ? "active" : ""}`}
                            onClick={() => setOffcanvasOpenGeorutas((v) => !v)}
                            title="Georutas"
                            aria-label="Georutas">
                            <SiRoamresearch size={18} />
                            <span>Georutas</span>
                        </Button>
                    </div>

                    {isMobile && (
                        <div className="action-item map-actions-dropdown-item-wrap">
                            <div
                                className={`map-actions-dropdown ${mobileActionsOpen ? "is-open" : ""}`}
                                ref={mobileActionsRef}
                            >
                                <Button
                                    color="light"
                                    className={`map-actions-dropdown-toggle ${mobileActionsOpen ? "is-active" : ""}`}
                                    onClick={() => setMobileActionsOpen((v) => !v)}
                                    title="MÃ¡s acciones"
                                    aria-label="MÃ¡s acciones"
                                >
                                    <FaEllipsisV size={16} />
                                </Button>
                                {mobileActionsOpen && (
                                    <div className="map-actions-dropdown-menu">
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${fastFilter ? "is-active" : ""}`}
                                            onClick={() => {
                                                setFastFilter((v) => !v);
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <FaFilter size={16} />
                                            <span>Filtros rapidos</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${offcanvasOpenGeocercas ? "is-active" : ""}`}
                                            onClick={() => {
                                                setOffcanvasOpenGeocercas((v) => !v);
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <SiGraphql size={16} />
                                            <span>Geocercas</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${offcanvasOpenGeorutas ? "is-active" : ""}`}
                                            onClick={() => {
                                                setOffcanvasOpenGeorutas((v) => !v);
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <SiRoamresearch size={16} />
                                            <span>Georutas</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${inviasActive || inviasOffcanvasOpen ? "is-active" : ""}`}
                                            onClick={() => {
                                                setInviasCountriesDraft(inviasCountries);
                                                setInviasOffcanvasOpen(true);
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <TbRouteOff size={16} />
                                            <span>Restricciones viales</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${deviceViewMode !== "left" ? "is-active" : ""}`}
                                            onClick={() => {
                                                toggleDeviceView();
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            {React.createElement(deviceViewIcon, { size: 16 })}
                                            <span>{deviceViewLabel}</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${showPlateBadges ? "is-active" : ""}`}
                                            onClick={() => {
                                                openMarkerLabelsOffcanvas();
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <FaTag size={16} />
                                            <span>Mostrar etiquetas</span>
                                        </button>
                                        <button
                                            type="button"
                                            className={`map-actions-dropdown-item ${livePanelOpen ? "is-active" : ""}`}
                                            onClick={() => {
                                                startTour();
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <FaInfoCircle size={16} />
                                            <span>Visita guiada</span>
                                        </button>
                                        <button
                                            type="button"
                                            className="map-actions-dropdown-item"
                                            onClick={() => {
                                                setActiveStreams(readActiveStreamsFromSession());
                                                setLivePanelOpen((v) => !v);
                                                setMobileActionsOpen(false);
                                            }}
                                        >
                                            <FaVideo size={16} />
                                            <span>Live ({displayStreams.length})</span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className="action-item">
                        <Button
                            id="tour-invias"
                            color="light"
                            className={`fast-invias-button ${inviasActive ? "active" : ""}`}
                            onClick={() => {
                                setInviasCountriesDraft(inviasCountries);
                                setInviasOffcanvasOpen(true);
                            }}
                            title="Restricciones viales"
                            aria-label="Restricciones viales">
                            <TbRouteOff size={18} />
                            <span>Restricciones viales</span>
                        </Button>
                    </div>

                  <div className="action-item">
                      <Button
                          id="tour-devices-view"
                          className={`fast-devices-button ${deviceViewMode !== "left" ? "active" : ""}`}
                          onClick={toggleDeviceView}
                              title={`Vista servicios: ${deviceViewLabel}`}
                              aria-label={`Vista servicios: ${deviceViewLabel}`}>
                              {React.createElement(deviceViewIcon, { size: 16 })}
                              <span>{deviceViewLabel}</span>
                          </Button>
                      </div>

                  {!isMobile && (
                      <div className="action-item">
                          <Button
                              className={`fast-placa-button ${showPlateBadges ? "active" : ""}`}
                              onClick={openMarkerLabelsOffcanvas}
                              title="Configurar etiquetas de los markers"
                              aria-label="Mostrar etiquetas"
                          >
                              <FaTag size={16} />
                              <span>Mostrar etiquetas</span>
                          </Button>
                      </div>
                  )}

                  <div className="action-item">
                      <Button
                          className="fast-info-button"
                          onClick={startTour}
                          title="Visita guiada"
                          aria-label="Visita guiada"
                      >
                          <FaInfoCircle size={16} />
                          <span>Visita guiada</span>
                      </Button>
                  </div>

                  <div className="action-item">
                      <Button
                          className={`fast-live-button ${livePanelOpen ? "active" : ""}`}
                          onClick={() => {
                              setActiveStreams(readActiveStreamsFromSession());
                              setLivePanelOpen((v) => !v);
                          }}
                          title="Lives activos"
                          aria-label="Lives activos"
                      >
                          <FaVideo size={16} />
                          <span className="fast-live-dot" aria-hidden="true"></span>
                          <span>Live ({displayStreams.length})</span>
                      </Button>
                  </div>

                  </div>}

                {isGeocercasOnly && (
                    <div className="map-actions-stack">
                        <div className="action-item">
                            <Button
                                id="tour-georutas"
                                color="light"
                                className={`fast-georutas-button ${fastGeoruta ? "active" : ""}`}
                                onClick={async () => {
                                    if (!offcanvasOpenGeorutas) {
                                        try {
                                            await ensureAllGeocercasForTrayectoLoaded();
                                        } catch (error) {
                                            toast.error(error.response?.data?.message || error.message || "Error al preparar las geocercas.");
                                            return;
                                        }
                                    }
                                    setOffcanvasOpenGeorutas((v) => !v);
                                }}
                                title="Georutas"
                                aria-label="Georutas">
                                <SiRoamresearch size={18} />
                                <span>Georutas</span>
                            </Button>
                        </div>
                    </div>
                )}

                {!isGeocercasOnly && (!isMobile || menuVisible) && <div className="search-filter-container">
                    <Input
                        id="tour-search"
                        type="text"
                        placeholder={isMobile ? "Buscar vehículo, placa o empresa..." : "Buscar..."}
                        className="search-input"
                        value={search}
                        onChange={handleSearchChange}
                    />
                    <Button id="tour-advanced-filters" title="Abrir filtros avanzados" color="light" className="filter-btn" onClick={() => setOffcanvasOpen(!offcanvasOpen)}>
                        {isMobile ? <FaFilter size={18} /> : <FaSearch size={18} />}
                        {notificationCircle && <div className="notification-badge"></div>}
                    </Button>
                </div>}

                {!isGeocercasOnly && <LiveFloatingPanel
                    isOpen={livePanelOpen}
                    title={`Live activos (${displayStreams.length})`}
                    onClose={() => setLivePanelOpen(false)}
                    defaultPosition={{ right: 20, bottom: 90 }}
                    defaultSize={{ width: 420, height: 520 }}
                    minWidth={360}
                    minHeight={320}
                    onLayoutChange={setLivePanelLayout}
                >
                    {renderActiveStreams()}
                </LiveFloatingPanel>}

                {!isGeocercasOnly && !showHorizontalDevices && !showTrafficGrid && (!isMobile || !fastFilter) && (
                    <div id="tour-left-panel" className={`left-dropdown-menu ${!menuVisible ? "is-collapsed" : ""}`}>
                        <div className={["device-cards", !menuVisible ? "is-collapsed" : ""].join(" ").trim()}>
                            {filteredContracts.map((d) => {
                                const borderColor = d.Locked ? "green" : "red";
                                const movingIcon = String(d.IconMoving || "").toLowerCase();
                                const cardStatus = movingIcon.includes("moving")
                                    ? { key: "moving", label: "En ruta", color: "#16a34a" }
                                    : movingIcon.includes("stop")
                                        ? { key: "stopped", label: "Detenido", color: "#ef233c" }
                                        : { key: "review", label: "En revisión", color: "#1677d2" };
                                return (
                                    <Card
                                        key={d.ContractID}
                                        className="device-card device-card--responsive mb-2"
                                        onClick={() => openInfoWindowForContrato(d, { focusZoom: true })}
                                        style={{
                                            cursor: "pointer",
                                            borderLeft: `6px solid ${borderColor}`,
                                            "--device-status-color": cardStatus.color,
                                            width: "100%",
                                        }}>
                                        {(
                                            <CardBody className="device-card__body">
                                                <div className="device-card__header">
                                                    <div className="device-card__vehicle-icon" aria-hidden="true">
                                                        <FaTruck />
                                                    </div>
                                                    <div className="device-card__heading">
                                                        <div className="device-card__company" title={d.NombreEmpresa}>
                                                            {d.NombreEmpresa || "Empresa sin nombre"}
                                                        </div>
                                                        <div className="device-card__identity">
                                                            <span className="device-card__pill">
                                                                <FaIdCard aria-hidden="true" />
                                                                {d.PlacaTruck || "Sin placa"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <FaChevronRight className="device-card__chevron" aria-hidden="true" />
                                                </div>

                                                <div className="device-card__location device-card__device-location">
                                                    <FaMobileAlt aria-hidden="true" />
                                                    <span>
                                                        <strong>Dispositivo:</strong> {d.FKLokDeviceID || "Sin dispositivo"}
                                                    </span>
                                                </div>

                                                <div className="device-card__location">
                                                    <FaMapMarkerAlt aria-hidden="true" />
                                                    <span>
                                                        <strong>Ult. geocerca:</strong> {d.geocerca || "Sin geocerca"} ({d.LastReportgeocerca ?? "-"} min)
                                                    </span>
                                                </div>

                                                <div className="device-card__metrics">
                                                    <span>
                                                        <FaTachometerAlt aria-hidden="true" /> {d.Speed ?? "-"} km/h
                                                    </span>
                                                </div>

                                                <div className="device-card__footer">
                                                    <div className="device-card__status-icons">
                                                        {Object.entries(d)
                                                            .filter(
                                                                ([key, url]) =>
                                                                    (key.startsWith("Icon") || key === "icon_bat") &&
                                                                    typeof url === "string" &&
                                                                    !url.toLowerCase().includes("transparent")
                                                            )
                                                            .map(([key, url]) => (
                                                                <img key={key} src={url} width={23} height={23} alt={key} title={key} />
                                                            ))}
                                                        {renderLiveBadge(d.FKLokDeviceID)}
                                                    </div>
                                                    <span className={`device-card__state device-card__state--${cardStatus.key}`}>
                                                        <span className="device-card__state-dot" aria-hidden="true" />
                                                        {cardStatus.label}
                                                    </span>
                                                    <span className="device-card__time">{d.Tiempo || "-"}</span>
                                                </div>
                                            </CardBody>
                                        )}
                                    </Card>
                                );
                            })}
                        </div>

                        {filteredContracts.length > 0 && (
                            <button
                                type="button"
                                className={`devices-toggle-tab devices-toggle-tab--left ${menuVisible ? "is-open" : "is-closed"}`}
                                onClick={() => setMenuVisible((v) => !v)}
                                aria-label={menuVisible ? "Ocultar dispositivos" : `Mostrar dispositivos (${filteredContracts.length})`}
                                title={menuVisible ? "Ocultar dispositivos" : `Mostrar dispositivos (${filteredContracts.length})`}>
                                <span className="tab-arrow">{menuVisible ? "▴" : "▾"}</span>
                                {!menuVisible && <span className="tab-count">{filteredContracts.length}</span>}
                            </button>
                        )}
                    </div>
                )}

                {/* Offcanvas filtros avanzados */}
                {!isGeocercasOnly && <Offcanvas
                    direction="end"
                    isOpen={offcanvasOpen}
                    toggle={() => setOffcanvasOpen(!offcanvasOpen)}
                    className="custom-offcanvas-map-center"
                    container={offcanvasContainer}
                >
                    <OffcanvasHeader toggle={() => setOffcanvasOpen(false)}>
                        {`${appName} FILTROS AVANZADOS`}
                        <h5 className="offcanvas-title" id="offcanvasScrollingLabel" style={{ display: "flex", flexDirection: "column" }}>
                            {localStorage.getItem("nameFilters") ? (
                                <span style={{ color: "#006699" }}>
                                    ({localStorage.getItem("nameFilters")})&nbsp;
                                    <i className={savedFilters ? "bx bx-flashing bx-pencil" : "bx bx-pencil"} style={{ cursor: "pointer" }} />
                                </span>
                            ) : (
                                <span style={{ color: "#006699" }}>(Sin guardar)</span>
                            )}
                        </h5>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div id="tour-advanced-filters-panel" />
                        <FilterBodyOffcanvas
                            contratos={filteredContracts}
                            listContratos={contracts}
                            onFiltersChange={() => { }}
                            savedFilter={handleNewValueSavedFilter}
                            statusFilter={savedFilters}
                            newValueFilter={newValueFilterButton}
                            deleteNewFilter={deleteNewFilterButton}
                        />
                    </OffcanvasBody>
                </Offcanvas>}

                {isMobile && (
                    <Offcanvas
                        direction="end"
                        isOpen={mobileInfoOpen}
                        toggle={closeInfoWindow}
                        className="custom-offcanvas-map-center mobile-detail-offcanvas"
                        container={offcanvasContainer}
                    >
                        <OffcanvasHeader toggle={closeInfoWindow}>
                            <div className="mobile-detail-offcanvas__header">
                                <span className="mobile-detail-offcanvas__eyebrow">MONITOREO EN TIEMPO REAL</span>
                                <strong>
                                    {mobileInfoContrato?.PlacaTruck || mobileInfoContrato?.ContainerNum || mobileInfoContrato?.FKLokDeviceID || "Detalle del dispositivo"}
                                </strong>
                            </div>
                        </OffcanvasHeader>
                        <OffcanvasBody className="mobile-detail-offcanvas__body">
                            {mobileInfoContrato && (
                                <InfoWindowContent
                                    contrato={mobileInfoContrato}
                                    openModalContratoSeguimiento={() => {
                                        closeInfoWindow();
                                        openModalContratoSeguimiento(mobileInfoContrato);
                                    }}
                                    openReporteConsolidado={() => {
                                        closeInfoWindow();
                                        openModalConsolidado(mobileInfoContrato);
                                    }}
                                    openModalGaleria={() => {
                                        closeInfoWindow();
                                        openModalImagens(mobileInfoContrato);
                                    }}
                                    openModalSeguir={() => {
                                        closeInfoWindow();
                                        openModalSeguirPanel(mobileInfoContrato);
                                    }}
                                    openModalEnVivo={() => {
                                        closeInfoWindow();
                                        openModalEnVivo(mobileInfoContrato);
                                    }}
                                    onClose={closeInfoWindow}
                                />
                            )}
                        </OffcanvasBody>
                    </Offcanvas>
                )}

                {/* Offcanvas geocercas */}
                {!isGeocercasOnly && <Offcanvas
                    direction="end"
                    isOpen={offcanvasOpenGeocercas}
                    toggle={() => setOffcanvasOpenGeocercas(!offcanvasOpenGeocercas)}
                    className="custom-offcanvas-map-center"
                    container={offcanvasContainer}
                >
                    <OffcanvasHeader toggle={() => setOffcanvasOpenGeocercas(false)}>
                        {`${appName} GEOCERCAS`}
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div id="tour-geocercas-panel" />
                        {geocercasCrudPanelContent}
                    </OffcanvasBody>
                </Offcanvas>}

                {/* Offcanvas etiquetas de markers */}
                {!isGeocercasOnly && <Offcanvas
                    direction="end"
                    isOpen={markerLabelsOffcanvasOpen}
                    toggle={() => setMarkerLabelsOffcanvasOpen((isOpen) => !isOpen)}
                    className="custom-offcanvas-map-center"
                    container={offcanvasContainer}
                >
                    <OffcanvasHeader toggle={() => setMarkerLabelsOffcanvasOpen(false)}>
                        {`${appName} ETIQUETAS`}
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div style={{ display: "grid", gap: 16 }}>
                            <div>
                                <div style={{ color: "#16324a", fontSize: 18, fontWeight: 800 }}>
                                    Informacion del marcador
                                </div>
                                <div style={{ marginTop: 5, color: "#6d8498", fontSize: 13, lineHeight: 1.45 }}>
                                    Selecciona entre 1 y 3 campos. El orden seleccionado sera el orden de las lineas en la etiqueta.
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px 12px",
                                    borderRadius: 12,
                                    background: "rgba(15,76,129,0.07)",
                                    color: "#0f4c81",
                                    fontSize: 13,
                                    fontWeight: 700,
                                }}
                            >
                                <span>Campos seleccionados</span>
                                <span>{markerLabelFieldsDraft.length}/3</span>
                            </div>

                            <div style={{ display: "grid", gap: 8 }}>
                                {MARKER_LABEL_FIELD_OPTIONS.map((option) => {
                                    const isChecked = markerLabelFieldsDraft.includes(option.key);
                                    const isDisabled = !isChecked && markerLabelFieldsDraft.length >= 3;
                                    return (
                                        <div
                                            key={option.key}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 10,
                                                padding: "11px 12px",
                                                border: isChecked ? "1px solid rgba(15,76,129,0.3)" : "1px solid rgba(15,76,129,0.1)",
                                                borderRadius: 12,
                                                background: isChecked ? "rgba(15,76,129,0.08)" : "#ffffff",
                                                color: isDisabled ? "#9aaaba" : "#284b66",
                                                fontWeight: isChecked ? 700 : 600,
                                            }}
                                        >
                                            <SwitchButton3
                                                checked={isChecked}
                                                onChange={() => toggleMarkerLabelField(option.key)}
                                                type={option.label}
                                                disabled={isDisabled}
                                            />
                                            {option.key === "plate" && (
                                                <span style={{ marginLeft: "auto", color: "#6d8498", fontSize: 11 }}>
                                                    Predeterminado
                                                </span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="geo-actions mt-2">
                                <button
                                    type="button"
                                    className="buttonSecondary"
                                    onClick={hideMarkerLabels}
                                >
                                    Ocultar etiquetas
                                </button>
                                <button
                                    type="button"
                                    className="buttonPrimary"
                                    onClick={applyMarkerLabelFields}
                                >
                                    Mostrar
                                </button>
                            </div>
                        </div>
                    </OffcanvasBody>
                </Offcanvas>}

                {/* Offcanvas georutas */}
                {!isGeocercasOnly && <Offcanvas
                    direction="end"
                    isOpen={offcanvasOpenGeorutas}
                    toggle={() => setOffcanvasOpenGeorutas(!offcanvasOpenGeorutas)}
                    className="custom-offcanvas-map-center"
                    container={offcanvasContainer}
                >
                    <OffcanvasHeader toggle={() => setOffcanvasOpenGeorutas(false)}>
                        {`${appName} GEORUTAS`}
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div id="tour-georutas-panel" />
                        <FilteredBodyGeorutas
                            listGeorutas={filteredContracts}   // ✅ usa contracts para no “desaparecer” opciones
                            showAll={georutaFilter.showAll}
                            setShowAll={(v) => setGeorutaFilter(prev => ({ ...prev, showAll: v }))}
                            selectedIds={georutaFilter.selectedIds}
                            setSelectedIds={(updater) => {
                                setGeorutaFilter(prev => ({
                                    ...prev,
                                    selectedIds: typeof updater === "function" ? updater(prev.selectedIds) : updater
                                }));
                            }}
                            filterActive={validateFilterGeorutas}
                        />
                        <div className="geo-actions mt-3">
                            <button
                                type="button"
                                className="buttonSecondary"
                                onClick={() => {
                                    setGeorutaFilter({ showAll: false, selectedIds: [] });
                                    validateFilterGeorutas({ showAll: false, selectedIds: [] });
                                    clearTrayectoLines();
                                    clearYellowCircle();
                                }}>
                                Limpiar
                            </button>

                            <button
                                type="button"
                                className="buttonPrimary"
                                onClick={() => {
                                    drawSelectedTrayectos(georutaFilter);
                                    setOffcanvasOpenGeorutas(false);
                                }}>
                                Aplicar
                            </button>
                        </div>

                    </OffcanvasBody>
                </Offcanvas>}
                {isGeocercasOnly && (
                    <GeocercasTrayectoOffcanvas
                        isOpen={offcanvasOpenGeorutas || offcanvasOpenGeocercasTrayecto}
                        toggle={() => {
                            setOffcanvasOpenGeorutas(false);
                            setOffcanvasOpenGeocercasTrayecto(false);
                        }}
                        container={offcanvasContainer}
                        trayecto={selectedGeoruta}
                        geocercas={allGeocercasForTrayecto}
                        appName={appName}
                        selectedIds={trayectoGeocercaSelectedIds}
                        onSelectedIdsChange={handleTrayectoGeocercaSelectedIdsChange}
                        startPoint={trayectoStartPoint}
                        endPoint={trayectoEndPoint}
                        originalStartPoint={trayectoOriginalStartPoint}
                        originalEndPoint={trayectoOriginalEndPoint}
                        onStartPointChange={handleTrayectoStartPointChange}
                        onEndPointChange={handleTrayectoEndPointChange}
                        onNearbyIdsDetected={setTrayectoNearbyDetectedIds}
                        onUpdateTrayecto={updateTrayectoGeocercas}
                        isUpdatingTrayecto={isUpdatingTrayecto}
                        onApplyTrayecto={showSelectedGeorutaOnMap}
                        onClearTrayecto={() => {
                            const emptyFilter = { showAll: false, selectedIds: [] };
                            setGeorutaFilter(emptyFilter);
                            setSelectedGeoruta(null);
                            setTrayectoGeocercaSelectedIds([]);
                            setTrayectoGeocercaOriginalIds([]);
                            setTrayectoNearbyDetectedIds([]);
                            setTrayectoStartPoint(null);
                            setTrayectoEndPoint(null);
                            setTrayectoOriginalStartPoint(null);
                            setTrayectoOriginalEndPoint(null);
                            validateFilterGeorutas(emptyFilter);
                            clearTrayectoLines();
                            clearYellowCircle();
                            clearGeocercasTrayecto();
                        }}
                        hasUnsavedChanges={hasUnsavedTrayectoConfigChanges}
                        originalSelectedIds={trayectoGeocercaOriginalIds}
                        onDiscardDraft={discardTrayectoGeocercaDraft}
                    />
                )}

                {/* Offcanvas restricciones viales (Invias) */}
                {!isGeocercasOnly && <Offcanvas
                    direction="end"
                    isOpen={inviasOffcanvasOpen}
                    toggle={() => setInviasOffcanvasOpen(!inviasOffcanvasOpen)}
                    className="custom-offcanvas-map-center"
                    container={offcanvasContainer}
                >
                    <OffcanvasHeader toggle={() => setInviasOffcanvasOpen(false)}>
                        RESTRICCIONES VIALES
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div id="tour-invias-panel" />
                        <FilteredBodyInviasCountries
                            countries={INVIAS_COUNTRIES}
                            selected={inviasCountriesDraft}
                            setSelected={setInviasCountriesDraft}
                        />

                        <div className="geo-actions mt-3">
                            <button
                                type="button"
                                className="buttonSecondary"
                                onClick={() => {
                                    setInviasActive(false);
                                    clearInviasMarkers();
                                    setInviasOffcanvasOpen(false);
                                }}
                                disabled={inviasLoading}>
                                Desactivar
                            </button>

                            <button
                                type="button"
                                className="buttonPrimary"
                                onClick={() => {
                                    const hasCountries = inviasCountriesDraft.length > 0;
                                    setInviasActive(hasCountries);
                                    setInviasCountries(inviasCountriesDraft);
                                    if (!hasCountries) {
                                        clearInviasMarkers();
                                        setInviasPendingApply(false);
                                        setInviasOffcanvasOpen(false);
                                        return;
                                    }
                                    setInviasPendingApply(true);
                                }}
                                disabled={inviasLoading}>
                                {inviasLoading ? (
                                    <>
                                        <Spinner size="sm" /> <span className="ms-1">Cargando…</span>
                                    </>
                                ) : (
                                    "Aplicar"
                                )}
                            </button>
                        </div>
                    </OffcanvasBody>
                </Offcanvas>}

                {/* Mapa */}
                <div id="tour-map" className="map-wrapper">
                    <div ref={mapContainerRef} style={{ width: "100%", height: "100%" }} />
                </div>
            </div>

            {showTrafficGrid && (
                <div
                    className="bottom-resize-handle"
                    onMouseDown={(event) => {
                        event.preventDefault();
                        bottomResizeRef.current = { startY: event.clientY, startHeight: bottomHeight };
                        setIsResizingBottom(true);
                    }}
                    role="separator"
                    aria-orientation="horizontal"
                />
            )}

            {showTrafficGrid && (
                <div id="tour-device-table" className="bottom-device-table" style={{ height: bottomHeight }}>
                    <div className="bottom-device-table__inner">
                        <table className="bottom-device-table__table">
                            <thead>
                                <tr>
                                    <th style={{ width: "250px" }}>Empresa</th>
                                    <th style={{ width: "260px" }}>Dispositivo</th>
                                    <th style={{ width: "120px" }}>Placa</th>
                                    <th>Ult. geocerca</th>
                                    <th style={{ width: "80px" }}>Bat</th>
                                    <th style={{ width: "70px" }}>Vel</th>
                                    <th style={{ width: "130px" }}>Iconos</th>
                                    <th style={{ width: "150px" }}>Tiempo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredContracts.map((d) => (
                                    <tr
                                        key={d.ContractID}
                                        className={selectedContractID === d.ContractID ? "is-selected" : ""}
                                        onClick={() => openInfoWindowForContrato(d, { focusZoom: true })}>
                                        <td>{d.NombreEmpresa}</td>
                                        <td>
                                            <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                                <span className="bottom-device-table__device">{d.FKLokDeviceID}</span>
                                                {renderLiveBadge(d.FKLokDeviceID)}
                                            </div>
                                        </td>
                                        <td className="bottom-device-table__plate">{d.PlacaTruck}</td>
                                        <td>
                                            {d.geocerca} ({d.LastReportgeocerca} min)
                                        </td>
                                        <td>
                                            <img src={d.icon_bat} width={19} height={20} alt="Bateria" title="Batería" />
                                        </td>
                                        <td>{d.Speed} km/h</td>
                                        <td>
                                            <div className="bottom-device-table__icons">
                                                {Object.entries(d)
                                                    .filter(
                                                        ([key, url]) =>
                                                            key.startsWith("Icon") &&
                                                            typeof url === "string" &&
                                                            !url.toLowerCase().includes("transparent")
                                                    )
                                                    .map(([key, url]) => (
                                                        <img key={key} src={url} width={19} height={20} alt={key} title={key} />
                                                    ))}
                                            </div>
                                        </td>
                                        <td>{d.Tiempo}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {showHorizontalDevices && (
                <div id="tour-device-cards" className="bottom-device-grid">
                    <div className="bottom-device-grid__inner">
                        {filteredContracts.map((d) => {
                            const borderColor = d.Locked ? "green" : "red";
                            return (
                                <Card
                                    key={d.ContractID}
                                    className="device-card bottom-device-card"
                                    onClick={() => openInfoWindowForContrato(d, { focusZoom: true })}
                                    style={{
                                        cursor: "pointer",
                                        borderLeft: `6px solid ${borderColor}`,
                                    }}>
                                    <CardBody className="p-2 w-100">
                                        <div style={{ marginBottom: 8 }}>
                                            <div>
                                                <strong>Empresa:</strong> {d.NombreEmpresa}
                                            </div>
                                            <div>
                                                <strong>Dispositivo:</strong> <span className="bottom-device-card__device">{d.FKLokDeviceID}</span>
                                            </div>
                                            <div>
                                                <strong>Placa:</strong> <span className="bottom-device-card__plate">{d.PlacaTruck}</span>
                                            </div>
                                            <div>
                                                <strong>Ult. geocerca:</strong> {d.geocerca} ({d.LastReportgeocerca} min)
                                            </div>
                                            <div>
                                                <strong>Vel:</strong> {d.Speed}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr auto",
                                                alignItems: "center",
                                                gap: "4px",
                                                width: "100%",
                                            }}>
                                            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                                                {Object.entries(d)
                                                    .filter(
                                                        ([key, url]) =>
                                                            (key.startsWith("Icon") || key === "icon_bat") &&
                                                            typeof url === "string" &&
                                                            !url.toLowerCase().includes("transparent")
                                                    )
                                                    .map(([key, url]) => (
                                                        <img key={key} src={url} width={19} height={20} alt={key} title={key} />
                                                    ))}
                                                {renderLiveBadge(d.FKLokDeviceID)}
                                            </div>

                                            <div
                                                style={{
                                                    color: "#888",
                                                    fontSize: "0.70rem",
                                                    whiteSpace: "nowrap",
                                                    justifySelf: "end",
                                                }}>
                                                {d.Tiempo}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            );
                        })}
                    </div>
                </div>
            )}

            <BaseModalAuto2
                isOpen={isGeoDraftRegistrationModalOpen}
                onClose={closeGeoDraftRegistrationModal}
                title={geoCrudMode === "edit" ? "Editar Geocerca" : "Nueva Geocerca"}
                size="md"
                container={modalContainer}
            >
                <div
                    style={{
                        display: "grid",
                        gap: 14,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                        overflowX: "hidden",
                    }}
                >
                    <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Nombre:</label>
                        <Input
                            type="text"
                            value={geoDraftName}
                            onChange={(e) => setGeoDraftName(e.target.value)}
                            placeholder="Nombre de la geocerca"
                            style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                        />
                    </div>

                    <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Categoria:</label>
                        <Input
                            type="select"
                            value={geoDraftCategory}
                            onChange={(e) => setGeoDraftCategory(e.target.value)}
                            disabled={isGeoCategoriesLoading || geoCategories.length === 0}
                            style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                        >
                            {isGeoCategoriesLoading && <option value="">Cargando categorias...</option>}
                            {!isGeoCategoriesLoading && geoCategories.length === 0 && (
                                <option value="">No hay categorias disponibles</option>
                            )}
                            {geoCategories.map((category) => {
                                return (
                                    <option key={category.ID} value={String(category.ID)}>
                                        {category.Descripcion}
                                    </option>
                                );
                            })}
                        </Input>
                    </div>

                    <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Descripcion:</label>
                        <Input
                            type="textarea"
                            rows="3"
                            value={geoDraftDescription}
                            onChange={(e) => setGeoDraftDescription(e.target.value)}
                            placeholder="Describe la geocerca"
                            style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", resize: "vertical" }}
                        />
                    </div>

                    <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Codigo:</label>
                        <Input
                            type="number"
                            min="0"
                            step="1"
                            inputMode="numeric"
                            value={geoDraftCode}
                            onChange={(e) => {
                                const nextCode = e.target.value;
                                if (nextCode === "" || /^\d+$/.test(nextCode)) {
                                    setGeoDraftCode(nextCode);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            placeholder="Codigo numerico"
                            style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                        />
                    </div>

                    <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                        <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Empresa:</label>
                        <Input
                            type="select"
                            value={geoDraftCompany}
                            onChange={(e) => {
                                const companyId = e.target.value;
                                setGeoDraftCompany(companyId);
                                if (geoCrudMode !== "edit") setGeoDraftCompanies([companyId]);
                            }}
                            disabled={isGeoCompaniesLoading}
                            style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                        >
                            <option value="0">TODAS</option>
                            {geoCompanies.map((company) => (
                                <option key={company.IdEmpresa} value={String(company.IdEmpresa)}>
                                    {company.NombreEmpresa}
                                </option>
                            ))}
                        </Input>
                    </div>

                    {geoCrudMode === "edit" && (
                        <div style={{ display: "grid", gap: 6, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
                            <label style={{ fontWeight: 700, color: "#16324a", marginBottom: 0 }}>Lista de empresas:</label>
                            <Input
                                type="search"
                                value={geoCompanySearch}
                                onChange={(e) => setGeoCompanySearch(e.target.value)}
                                placeholder="Buscar en la lista de empresas..."
                                disabled={isGeoCompaniesLoading}
                                style={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}
                            />

                            <div style={{ border: "1px solid #ced4da", borderRadius: 6, maxHeight: 180, overflowY: "auto", padding: 8 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 4px", fontWeight: 700 }}>
                                        <SwitchButton3
                                            checked={geoDraftCompanies.includes("0")}
                                            onChange={() => toggleGeoCompany("0")}
                                            type="TODAS"
                                            disabled={isGeoCompaniesLoading}
                                        />
                                    </div>
                                    {filteredGeoCompanies.map((company) => {
                                        const companyId = String(company.IdEmpresa);
                                        return (
                                            <div key={companyId} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 4px" }}>
                                                <SwitchButton3
                                                    checked={geoDraftCompanies.includes(companyId)}
                                                    onChange={() => toggleGeoCompany(companyId)}
                                                    type={company.NombreEmpresa}
                                                    disabled={isGeoCompaniesLoading}
                                                />
                                            </div>
                                        );
                                    })}
                                    {!isGeoCompaniesLoading && filteredGeoCompanies.length === 0 && (
                                        <div style={{ padding: 6, color: "#6c757d", fontSize: 13 }}>No se encontraron empresas.</div>
                                    )}
                            </div>

                            <div style={{ border: "1px solid rgba(15,76,129,0.18)", borderRadius: 6, padding: 8, background: "#f4f9fc" }}>
                                <div style={{ fontSize: 12, fontWeight: 700, color: "#16324a", marginBottom: 5 }}>Empresas seleccionadas</div>
                                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                    {selectedGeoCompanyNames.map((companyName) => (
                                        <span key={companyName} style={{ padding: "3px 8px", borderRadius: 12, background: "#0f4c81", color: "#fff", fontSize: 12 }}>
                                            {companyName}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {geoCrudMode === "edit" && (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 12,
                                width: "100%",
                                padding: "10px 12px",
                                boxSizing: "border-box",
                                border: "1px solid rgba(15,76,129,0.16)",
                                borderRadius: 10,
                                background: geoDraftActive ? "rgba(34,197,94,0.08)" : "rgba(100,116,139,0.08)",
                            }}
                        >
                            <div>
                                <div style={{ fontWeight: 700, color: "#16324a" }}>Estado de la geocerca</div>
                                <div style={{ marginTop: 2, fontSize: 12, color: "#6d8498" }}>
                                    {geoDraftActive ? "La geocerca esta activa" : "La geocerca esta inactiva"}
                                </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 700, color: geoDraftActive ? "#15803d" : "#64748b" }}>
                                <SwitchButton3
                                    checked={geoDraftActive}
                                    onChange={setGeoDraftActive}
                                    type={geoDraftActive ? "Activa" : "Inactiva"}
                                />
                            </div>
                        </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 12, flexWrap: "wrap", width: "100%", maxWidth: "100%", minWidth: 0, paddingTop: 4 }}>
                        <button
                            type="button"
                            className="buttonSecondary"
                            onClick={closeGeoDraftRegistrationModal}
                            style={{
                                width: 110,
                                flex: "0 0 110px",
                                minWidth: 110,
                                minHeight: 36,
                                padding: "7px 18px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                lineHeight: 1,
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={commitGeoDraftToModal}
                            disabled={isGeoDraftSaving || !geoDraftName.trim() || geoDraftPoints.length < 3}
                            style={{
                                width: 130,
                                flex: "0 0 130px",
                                minWidth: 130,
                                minHeight: 36,
                                padding: "7px 20px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                lineHeight: 1,
                                whiteSpace: "nowrap",
                                border: "1px solid #006699",
                                borderRadius: 8,
                                backgroundColor: "#006699",
                                color: "#ffffff",
                                fontWeight: 700,
                                boxShadow: "0 6px 14px rgba(0, 102, 153, 0.22)",
                                cursor: isGeoDraftSaving || !geoDraftName.trim() || geoDraftPoints.length < 3
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: isGeoDraftSaving || !geoDraftName.trim() || geoDraftPoints.length < 3
                                    ? 0.6
                                    : 1,
                            }}
                        >
                            {isGeoDraftSaving ? "Guardando..." : geoCrudMode === "edit" ? "Actualizar" : "Crear"}
                        </button>
                    </div>
                </div>
            </BaseModalAuto2>

            {/* MODALES */}
            <BaseModalXXL
                isOpen={modalContratoSeguimiento}
                title={"Contrato Seguimiento"}
                onClose={() => closeModales("modalContratoSeguimiento")}
                loading={loading}
                container={modalContainer}
            >
                <div style={seguimientoBodyStyle}>
                    <ReporteContrato
                        isOpen={modalContratoSeguimiento}
                        onClose={() => closeModales("modalContratoSeguimiento")}
                        contratoVar={contratoSelected}
                        aleatorio={Math.floor(Math.random() * 1000) + 1}
                        images={() => openImagenes2(contratoSelected)}
                        videos={openModalVideos}
                        valitronics={() => openModalValitronics(contratoSelected)}
                        checkList={() => openModalCheckList()}
                        monitoreo={() => openModalMonitoreo()}
                        trayecto={openModalTrayecto}
                        consolidado={() => openModalConsolidado(contratoSelected)}
                        rutaseleccionadaprop={rutaSelected}
                        modalContainer={modalContainer}
                    />
                </div>
            </BaseModalXXL>

            <BaseModalXXL
                isOpen={modalEnVivo}
                onClose={() => {
                    closeModales("modalEnVivo");
                    setContratoSelected(null);
                    setLiveStreamUrl("");
                }}
                title={"En vivo"}
                container={modalContainer}
            >
                <EnVivoPanel
                    contrato={contratoSelected}
                    initialStreamUrl={liveStreamUrl}
                    deviceActiveStreamUrls={(activeStreams || [])
                        .filter(
                            (stream) =>
                                String(stream?.deviceId || "") ===
                                String(contratoSelected?.FKLokDeviceID || "")
                        )
                        .map((stream) => String(stream?.streamId || "").trim())
                        .filter(Boolean)}
                />
            </BaseModalXXL>

            <BaseModalXXL
                isOpen={modalImagenes}
                title={""}
                onClose={() => closeModales("modalImagenes")}
                fullscreen={isMobile}
                container={modalContainer}
            >
                <ModalMultimediaHub
                    contratoData={contratoSelected}
                    selectedContrato={contratoSelected?.ContractID}
                    infoContrato={contratoSelected?.ContainerNum}
                    initialTab={multimediaHubTab}
                    onSelectTab={(tab) => setMultimediaHubTab(tab)}
                    onOpenUploadPhoto={() => {}}
                    onOpenUploadVideo={() => {}}
                    onOpenTracking={() => openModalContratoSeguimiento2(contratoSelected)}
                    onOpenMonitoreo={() => openModalMonitoreo()}
                    onOpenConsolidado={() => openModalConsolidado3(contratoSelected)}
                    initialStreamUrl={liveStreamUrl}
                    deviceActiveStreamUrls={(activeStreams || [])
                        .filter(
                            (stream) =>
                                String(stream?.deviceId || "") ===
                                String(contratoSelected?.FKLokDeviceID || "")
                        )
                        .map((stream) => String(stream?.streamId || "").trim())
                        .filter(Boolean)}
                    liveActive={(activeStreams || []).some(
                        (stream) =>
                            String(stream?.deviceId || "") ===
                            String(contratoSelected?.FKLokDeviceID || "")
                    )}
                />
            </BaseModalXXL>

            <ModalReporteServicio
                isOpen={modalConsolidado}
                onClose={() => closeModales("modalReporteServicio")}
                container={modalContainer}
                childComponent={<ReporteServicio contrato={contratoSelected} ultPunto={ultPunto} contractR={contractR} />}
            />

            <ModalBaseLg
                isOpen={modalValitronics}
                title={""}
                onClose={() => closeModales("modalValitronics")}
                container={modalContainer}
                childComponent={<ModalComprobanteValitronics listComprobantes={listComprobantes} />}
            />

            <BaseModalAuto
                size={"xl"}
                isOpen={modalCheckList}
                title={""}
                onClose={() => closeModales("modalCheckList")}
                container={modalContainer}
                childComponent={<PrintComponent data={contratoSelected} />}
            />

            <RSeguimientoServicio
                isOpen={modalMonitoreo}
                title={"Monitoreo de tráfico"}
                onClose={() => closeModales("modalMonitoreo")}
                container={modalContainer}
                childComponent={
                    <FormReporteServicio
                        contrato={selectedContractID}
                        images={() => openImagenes3(contratoSelected)}
                        tracking={() => openTracking2(contratoSelected)}
                        consolidado={() => openModalConsolidado4(contratoSelected)}
                    />
                }
            />

            {showSeguirPanel && (
                <Rnd
                    size={{ width: panelProps.width, height: panelProps.height }}
                    position={{ x: panelProps.x, y: panelProps.y }}
                    bounds=".map-container"
                    minWidth={200}
                    minHeight={100}
                    dragHandleClassName="seguir-handle"
                    onDragStop={(_, d) => setPanelProps((p) => ({ ...p, x: d.x, y: d.y }))}
                    onResizeStop={(_, __, ref, ___, position) => {
                        setPanelProps({
                            width: parseInt(ref.style.width, 10),
                            height: parseInt(ref.style.height, 10),
                            x: position.x,
                            y: position.y,
                        });
                    }}
                    style={{
                        zIndex: 1000,
                        background: "#ECEFF4",
                        border: "1px solid #CAD1D8",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div
                        className="seguir-handle"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "6px 12px",
                            background: "#D8E1E8",
                            cursor: "move",
                            borderTopLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                        }}
                    >
                        <button
                            onClick={() => {
                                setShowSeguirPanel(false);
                                setSearch("");
                                clearMarkers();
                                clearPolylines();
                                clearOverlay();
                                clearYellowCircle();
                                clearTrayectoLines();
                                clearArrowLines();
                            }}
                            style={{
                                border: "none",
                                background: "transparent",
                                fontSize: "1.2rem",
                                lineHeight: "1",
                                cursor: "pointer",
                                width: "24px",
                                height: "24px",
                                textAlign: "center",
                            }}
                            aria-label="Cerrar">
                            &times;
                        </button>
                    </div>

                    <div
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "12px",
                            borderBottomLeftRadius: "12px",
                            borderBottomRightRadius: "12px",
                            fontSize: "0.8rem",
                            lineHeight: "1.1",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {contratoSelected && (
                            <>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Nombre empresa:</strong> {contratoSelected.NombreEmpresa}
                                </p>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Placa:</strong> {contratoSelected.PlacaTruck}
                                </p>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Dispositivo:</strong> {contratoSelected.FKLokDeviceID}
                                </p>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Ult. geocerca:</strong> {contratoSelected.geocerca} ({contratoSelected.LastReportgeocerca} min)
                                </p>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Vel:</strong> {contratoSelected.Speed}
                                </p>
                                <p style={{ marginBottom: "10px" }}>
                                    <strong>Tiempo:</strong> {contratoSelected.Tiempo}
                                </p>

                                <IconGrid contrato={contratoSelected} changedIcons={changedIcons} />

                                {hasRefuerzos && (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            marginTop: "10px",
                                            fontWeight: 600,
                                            color: "#3b4a5a",
                                        }}>
                                        <SwitchButton3
                                            checked={showRefuerzosPanel}
                                            onChange={handleRefuerzosSwitch}
                                            type="Servicios asociados"
                                        />
                                    </div>
                                )}

                                <button
                                    type="button"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "10px",
                                        padding: "8px",
                                        backgroundColor: "#E0E7F1",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                    onClick={() => openInfoWindowForContrato(contratoSelected, { focusZoom: true })}>
                                    <FaInfoCircle size={20} color="#007bff" title="Ver más información del contrato" />
                                </button>

                                {showRefuerzosPanel && hasRefuerzos && (
                                    <div
                                        style={{
                                            marginTop: "10px",
                                            padding: "8px",
                                            background: "#F6F8FB",
                                            border: "1px solid #D6DEE7",
                                            borderRadius: "8px",
                                        }}>
                                        <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                                            Servicios ({refuerzosForSelected.length})
                                        </div>
                                        {refuerzosForSelected.map((c) => (
                                            <div key={c.ContractID} style={{ marginBottom: "6px" }}>
                                                <div><strong>Empresa:</strong> {c.NombreEmpresa}</div>
                                                <div><strong>Dispositivo:</strong> {c.FKLokDeviceID}</div>
                                                <div><strong>Contenedor:</strong> {c.ContainerNum || "-"}</div>
                                                <div><strong>Placa:</strong> {c.PlacaTruck}</div>
                                                <div><strong>Ult. geocerca:</strong> {c.geocerca} ({c.LastReportgeocerca} min)</div>
                                                <div><strong>Vel:</strong> {c.Speed}</div>
                                                <div><strong>Tiempo:</strong> {c.Tiempo}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </Rnd>
            )}
        </div>
    );
});

export default MapCenterModal;
